/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * FortifyID SaaS API — multi-tenant identity-verified change requests for AU businesses.
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AcceptConnectIdTermsBody,
  AcceptTermsBody,
  ActivateConnectIdEnvironment200,
  ActivateConnectIdEnvironmentBody,
  ActivityItem,
  BillingCheckoutInput,
  BillingRedirect,
  BrandPortalStatus,
  BrandPortalUnlockBody,
  Branding,
  BsbEntry,
  BulkReassignRequestsBody,
  BulkReassignRequestsResult,
  Comment,
  ComplianceCaseDetail,
  ComplianceCaseInput,
  ComplianceCaseNoteInput,
  ComplianceCaseRow,
  ComplianceCaseUpdateInput,
  ComplianceCustomerUpdateInput,
  ComplianceOverview,
  ComplianceRunbook,
  ComplianceRunbookHistoryEntry,
  ComplianceRunbookInput,
  ConnectIdConfigStatus,
  ConnectIdCsrPairInput,
  ConnectIdNomination,
  ConnectIdNominationEvidenceUploadRequest,
  ConnectIdNominationEvidenceUploadResponse,
  ConnectIdNominationRecord,
  ConnectIdNominationUpdate,
  ConnectIdParticipant,
  ConnectIdTestResult,
  CreateCommentBody,
  CreateDelegationBody,
  CreateEmailDomainBody,
  CreateOperatorAccessGrantBody,
  CreateRequestBody,
  CrmAiGenerateEmailBody,
  CrmCampaign,
  CrmCampaignDetail,
  CrmContact,
  CrmContactDetail,
  CrmContactEnrollmentRow,
  CrmCreateCampaignBody,
  CrmCreateNoteBody,
  CrmCreateSequenceBody,
  CrmCreateSequenceStepBody,
  CrmCreateTemplateBody,
  CrmEmailTemplate,
  CrmEnrollContactBody,
  CrmFlushSequenceScheduler200,
  CrmGetSegmentCount200,
  CrmGetSegmentCountParams,
  CrmGetSegmentPreview200,
  CrmGetSegmentPreviewParams,
  CrmGetSmsUnreadCount200,
  CrmListContactsParams,
  CrmListTemplatesParams,
  CrmNote,
  CrmPatchContactBody,
  CrmSendContactEmail200,
  CrmSendContactEmailBody,
  CrmSendTestCampaign200,
  CrmSendTestCampaignBody,
  CrmSequence,
  CrmSequenceDetail,
  CrmSequenceEnrollment,
  CrmSequenceStep,
  CrmTrialInviteBody,
  CrmUnsubscribeParams,
  CrmUpdateCampaignBody,
  CrmUpdateSequenceBody,
  CrmUpdateTemplateBody,
  CustomFormTemplate,
  CustomFormTemplateInput,
  DashboardSummary,
  DataRetentionScrubResult,
  DataRetentionStats,
  Delegation,
  DeleteSocialPostSchedule200,
  DemoAvailability,
  DemoBooking,
  DemoBookingInput,
  DemoBookingOrNone,
  DismissBillingPlanChangeNotice200,
  EligibleReviewer,
  EmailDomainCheckResult,
  ErasePiiConflictResponse,
  EraseSubjectPii200,
  EraseSubjectPiiBody,
  ErrorResponse,
  FeedbackItem,
  FraudReport,
  FraudReportInput,
  FraudReportStatusUpdate,
  GenerateConnectIdSigningKeyBody,
  GeneratedConnectIdCsrPair,
  GeneratedMtlsCsr,
  GeneratedSigningKey,
  GetConnectIdConfigParams,
  GetOpsFeedbackParams,
  GetRecentActivityParams,
  GetVerifyConnectIdParticipantsRaw200Item,
  GetWorkspaceActivityParams,
  GetWorkspaceAnalyticsParams,
  HealthStatus,
  InviteMembershipBody,
  InvoiceLines,
  ListCustomFormTemplatesParams,
  ListRequestsParams,
  LogPrivacyActRequestBody,
  MarketingContact,
  MarketingContactAck,
  MarketingContactInput,
  MeResponse,
  Membership,
  MtlsCsrInput,
  NoticeInput,
  NoticeUpdate,
  NotificationPrefs,
  OnboardingQuestion,
  OnboardingQuestionInput,
  Operator,
  OpsAuditLogRow,
  OpsCreateWorkspaceBody,
  OpsDeleteWorkspaceBody,
  OpsDemoBookingRow,
  OpsExtendGracePeriodBody,
  OpsExtendGracePeriodResponse,
  OpsFraudReportRow,
  OpsListAuditLogParams,
  OpsListComplianceCasesParams,
  OpsListDemosParams,
  OpsListFraudReportsParams,
  OpsListMarketingContactsParams,
  OpsListOnboardingQuestionsParams,
  OpsListWorkspacesParams,
  OpsNoticeRow,
  OpsOnboardingQuestionRow,
  OpsStats,
  OpsSuspendWorkspaceBody,
  OpsUpdateWorkspaceBody,
  OpsWorkspaceRow,
  OversightRow,
  PatchFeedbackBody,
  PatchIdVerificationSettingsBody,
  PatchMemberRequestVisibilityBody,
  PatchMemberReviewPermissionsBody,
  PatchMemberVerbalVerifyBody,
  PatchReminderSettingsBody,
  PatchRequestReminders200,
  PatchRequestRemindersBody,
  PatchVerbalVerificationSettingsBody,
  PatchVerifyLinkSettingsBody,
  PatchWorkspaceIdentityBody,
  PatchWorkspaceReviewPolicy200,
  PatchWorkspaceReviewPolicyBody,
  PostVerbalVerificationBody,
  PrivacyActRequestRow,
  ProptrackAddressSuggestParams,
  ProptrackAddressSuggestResponse,
  RegisterPushTokenBody,
  ReissueVerifyResponse,
  RemoveMembershipInvite200,
  RequestDetail,
  RequestSummary,
  ResendMembershipInvite200,
  ResendRequestBody,
  RevokeWorkspaceOperatorAccess200,
  RexConnectionStatus,
  RexContactResults,
  RexListingResults,
  RexSearchQuery,
  SaveRexBody,
  ScheduleSocialPostBody,
  SetupWizardAppliedConfig,
  SignupWorkspaceBody,
  SmsMessage,
  SmsOtpStartResponse,
  SmsOtpVerifyBody,
  SmsThread,
  SocialPostSchedule,
  StartIdBody,
  StartVerifyIdResponse,
  SubmitFeedbackBody,
  SubmitVerifyBody,
  TestConnectIdConfigBody,
  TrustIQPartialLeadInput,
  TwilioInboundSmsBody,
  UnauthorizedResponse,
  UpdateBrandingBody,
  UpdateCommunicationSettingsBody,
  UpdateConnectIdConfigBody,
  UpdateConnectIdNominationBody,
  UpdateNameBody,
  UpdateNotificationPrefsBody,
  UpdatePushNotifPrefsBody,
  UpdatePushNotificationPrefs200,
  UploadUrlRequest,
  UploadUrlResponse,
  VerifyAddressSuggestParams,
  VerifyContext,
  Workspace,
  WorkspaceAccessGrant,
  WorkspaceAccessGrantStatus,
  WorkspaceActivityItem,
  WorkspaceAnalytics,
  WorkspaceBilling,
  WorkspaceEmailDomain,
  WorkspaceExport,
  WorkspaceExportDownload,
  WorkspaceExportList,
  WorkspaceNotice,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary PropTrack address autocomplete — returns candidate Australian addresses for the given query. Requires Clerk session. Degrades gracefully when PropTrack is not configured.
 */
export const getProptrackAddressSuggestUrl = (
  params: ProptrackAddressSuggestParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/proptrack/address-suggest?${stringifiedParams}`
    : `/api/proptrack/address-suggest`;
};

export const proptrackAddressSuggest = async (
  params: ProptrackAddressSuggestParams,
  options?: RequestInit,
): Promise<ProptrackAddressSuggestResponse> => {
  return customFetch<ProptrackAddressSuggestResponse>(
    getProptrackAddressSuggestUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getProptrackAddressSuggestQueryKey = (
  params?: ProptrackAddressSuggestParams,
) => {
  return [
    `/api/proptrack/address-suggest`,
    ...(params ? [params] : []),
  ] as const;
};

export const getProptrackAddressSuggestQueryOptions = <
  TData = Awaited<ReturnType<typeof proptrackAddressSuggest>>,
  TError = ErrorType<ErrorResponse | UnauthorizedResponse | void>,
>(
  params: ProptrackAddressSuggestParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof proptrackAddressSuggest>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getProptrackAddressSuggestQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof proptrackAddressSuggest>>
  > = ({ signal }) =>
    proptrackAddressSuggest(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof proptrackAddressSuggest>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ProptrackAddressSuggestQueryResult = NonNullable<
  Awaited<ReturnType<typeof proptrackAddressSuggest>>
>;
export type ProptrackAddressSuggestQueryError = ErrorType<
  ErrorResponse | UnauthorizedResponse | void
>;

/**
 * @summary PropTrack address autocomplete — returns candidate Australian addresses for the given query. Requires Clerk session. Degrades gracefully when PropTrack is not configured.
 */

export function useProptrackAddressSuggest<
  TData = Awaited<ReturnType<typeof proptrackAddressSuggest>>,
  TError = ErrorType<ErrorResponse | UnauthorizedResponse | void>,
>(
  params: ProptrackAddressSuggestParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof proptrackAddressSuggest>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getProptrackAddressSuggestQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary PropTrack address autocomplete for public verify surface. Authenticated by verify token (no Clerk required). Degrades gracefully when PropTrack is not configured.
 */
export const getVerifyAddressSuggestUrl = (
  slug: string,
  token: string,
  params: VerifyAddressSuggestParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/verify/${slug}/${token}/address-suggest?${stringifiedParams}`
    : `/api/verify/${slug}/${token}/address-suggest`;
};

export const verifyAddressSuggest = async (
  slug: string,
  token: string,
  params: VerifyAddressSuggestParams,
  options?: RequestInit,
): Promise<ProptrackAddressSuggestResponse> => {
  return customFetch<ProptrackAddressSuggestResponse>(
    getVerifyAddressSuggestUrl(slug, token, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getVerifyAddressSuggestQueryKey = (
  slug: string,
  token: string,
  params?: VerifyAddressSuggestParams,
) => {
  return [
    `/api/verify/${slug}/${token}/address-suggest`,
    ...(params ? [params] : []),
  ] as const;
};

export const getVerifyAddressSuggestQueryOptions = <
  TData = Awaited<ReturnType<typeof verifyAddressSuggest>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  token: string,
  params: VerifyAddressSuggestParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof verifyAddressSuggest>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getVerifyAddressSuggestQueryKey(slug, token, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof verifyAddressSuggest>>
  > = ({ signal }) =>
    verifyAddressSuggest(slug, token, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(slug && token),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof verifyAddressSuggest>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type VerifyAddressSuggestQueryResult = NonNullable<
  Awaited<ReturnType<typeof verifyAddressSuggest>>
>;
export type VerifyAddressSuggestQueryError = ErrorType<ErrorResponse>;

/**
 * @summary PropTrack address autocomplete for public verify surface. Authenticated by verify token (no Clerk required). Degrades gracefully when PropTrack is not configured.
 */

export function useVerifyAddressSuggest<
  TData = Awaited<ReturnType<typeof verifyAddressSuggest>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  token: string,
  params: VerifyAddressSuggestParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof verifyAddressSuggest>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getVerifyAddressSuggestQueryOptions(
    slug,
    token,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<HealthStatus>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<HealthStatus>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<HealthStatus>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Current user, memberships, and operator flag (JIT-provisions local user from Clerk).
 */
export const getGetMeUrl = () => {
  return `/api/me`;
};

export const getMe = async (options?: RequestInit): Promise<MeResponse> => {
  return customFetch<MeResponse>(getGetMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMeQueryKey = () => {
  return [`/api/me`] as const;
};

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({
    signal,
  }) => getMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Current user, memberships, and operator flag (JIT-provisions local user from Clerk).
 */

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Record that the current user has accepted a given version of the Terms of Service and DPA.
 */
export const getAcceptTermsUrl = () => {
  return `/api/me/accept-terms`;
};

export const acceptTerms = async (
  acceptTermsBody: AcceptTermsBody,
  options?: RequestInit,
): Promise<MeResponse> => {
  return customFetch<MeResponse>(getAcceptTermsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(acceptTermsBody),
  });
};

export const getAcceptTermsMutationOptions = <
  TError = ErrorType<ErrorResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptTerms>>,
    TError,
    { data: BodyType<AcceptTermsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptTerms>>,
  TError,
  { data: BodyType<AcceptTermsBody> },
  TContext
> => {
  const mutationKey = ["acceptTerms"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptTerms>>,
    { data: BodyType<AcceptTermsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return acceptTerms(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptTermsMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptTerms>>
>;
export type AcceptTermsMutationBody = BodyType<AcceptTermsBody>;
export type AcceptTermsMutationError = ErrorType<
  ErrorResponse | UnauthorizedResponse
>;

/**
 * @summary Record that the current user has accepted a given version of the Terms of Service and DPA.
 */
export const useAcceptTerms = <
  TError = ErrorType<ErrorResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptTerms>>,
    TError,
    { data: BodyType<AcceptTermsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acceptTerms>>,
  TError,
  { data: BodyType<AcceptTermsBody> },
  TContext
> => {
  return useMutation(getAcceptTermsMutationOptions(options));
};

/**
 * @summary Update the current user's push notification preferences. Unset keys default to opted-in (true).
 */
export const getUpdatePushNotificationPrefsUrl = () => {
  return `/api/me/push-notification-prefs`;
};

export const updatePushNotificationPrefs = async (
  updatePushNotifPrefsBody: UpdatePushNotifPrefsBody,
  options?: RequestInit,
): Promise<UpdatePushNotificationPrefs200> => {
  return customFetch<UpdatePushNotificationPrefs200>(
    getUpdatePushNotificationPrefsUrl(),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updatePushNotifPrefsBody),
    },
  );
};

export const getUpdatePushNotificationPrefsMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePushNotificationPrefs>>,
    TError,
    { data: BodyType<UpdatePushNotifPrefsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePushNotificationPrefs>>,
  TError,
  { data: BodyType<UpdatePushNotifPrefsBody> },
  TContext
> => {
  const mutationKey = ["updatePushNotificationPrefs"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePushNotificationPrefs>>,
    { data: BodyType<UpdatePushNotifPrefsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updatePushNotificationPrefs(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePushNotificationPrefsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePushNotificationPrefs>>
>;
export type UpdatePushNotificationPrefsMutationBody =
  BodyType<UpdatePushNotifPrefsBody>;
export type UpdatePushNotificationPrefsMutationError =
  ErrorType<UnauthorizedResponse>;

/**
 * @summary Update the current user's push notification preferences. Unset keys default to opted-in (true).
 */
export const useUpdatePushNotificationPrefs = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePushNotificationPrefs>>,
    TError,
    { data: BodyType<UpdatePushNotifPrefsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePushNotificationPrefs>>,
  TError,
  { data: BodyType<UpdatePushNotifPrefsBody> },
  TContext
> => {
  return useMutation(getUpdatePushNotificationPrefsMutationOptions(options));
};

/**
 * @summary Update the current user's first and last name via the Clerk Admin API.
 */
export const getUpdateMyNameUrl = () => {
  return `/api/me/name`;
};

export const updateMyName = async (
  updateNameBody: UpdateNameBody,
  options?: RequestInit,
): Promise<MeResponse> => {
  return customFetch<MeResponse>(getUpdateMyNameUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateNameBody),
  });
};

export const getUpdateMyNameMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyName>>,
    TError,
    { data: BodyType<UpdateNameBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyName>>,
  TError,
  { data: BodyType<UpdateNameBody> },
  TContext
> => {
  const mutationKey = ["updateMyName"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyName>>,
    { data: BodyType<UpdateNameBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateMyName(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMyNameMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMyName>>
>;
export type UpdateMyNameMutationBody = BodyType<UpdateNameBody>;
export type UpdateMyNameMutationError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Update the current user's first and last name via the Clerk Admin API.
 */
export const useUpdateMyName = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyName>>,
    TError,
    { data: BodyType<UpdateNameBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMyName>>,
  TError,
  { data: BodyType<UpdateNameBody> },
  TContext
> => {
  return useMutation(getUpdateMyNameMutationOptions(options));
};

/**
 * @summary Record that the current user has accepted a given version of the ConnectID Minimum Customer Terms for every workspace they administer.
 */
export const getAcceptConnectIdTermsUrl = () => {
  return `/api/me/accept-connectid-terms`;
};

export const acceptConnectIdTerms = async (
  acceptConnectIdTermsBody: AcceptConnectIdTermsBody,
  options?: RequestInit,
): Promise<MeResponse> => {
  return customFetch<MeResponse>(getAcceptConnectIdTermsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(acceptConnectIdTermsBody),
  });
};

export const getAcceptConnectIdTermsMutationOptions = <
  TError = ErrorType<ErrorResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptConnectIdTerms>>,
    TError,
    { data: BodyType<AcceptConnectIdTermsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptConnectIdTerms>>,
  TError,
  { data: BodyType<AcceptConnectIdTermsBody> },
  TContext
> => {
  const mutationKey = ["acceptConnectIdTerms"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptConnectIdTerms>>,
    { data: BodyType<AcceptConnectIdTermsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return acceptConnectIdTerms(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptConnectIdTermsMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptConnectIdTerms>>
>;
export type AcceptConnectIdTermsMutationBody =
  BodyType<AcceptConnectIdTermsBody>;
export type AcceptConnectIdTermsMutationError = ErrorType<
  ErrorResponse | UnauthorizedResponse
>;

/**
 * @summary Record that the current user has accepted a given version of the ConnectID Minimum Customer Terms for every workspace they administer.
 */
export const useAcceptConnectIdTerms = <
  TError = ErrorType<ErrorResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptConnectIdTerms>>,
    TError,
    { data: BodyType<AcceptConnectIdTermsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acceptConnectIdTerms>>,
  TError,
  { data: BodyType<AcceptConnectIdTermsBody> },
  TContext
> => {
  return useMutation(getAcceptConnectIdTermsMutationOptions(options));
};

/**
 * @summary Register or refresh an Expo push token for the current user.
 */
export const getRegisterPushTokenUrl = () => {
  return `/api/devices/push-token`;
};

export const registerPushToken = async (
  registerPushTokenBody: RegisterPushTokenBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getRegisterPushTokenUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(registerPushTokenBody),
  });
};

export const getRegisterPushTokenMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerPushToken>>,
    TError,
    { data: BodyType<RegisterPushTokenBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerPushToken>>,
  TError,
  { data: BodyType<RegisterPushTokenBody> },
  TContext
> => {
  const mutationKey = ["registerPushToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerPushToken>>,
    { data: BodyType<RegisterPushTokenBody> }
  > = (props) => {
    const { data } = props ?? {};

    return registerPushToken(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterPushTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerPushToken>>
>;
export type RegisterPushTokenMutationBody = BodyType<RegisterPushTokenBody>;
export type RegisterPushTokenMutationError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Register or refresh an Expo push token for the current user.
 */
export const useRegisterPushToken = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerPushToken>>,
    TError,
    { data: BodyType<RegisterPushTokenBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof registerPushToken>>,
  TError,
  { data: BodyType<RegisterPushTokenBody> },
  TContext
> => {
  return useMutation(getRegisterPushTokenMutationOptions(options));
};

/**
 * Used during onboarding to surface a soft warning when a business-domain email matches an existing workspace, suggesting the user may have been meant to receive an invite rather than create a new workspace. Personal/consumer domains (gmail.com, hotmail.com, etc.) are excluded from the check and will always return found=false, personal=true.

 * @summary Check whether the authenticated user's email domain is already associated with an active FortifyID workspace.
 */
export const getCheckEmailDomainUrl = () => {
  return `/api/workspaces/check-email-domain`;
};

export const checkEmailDomain = async (
  options?: RequestInit,
): Promise<EmailDomainCheckResult> => {
  return customFetch<EmailDomainCheckResult>(getCheckEmailDomainUrl(), {
    ...options,
    method: "GET",
  });
};

export const getCheckEmailDomainQueryKey = () => {
  return [`/api/workspaces/check-email-domain`] as const;
};

export const getCheckEmailDomainQueryOptions = <
  TData = Awaited<ReturnType<typeof checkEmailDomain>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof checkEmailDomain>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCheckEmailDomainQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof checkEmailDomain>>
  > = ({ signal }) => checkEmailDomain({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof checkEmailDomain>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CheckEmailDomainQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkEmailDomain>>
>;
export type CheckEmailDomainQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Check whether the authenticated user's email domain is already associated with an active FortifyID workspace.
 */

export function useCheckEmailDomain<
  TData = Awaited<ReturnType<typeof checkEmailDomain>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof checkEmailDomain>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCheckEmailDomainQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a pending workspace for the authenticated user (becomes admin on approval).
 */
export const getSignupWorkspaceUrl = () => {
  return `/api/workspaces/signup`;
};

export const signupWorkspace = async (
  signupWorkspaceBody: SignupWorkspaceBody,
  options?: RequestInit,
): Promise<Workspace> => {
  return customFetch<Workspace>(getSignupWorkspaceUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(signupWorkspaceBody),
  });
};

export const getSignupWorkspaceMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signupWorkspace>>,
    TError,
    { data: BodyType<SignupWorkspaceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signupWorkspace>>,
  TError,
  { data: BodyType<SignupWorkspaceBody> },
  TContext
> => {
  const mutationKey = ["signupWorkspace"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signupWorkspace>>,
    { data: BodyType<SignupWorkspaceBody> }
  > = (props) => {
    const { data } = props ?? {};

    return signupWorkspace(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignupWorkspaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof signupWorkspace>>
>;
export type SignupWorkspaceMutationBody = BodyType<SignupWorkspaceBody>;
export type SignupWorkspaceMutationError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Create a pending workspace for the authenticated user (becomes admin on approval).
 */
export const useSignupWorkspace = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signupWorkspace>>,
    TError,
    { data: BodyType<SignupWorkspaceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof signupWorkspace>>,
  TError,
  { data: BodyType<SignupWorkspaceBody> },
  TContext
> => {
  return useMutation(getSignupWorkspaceMutationOptions(options));
};

export const getGetWorkspaceUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}`;
};

export const getWorkspace = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<Workspace> => {
  return customFetch<Workspace>(getGetWorkspaceUrl(workspaceId), {
    ...options,
    method: "GET",
  });
};

export const getGetWorkspaceQueryKey = (workspaceId: string) => {
  return [`/api/workspaces/${workspaceId}`] as const;
};

export const getGetWorkspaceQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkspace>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspace>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWorkspaceQueryKey(workspaceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspace>>> = ({
    signal,
  }) => getWorkspace(workspaceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspace>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWorkspaceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkspace>>
>;
export type GetWorkspaceQueryError = ErrorType<unknown>;

export function useGetWorkspace<
  TData = Awaited<ReturnType<typeof getWorkspace>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspace>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWorkspaceQueryOptions(workspaceId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update core workspace identity fields (name, industry, ABN, office address, sender identity). Admin only.
 */
export const getPatchWorkspaceIdentityUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/identity`;
};

export const patchWorkspaceIdentity = async (
  workspaceId: string,
  patchWorkspaceIdentityBody: PatchWorkspaceIdentityBody,
  options?: RequestInit,
): Promise<Workspace> => {
  return customFetch<Workspace>(getPatchWorkspaceIdentityUrl(workspaceId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(patchWorkspaceIdentityBody),
  });
};

export const getPatchWorkspaceIdentityMutationOptions = <
  TError = ErrorType<ErrorResponse | UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchWorkspaceIdentity>>,
    TError,
    { workspaceId: string; data: BodyType<PatchWorkspaceIdentityBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchWorkspaceIdentity>>,
  TError,
  { workspaceId: string; data: BodyType<PatchWorkspaceIdentityBody> },
  TContext
> => {
  const mutationKey = ["patchWorkspaceIdentity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchWorkspaceIdentity>>,
    { workspaceId: string; data: BodyType<PatchWorkspaceIdentityBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return patchWorkspaceIdentity(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchWorkspaceIdentityMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchWorkspaceIdentity>>
>;
export type PatchWorkspaceIdentityMutationBody =
  BodyType<PatchWorkspaceIdentityBody>;
export type PatchWorkspaceIdentityMutationError = ErrorType<
  ErrorResponse | UnauthorizedResponse | void
>;

/**
 * @summary Update core workspace identity fields (name, industry, ABN, office address, sender identity). Admin only.
 */
export const usePatchWorkspaceIdentity = <
  TError = ErrorType<ErrorResponse | UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchWorkspaceIdentity>>,
    TError,
    { workspaceId: string; data: BodyType<PatchWorkspaceIdentityBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchWorkspaceIdentity>>,
  TError,
  { workspaceId: string; data: BodyType<PatchWorkspaceIdentityBody> },
  TContext
> => {
  return useMutation(getPatchWorkspaceIdentityMutationOptions(options));
};

/**
 * @summary Update sender name and reply-to email for outbound request emails.
 */
export const getUpdateCommunicationSettingsUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/communication-settings`;
};

export const updateCommunicationSettings = async (
  workspaceId: string,
  updateCommunicationSettingsBody: UpdateCommunicationSettingsBody,
  options?: RequestInit,
): Promise<Workspace> => {
  return customFetch<Workspace>(
    getUpdateCommunicationSettingsUrl(workspaceId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateCommunicationSettingsBody),
    },
  );
};

export const getUpdateCommunicationSettingsMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCommunicationSettings>>,
    TError,
    { workspaceId: string; data: BodyType<UpdateCommunicationSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCommunicationSettings>>,
  TError,
  { workspaceId: string; data: BodyType<UpdateCommunicationSettingsBody> },
  TContext
> => {
  const mutationKey = ["updateCommunicationSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCommunicationSettings>>,
    { workspaceId: string; data: BodyType<UpdateCommunicationSettingsBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return updateCommunicationSettings(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCommunicationSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCommunicationSettings>>
>;
export type UpdateCommunicationSettingsMutationBody =
  BodyType<UpdateCommunicationSettingsBody>;
export type UpdateCommunicationSettingsMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Update sender name and reply-to email for outbound request emails.
 */
export const useUpdateCommunicationSettings = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCommunicationSettings>>,
    TError,
    { workspaceId: string; data: BodyType<UpdateCommunicationSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCommunicationSettings>>,
  TError,
  { workspaceId: string; data: BodyType<UpdateCommunicationSettingsBody> },
  TContext
> => {
  return useMutation(getUpdateCommunicationSettingsMutationOptions(options));
};

/**
 * @summary Update per-type identity verification mode matrix for a workspace (admin only).
 */
export const getPatchIdVerificationSettingsUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/id-verification-settings`;
};

export const patchIdVerificationSettings = async (
  workspaceId: string,
  patchIdVerificationSettingsBody: PatchIdVerificationSettingsBody,
  options?: RequestInit,
): Promise<Workspace> => {
  return customFetch<Workspace>(
    getPatchIdVerificationSettingsUrl(workspaceId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(patchIdVerificationSettingsBody),
    },
  );
};

export const getPatchIdVerificationSettingsMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchIdVerificationSettings>>,
    TError,
    { workspaceId: string; data: BodyType<PatchIdVerificationSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchIdVerificationSettings>>,
  TError,
  { workspaceId: string; data: BodyType<PatchIdVerificationSettingsBody> },
  TContext
> => {
  const mutationKey = ["patchIdVerificationSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchIdVerificationSettings>>,
    { workspaceId: string; data: BodyType<PatchIdVerificationSettingsBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return patchIdVerificationSettings(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchIdVerificationSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchIdVerificationSettings>>
>;
export type PatchIdVerificationSettingsMutationBody =
  BodyType<PatchIdVerificationSettingsBody>;
export type PatchIdVerificationSettingsMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Update per-type identity verification mode matrix for a workspace (admin only).
 */
export const usePatchIdVerificationSettings = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchIdVerificationSettings>>,
    TError,
    { workspaceId: string; data: BodyType<PatchIdVerificationSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchIdVerificationSettings>>,
  TError,
  { workspaceId: string; data: BodyType<PatchIdVerificationSettingsBody> },
  TContext
> => {
  return useMutation(getPatchIdVerificationSettingsMutationOptions(options));
};

/**
 * @summary Update verbal verification settings for a workspace (admin only).
 */
export const getPatchVerbalVerificationSettingsUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/verbal-verification-settings`;
};

export const patchVerbalVerificationSettings = async (
  workspaceId: string,
  patchVerbalVerificationSettingsBody: PatchVerbalVerificationSettingsBody,
  options?: RequestInit,
): Promise<Workspace> => {
  return customFetch<Workspace>(
    getPatchVerbalVerificationSettingsUrl(workspaceId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(patchVerbalVerificationSettingsBody),
    },
  );
};

export const getPatchVerbalVerificationSettingsMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchVerbalVerificationSettings>>,
    TError,
    {
      workspaceId: string;
      data: BodyType<PatchVerbalVerificationSettingsBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchVerbalVerificationSettings>>,
  TError,
  { workspaceId: string; data: BodyType<PatchVerbalVerificationSettingsBody> },
  TContext
> => {
  const mutationKey = ["patchVerbalVerificationSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchVerbalVerificationSettings>>,
    { workspaceId: string; data: BodyType<PatchVerbalVerificationSettingsBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return patchVerbalVerificationSettings(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchVerbalVerificationSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchVerbalVerificationSettings>>
>;
export type PatchVerbalVerificationSettingsMutationBody =
  BodyType<PatchVerbalVerificationSettingsBody>;
export type PatchVerbalVerificationSettingsMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Update verbal verification settings for a workspace (admin only).
 */
export const usePatchVerbalVerificationSettings = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchVerbalVerificationSettings>>,
    TError,
    {
      workspaceId: string;
      data: BodyType<PatchVerbalVerificationSettingsBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchVerbalVerificationSettings>>,
  TError,
  { workspaceId: string; data: BodyType<PatchVerbalVerificationSettingsBody> },
  TContext
> => {
  return useMutation(
    getPatchVerbalVerificationSettingsMutationOptions(options),
  );
};

/**
 * @summary Update automated reminder settings for a workspace (admin only).
 */
export const getPatchReminderSettingsUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/reminder-settings`;
};

export const patchReminderSettings = async (
  workspaceId: string,
  patchReminderSettingsBody: PatchReminderSettingsBody,
  options?: RequestInit,
): Promise<Workspace> => {
  return customFetch<Workspace>(getPatchReminderSettingsUrl(workspaceId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(patchReminderSettingsBody),
  });
};

export const getPatchReminderSettingsMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchReminderSettings>>,
    TError,
    { workspaceId: string; data: BodyType<PatchReminderSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchReminderSettings>>,
  TError,
  { workspaceId: string; data: BodyType<PatchReminderSettingsBody> },
  TContext
> => {
  const mutationKey = ["patchReminderSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchReminderSettings>>,
    { workspaceId: string; data: BodyType<PatchReminderSettingsBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return patchReminderSettings(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchReminderSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchReminderSettings>>
>;
export type PatchReminderSettingsMutationBody =
  BodyType<PatchReminderSettingsBody>;
export type PatchReminderSettingsMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Update automated reminder settings for a workspace (admin only).
 */
export const usePatchReminderSettings = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchReminderSettings>>,
    TError,
    { workspaceId: string; data: BodyType<PatchReminderSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchReminderSettings>>,
  TError,
  { workspaceId: string; data: BodyType<PatchReminderSettingsBody> },
  TContext
> => {
  return useMutation(getPatchReminderSettingsMutationOptions(options));
};

/**
 * @summary Update verification link settings for a workspace (admin only).
 */
export const getPatchVerifyLinkSettingsUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/verify-link-settings`;
};

export const patchVerifyLinkSettings = async (
  workspaceId: string,
  patchVerifyLinkSettingsBody: PatchVerifyLinkSettingsBody,
  options?: RequestInit,
): Promise<Workspace> => {
  return customFetch<Workspace>(getPatchVerifyLinkSettingsUrl(workspaceId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(patchVerifyLinkSettingsBody),
  });
};

export const getPatchVerifyLinkSettingsMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchVerifyLinkSettings>>,
    TError,
    { workspaceId: string; data: BodyType<PatchVerifyLinkSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchVerifyLinkSettings>>,
  TError,
  { workspaceId: string; data: BodyType<PatchVerifyLinkSettingsBody> },
  TContext
> => {
  const mutationKey = ["patchVerifyLinkSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchVerifyLinkSettings>>,
    { workspaceId: string; data: BodyType<PatchVerifyLinkSettingsBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return patchVerifyLinkSettings(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchVerifyLinkSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchVerifyLinkSettings>>
>;
export type PatchVerifyLinkSettingsMutationBody =
  BodyType<PatchVerifyLinkSettingsBody>;
export type PatchVerifyLinkSettingsMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Update verification link settings for a workspace (admin only).
 */
export const usePatchVerifyLinkSettings = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchVerifyLinkSettings>>,
    TError,
    { workspaceId: string; data: BodyType<PatchVerifyLinkSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchVerifyLinkSettings>>,
  TError,
  { workspaceId: string; data: BodyType<PatchVerifyLinkSettingsBody> },
  TContext
> => {
  return useMutation(getPatchVerifyLinkSettingsMutationOptions(options));
};

/**
 * @summary Enable or disable automated reminders for a single request.
 */
export const getPatchRequestRemindersUrl = (
  workspaceId: string,
  requestId: string,
) => {
  return `/api/workspaces/${workspaceId}/requests/${requestId}/reminders`;
};

export const patchRequestReminders = async (
  workspaceId: string,
  requestId: string,
  patchRequestRemindersBody: PatchRequestRemindersBody,
  options?: RequestInit,
): Promise<PatchRequestReminders200> => {
  return customFetch<PatchRequestReminders200>(
    getPatchRequestRemindersUrl(workspaceId, requestId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(patchRequestRemindersBody),
    },
  );
};

export const getPatchRequestRemindersMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchRequestReminders>>,
    TError,
    {
      workspaceId: string;
      requestId: string;
      data: BodyType<PatchRequestRemindersBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchRequestReminders>>,
  TError,
  {
    workspaceId: string;
    requestId: string;
    data: BodyType<PatchRequestRemindersBody>;
  },
  TContext
> => {
  const mutationKey = ["patchRequestReminders"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchRequestReminders>>,
    {
      workspaceId: string;
      requestId: string;
      data: BodyType<PatchRequestRemindersBody>;
    }
  > = (props) => {
    const { workspaceId, requestId, data } = props ?? {};

    return patchRequestReminders(workspaceId, requestId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchRequestRemindersMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchRequestReminders>>
>;
export type PatchRequestRemindersMutationBody =
  BodyType<PatchRequestRemindersBody>;
export type PatchRequestRemindersMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Enable or disable automated reminders for a single request.
 */
export const usePatchRequestReminders = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchRequestReminders>>,
    TError,
    {
      workspaceId: string;
      requestId: string;
      data: BodyType<PatchRequestRemindersBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchRequestReminders>>,
  TError,
  {
    workspaceId: string;
    requestId: string;
    data: BodyType<PatchRequestRemindersBody>;
  },
  TContext
> => {
  return useMutation(getPatchRequestRemindersMutationOptions(options));
};

/**
 * @summary Set the canVerbalVerify flag for a specific team member (admin only).
 */
export const getPatchMemberVerbalVerifyPermissionUrl = (
  workspaceId: string,
  membershipId: string,
) => {
  return `/api/workspaces/${workspaceId}/memberships/${membershipId}/verbal-verify-permission`;
};

export const patchMemberVerbalVerifyPermission = async (
  workspaceId: string,
  membershipId: string,
  patchMemberVerbalVerifyBody: PatchMemberVerbalVerifyBody,
  options?: RequestInit,
): Promise<Membership> => {
  return customFetch<Membership>(
    getPatchMemberVerbalVerifyPermissionUrl(workspaceId, membershipId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(patchMemberVerbalVerifyBody),
    },
  );
};

export const getPatchMemberVerbalVerifyPermissionMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMemberVerbalVerifyPermission>>,
    TError,
    {
      workspaceId: string;
      membershipId: string;
      data: BodyType<PatchMemberVerbalVerifyBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMemberVerbalVerifyPermission>>,
  TError,
  {
    workspaceId: string;
    membershipId: string;
    data: BodyType<PatchMemberVerbalVerifyBody>;
  },
  TContext
> => {
  const mutationKey = ["patchMemberVerbalVerifyPermission"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMemberVerbalVerifyPermission>>,
    {
      workspaceId: string;
      membershipId: string;
      data: BodyType<PatchMemberVerbalVerifyBody>;
    }
  > = (props) => {
    const { workspaceId, membershipId, data } = props ?? {};

    return patchMemberVerbalVerifyPermission(
      workspaceId,
      membershipId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMemberVerbalVerifyPermissionMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMemberVerbalVerifyPermission>>
>;
export type PatchMemberVerbalVerifyPermissionMutationBody =
  BodyType<PatchMemberVerbalVerifyBody>;
export type PatchMemberVerbalVerifyPermissionMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Set the canVerbalVerify flag for a specific team member (admin only).
 */
export const usePatchMemberVerbalVerifyPermission = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMemberVerbalVerifyPermission>>,
    TError,
    {
      workspaceId: string;
      membershipId: string;
      data: BodyType<PatchMemberVerbalVerifyBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchMemberVerbalVerifyPermission>>,
  TError,
  {
    workspaceId: string;
    membershipId: string;
    data: BodyType<PatchMemberVerbalVerifyBody>;
  },
  TContext
> => {
  return useMutation(
    getPatchMemberVerbalVerifyPermissionMutationOptions(options),
  );
};

/**
 * @summary Set the requestVisibility scope for a specific team member (admin only).
 */
export const getPatchMemberRequestVisibilityUrl = (
  workspaceId: string,
  membershipId: string,
) => {
  return `/api/workspaces/${workspaceId}/memberships/${membershipId}/request-visibility`;
};

export const patchMemberRequestVisibility = async (
  workspaceId: string,
  membershipId: string,
  patchMemberRequestVisibilityBody: PatchMemberRequestVisibilityBody,
  options?: RequestInit,
): Promise<Membership> => {
  return customFetch<Membership>(
    getPatchMemberRequestVisibilityUrl(workspaceId, membershipId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(patchMemberRequestVisibilityBody),
    },
  );
};

export const getPatchMemberRequestVisibilityMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMemberRequestVisibility>>,
    TError,
    {
      workspaceId: string;
      membershipId: string;
      data: BodyType<PatchMemberRequestVisibilityBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMemberRequestVisibility>>,
  TError,
  {
    workspaceId: string;
    membershipId: string;
    data: BodyType<PatchMemberRequestVisibilityBody>;
  },
  TContext
> => {
  const mutationKey = ["patchMemberRequestVisibility"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMemberRequestVisibility>>,
    {
      workspaceId: string;
      membershipId: string;
      data: BodyType<PatchMemberRequestVisibilityBody>;
    }
  > = (props) => {
    const { workspaceId, membershipId, data } = props ?? {};

    return patchMemberRequestVisibility(
      workspaceId,
      membershipId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMemberRequestVisibilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMemberRequestVisibility>>
>;
export type PatchMemberRequestVisibilityMutationBody =
  BodyType<PatchMemberRequestVisibilityBody>;
export type PatchMemberRequestVisibilityMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Set the requestVisibility scope for a specific team member (admin only).
 */
export const usePatchMemberRequestVisibility = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMemberRequestVisibility>>,
    TError,
    {
      workspaceId: string;
      membershipId: string;
      data: BodyType<PatchMemberRequestVisibilityBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchMemberRequestVisibility>>,
  TError,
  {
    workspaceId: string;
    membershipId: string;
    data: BodyType<PatchMemberRequestVisibilityBody>;
  },
  TContext
> => {
  return useMutation(getPatchMemberRequestVisibilityMutationOptions(options));
};

/**
 * @summary Set per-request-type Review/Complete permissions for a team member (admin only).
 */
export const getPatchMemberReviewPermissionsUrl = (
  workspaceId: string,
  membershipId: string,
) => {
  return `/api/workspaces/${workspaceId}/memberships/${membershipId}/review-permissions`;
};

export const patchMemberReviewPermissions = async (
  workspaceId: string,
  membershipId: string,
  patchMemberReviewPermissionsBody: PatchMemberReviewPermissionsBody,
  options?: RequestInit,
): Promise<Membership> => {
  return customFetch<Membership>(
    getPatchMemberReviewPermissionsUrl(workspaceId, membershipId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(patchMemberReviewPermissionsBody),
    },
  );
};

export const getPatchMemberReviewPermissionsMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMemberReviewPermissions>>,
    TError,
    {
      workspaceId: string;
      membershipId: string;
      data: BodyType<PatchMemberReviewPermissionsBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMemberReviewPermissions>>,
  TError,
  {
    workspaceId: string;
    membershipId: string;
    data: BodyType<PatchMemberReviewPermissionsBody>;
  },
  TContext
> => {
  const mutationKey = ["patchMemberReviewPermissions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMemberReviewPermissions>>,
    {
      workspaceId: string;
      membershipId: string;
      data: BodyType<PatchMemberReviewPermissionsBody>;
    }
  > = (props) => {
    const { workspaceId, membershipId, data } = props ?? {};

    return patchMemberReviewPermissions(
      workspaceId,
      membershipId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMemberReviewPermissionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMemberReviewPermissions>>
>;
export type PatchMemberReviewPermissionsMutationBody =
  BodyType<PatchMemberReviewPermissionsBody>;
export type PatchMemberReviewPermissionsMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Set per-request-type Review/Complete permissions for a team member (admin only).
 */
export const usePatchMemberReviewPermissions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMemberReviewPermissions>>,
    TError,
    {
      workspaceId: string;
      membershipId: string;
      data: BodyType<PatchMemberReviewPermissionsBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchMemberReviewPermissions>>,
  TError,
  {
    workspaceId: string;
    membershipId: string;
    data: BodyType<PatchMemberReviewPermissionsBody>;
  },
  TContext
> => {
  return useMutation(getPatchMemberReviewPermissionsMutationOptions(options));
};

/**
 * @summary Update the workspace review policy (self-review protection and segregation-of-duties enforcement). Admin only; changes are audit-logged.
 */
export const getPatchWorkspaceReviewPolicyUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/review-policy`;
};

export const patchWorkspaceReviewPolicy = async (
  workspaceId: string,
  patchWorkspaceReviewPolicyBody: PatchWorkspaceReviewPolicyBody,
  options?: RequestInit,
): Promise<PatchWorkspaceReviewPolicy200> => {
  return customFetch<PatchWorkspaceReviewPolicy200>(
    getPatchWorkspaceReviewPolicyUrl(workspaceId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(patchWorkspaceReviewPolicyBody),
    },
  );
};

export const getPatchWorkspaceReviewPolicyMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchWorkspaceReviewPolicy>>,
    TError,
    { workspaceId: string; data: BodyType<PatchWorkspaceReviewPolicyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchWorkspaceReviewPolicy>>,
  TError,
  { workspaceId: string; data: BodyType<PatchWorkspaceReviewPolicyBody> },
  TContext
> => {
  const mutationKey = ["patchWorkspaceReviewPolicy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchWorkspaceReviewPolicy>>,
    { workspaceId: string; data: BodyType<PatchWorkspaceReviewPolicyBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return patchWorkspaceReviewPolicy(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchWorkspaceReviewPolicyMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchWorkspaceReviewPolicy>>
>;
export type PatchWorkspaceReviewPolicyMutationBody =
  BodyType<PatchWorkspaceReviewPolicyBody>;
export type PatchWorkspaceReviewPolicyMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Update the workspace review policy (self-review protection and segregation-of-duties enforcement). Admin only; changes are audit-logged.
 */
export const usePatchWorkspaceReviewPolicy = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchWorkspaceReviewPolicy>>,
    TError,
    { workspaceId: string; data: BodyType<PatchWorkspaceReviewPolicyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchWorkspaceReviewPolicy>>,
  TError,
  { workspaceId: string; data: BodyType<PatchWorkspaceReviewPolicyBody> },
  TContext
> => {
  return useMutation(getPatchWorkspaceReviewPolicyMutationOptions(options));
};

/**
 * @summary List review-permission delegations for this workspace.
 */
export const getListDelegationsUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/delegations`;
};

export const listDelegations = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<Delegation[]> => {
  return customFetch<Delegation[]>(getListDelegationsUrl(workspaceId), {
    ...options,
    method: "GET",
  });
};

export const getListDelegationsQueryKey = (workspaceId: string) => {
  return [`/api/workspaces/${workspaceId}/delegations`] as const;
};

export const getListDelegationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listDelegations>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listDelegations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListDelegationsQueryKey(workspaceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDelegations>>> = ({
    signal,
  }) => listDelegations(workspaceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listDelegations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDelegationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDelegations>>
>;
export type ListDelegationsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List review-permission delegations for this workspace.
 */

export function useListDelegations<
  TData = Awaited<ReturnType<typeof listDelegations>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listDelegations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListDelegationsQueryOptions(workspaceId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Grant a temporary review-permission delegation (admin only). Expires automatically at endsAt.
 */
export const getCreateDelegationUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/delegations`;
};

export const createDelegation = async (
  workspaceId: string,
  createDelegationBody: CreateDelegationBody,
  options?: RequestInit,
): Promise<Delegation> => {
  return customFetch<Delegation>(getCreateDelegationUrl(workspaceId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createDelegationBody),
  });
};

export const getCreateDelegationMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDelegation>>,
    TError,
    { workspaceId: string; data: BodyType<CreateDelegationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDelegation>>,
  TError,
  { workspaceId: string; data: BodyType<CreateDelegationBody> },
  TContext
> => {
  const mutationKey = ["createDelegation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDelegation>>,
    { workspaceId: string; data: BodyType<CreateDelegationBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return createDelegation(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDelegationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDelegation>>
>;
export type CreateDelegationMutationBody = BodyType<CreateDelegationBody>;
export type CreateDelegationMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Grant a temporary review-permission delegation (admin only). Expires automatically at endsAt.
 */
export const useCreateDelegation = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDelegation>>,
    TError,
    { workspaceId: string; data: BodyType<CreateDelegationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createDelegation>>,
  TError,
  { workspaceId: string; data: BodyType<CreateDelegationBody> },
  TContext
> => {
  return useMutation(getCreateDelegationMutationOptions(options));
};

/**
 * @summary Revoke a delegation early (admin only).
 */
export const getRevokeDelegationUrl = (
  workspaceId: string,
  delegationId: string,
) => {
  return `/api/workspaces/${workspaceId}/delegations/${delegationId}/revoke`;
};

export const revokeDelegation = async (
  workspaceId: string,
  delegationId: string,
  options?: RequestInit,
): Promise<Delegation> => {
  return customFetch<Delegation>(
    getRevokeDelegationUrl(workspaceId, delegationId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRevokeDelegationMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeDelegation>>,
    TError,
    { workspaceId: string; delegationId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeDelegation>>,
  TError,
  { workspaceId: string; delegationId: string },
  TContext
> => {
  const mutationKey = ["revokeDelegation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeDelegation>>,
    { workspaceId: string; delegationId: string }
  > = (props) => {
    const { workspaceId, delegationId } = props ?? {};

    return revokeDelegation(workspaceId, delegationId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeDelegationMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeDelegation>>
>;

export type RevokeDelegationMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Revoke a delegation early (admin only).
 */
export const useRevokeDelegation = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeDelegation>>,
    TError,
    { workspaceId: string; delegationId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revokeDelegation>>,
  TError,
  { workspaceId: string; delegationId: string },
  TContext
> => {
  return useMutation(getRevokeDelegationMutationOptions(options));
};

/**
 * @summary Members currently able to review/complete requests — by role or via an active delegation.
 */
export const getListEligibleReviewersUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/eligible-reviewers`;
};

export const listEligibleReviewers = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<EligibleReviewer[]> => {
  return customFetch<EligibleReviewer[]>(
    getListEligibleReviewersUrl(workspaceId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListEligibleReviewersQueryKey = (workspaceId: string) => {
  return [`/api/workspaces/${workspaceId}/eligible-reviewers`] as const;
};

export const getListEligibleReviewersQueryOptions = <
  TData = Awaited<ReturnType<typeof listEligibleReviewers>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEligibleReviewers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListEligibleReviewersQueryKey(workspaceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEligibleReviewers>>
  > = ({ signal }) =>
    listEligibleReviewers(workspaceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listEligibleReviewers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListEligibleReviewersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEligibleReviewers>>
>;
export type ListEligibleReviewersQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Members currently able to review/complete requests — by role or via an active delegation.
 */

export function useListEligibleReviewers<
  TData = Awaited<ReturnType<typeof listEligibleReviewers>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEligibleReviewers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListEligibleReviewersQueryOptions(
    workspaceId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Bulk-reassign open requests to another eligible member (admin only). Recorded in each request's timeline.
 */
export const getBulkReassignRequestsUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/requests/bulk-reassign`;
};

export const bulkReassignRequests = async (
  workspaceId: string,
  bulkReassignRequestsBody: BulkReassignRequestsBody,
  options?: RequestInit,
): Promise<BulkReassignRequestsResult> => {
  return customFetch<BulkReassignRequestsResult>(
    getBulkReassignRequestsUrl(workspaceId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(bulkReassignRequestsBody),
    },
  );
};

export const getBulkReassignRequestsMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkReassignRequests>>,
    TError,
    { workspaceId: string; data: BodyType<BulkReassignRequestsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkReassignRequests>>,
  TError,
  { workspaceId: string; data: BodyType<BulkReassignRequestsBody> },
  TContext
> => {
  const mutationKey = ["bulkReassignRequests"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkReassignRequests>>,
    { workspaceId: string; data: BodyType<BulkReassignRequestsBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return bulkReassignRequests(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkReassignRequestsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkReassignRequests>>
>;
export type BulkReassignRequestsMutationBody =
  BodyType<BulkReassignRequestsBody>;
export type BulkReassignRequestsMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Bulk-reassign open requests to another eligible member (admin only). Recorded in each request's timeline.
 */
export const useBulkReassignRequests = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkReassignRequests>>,
    TError,
    { workspaceId: string; data: BodyType<BulkReassignRequestsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkReassignRequests>>,
  TError,
  { workspaceId: string; data: BodyType<BulkReassignRequestsBody> },
  TContext
> => {
  return useMutation(getBulkReassignRequestsMutationOptions(options));
};

/**
 * @summary Get current user's notification preferences for this workspace.
 */
export const getGetNotificationPrefsUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/notification-prefs`;
};

export const getNotificationPrefs = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<NotificationPrefs> => {
  return customFetch<NotificationPrefs>(
    getGetNotificationPrefsUrl(workspaceId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetNotificationPrefsQueryKey = (workspaceId: string) => {
  return [`/api/workspaces/${workspaceId}/notification-prefs`] as const;
};

export const getGetNotificationPrefsQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationPrefs>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getNotificationPrefs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetNotificationPrefsQueryKey(workspaceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNotificationPrefs>>
  > = ({ signal }) =>
    getNotificationPrefs(workspaceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationPrefs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNotificationPrefsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationPrefs>>
>;
export type GetNotificationPrefsQueryError = ErrorType<unknown>;

/**
 * @summary Get current user's notification preferences for this workspace.
 */

export function useGetNotificationPrefs<
  TData = Awaited<ReturnType<typeof getNotificationPrefs>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getNotificationPrefs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNotificationPrefsQueryOptions(
    workspaceId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update current user's notification preferences for this workspace.
 */
export const getUpdateNotificationPrefsUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/notification-prefs`;
};

export const updateNotificationPrefs = async (
  workspaceId: string,
  updateNotificationPrefsBody: UpdateNotificationPrefsBody,
  options?: RequestInit,
): Promise<NotificationPrefs> => {
  return customFetch<NotificationPrefs>(
    getUpdateNotificationPrefsUrl(workspaceId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateNotificationPrefsBody),
    },
  );
};

export const getUpdateNotificationPrefsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotificationPrefs>>,
    TError,
    { workspaceId: string; data: BodyType<UpdateNotificationPrefsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNotificationPrefs>>,
  TError,
  { workspaceId: string; data: BodyType<UpdateNotificationPrefsBody> },
  TContext
> => {
  const mutationKey = ["updateNotificationPrefs"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNotificationPrefs>>,
    { workspaceId: string; data: BodyType<UpdateNotificationPrefsBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return updateNotificationPrefs(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNotificationPrefsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNotificationPrefs>>
>;
export type UpdateNotificationPrefsMutationBody =
  BodyType<UpdateNotificationPrefsBody>;
export type UpdateNotificationPrefsMutationError = ErrorType<unknown>;

/**
 * @summary Update current user's notification preferences for this workspace.
 */
export const useUpdateNotificationPrefs = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotificationPrefs>>,
    TError,
    { workspaceId: string; data: BodyType<UpdateNotificationPrefsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateNotificationPrefs>>,
  TError,
  { workspaceId: string; data: BodyType<UpdateNotificationPrefsBody> },
  TContext
> => {
  return useMutation(getUpdateNotificationPrefsMutationOptions(options));
};

/**
 * @summary Get the last wizard-applied configuration snapshot for this workspace (admin only).
 */
export const getGetSetupWizardConfigUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/setup-wizard-config`;
};

export const getSetupWizardConfig = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<SetupWizardAppliedConfig> => {
  return customFetch<SetupWizardAppliedConfig>(
    getGetSetupWizardConfigUrl(workspaceId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetSetupWizardConfigQueryKey = (workspaceId: string) => {
  return [`/api/workspaces/${workspaceId}/setup-wizard-config`] as const;
};

export const getGetSetupWizardConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getSetupWizardConfig>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSetupWizardConfig>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSetupWizardConfigQueryKey(workspaceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSetupWizardConfig>>
  > = ({ signal }) =>
    getSetupWizardConfig(workspaceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSetupWizardConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSetupWizardConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSetupWizardConfig>>
>;
export type GetSetupWizardConfigQueryError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Get the last wizard-applied configuration snapshot for this workspace (admin only).
 */

export function useGetSetupWizardConfig<
  TData = Awaited<ReturnType<typeof getSetupWizardConfig>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSetupWizardConfig>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSetupWizardConfigQueryOptions(
    workspaceId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save the wizard-applied configuration snapshot for this workspace (admin only).
 */
export const getPutSetupWizardConfigUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/setup-wizard-config`;
};

export const putSetupWizardConfig = async (
  workspaceId: string,
  setupWizardAppliedConfig: SetupWizardAppliedConfig,
  options?: RequestInit,
): Promise<SetupWizardAppliedConfig> => {
  return customFetch<SetupWizardAppliedConfig>(
    getPutSetupWizardConfigUrl(workspaceId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(setupWizardAppliedConfig),
    },
  );
};

export const getPutSetupWizardConfigMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSetupWizardConfig>>,
    TError,
    { workspaceId: string; data: BodyType<SetupWizardAppliedConfig> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSetupWizardConfig>>,
  TError,
  { workspaceId: string; data: BodyType<SetupWizardAppliedConfig> },
  TContext
> => {
  const mutationKey = ["putSetupWizardConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSetupWizardConfig>>,
    { workspaceId: string; data: BodyType<SetupWizardAppliedConfig> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return putSetupWizardConfig(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutSetupWizardConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSetupWizardConfig>>
>;
export type PutSetupWizardConfigMutationBody =
  BodyType<SetupWizardAppliedConfig>;
export type PutSetupWizardConfigMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Save the wizard-applied configuration snapshot for this workspace (admin only).
 */
export const usePutSetupWizardConfig = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSetupWizardConfig>>,
    TError,
    { workspaceId: string; data: BodyType<SetupWizardAppliedConfig> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putSetupWizardConfig>>,
  TError,
  { workspaceId: string; data: BodyType<SetupWizardAppliedConfig> },
  TContext
> => {
  return useMutation(getPutSetupWizardConfigMutationOptions(options));
};

export const getGetWorkspaceBrandingUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/branding`;
};

export const getWorkspaceBranding = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<Branding> => {
  return customFetch<Branding>(getGetWorkspaceBrandingUrl(workspaceId), {
    ...options,
    method: "GET",
  });
};

export const getGetWorkspaceBrandingQueryKey = (workspaceId: string) => {
  return [`/api/workspaces/${workspaceId}/branding`] as const;
};

export const getGetWorkspaceBrandingQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkspaceBranding>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspaceBranding>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWorkspaceBrandingQueryKey(workspaceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWorkspaceBranding>>
  > = ({ signal }) =>
    getWorkspaceBranding(workspaceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspaceBranding>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWorkspaceBrandingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkspaceBranding>>
>;
export type GetWorkspaceBrandingQueryError = ErrorType<unknown>;

export function useGetWorkspaceBranding<
  TData = Awaited<ReturnType<typeof getWorkspaceBranding>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspaceBranding>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWorkspaceBrandingQueryOptions(
    workspaceId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateWorkspaceBrandingUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/branding`;
};

export const updateWorkspaceBranding = async (
  workspaceId: string,
  updateBrandingBody: UpdateBrandingBody,
  options?: RequestInit,
): Promise<Branding> => {
  return customFetch<Branding>(getUpdateWorkspaceBrandingUrl(workspaceId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateBrandingBody),
  });
};

export const getUpdateWorkspaceBrandingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWorkspaceBranding>>,
    TError,
    { workspaceId: string; data: BodyType<UpdateBrandingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWorkspaceBranding>>,
  TError,
  { workspaceId: string; data: BodyType<UpdateBrandingBody> },
  TContext
> => {
  const mutationKey = ["updateWorkspaceBranding"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWorkspaceBranding>>,
    { workspaceId: string; data: BodyType<UpdateBrandingBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return updateWorkspaceBranding(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWorkspaceBrandingMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWorkspaceBranding>>
>;
export type UpdateWorkspaceBrandingMutationBody = BodyType<UpdateBrandingBody>;
export type UpdateWorkspaceBrandingMutationError = ErrorType<unknown>;

export const useUpdateWorkspaceBranding = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWorkspaceBranding>>,
    TError,
    { workspaceId: string; data: BodyType<UpdateBrandingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateWorkspaceBranding>>,
  TError,
  { workspaceId: string; data: BodyType<UpdateBrandingBody> },
  TContext
> => {
  return useMutation(getUpdateWorkspaceBrandingMutationOptions(options));
};

/**
 * @summary Get the workspace's custom email sending domain configuration (admin only).
 */
export const getGetWorkspaceEmailDomainUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/email-domain`;
};

export const getWorkspaceEmailDomain = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<WorkspaceEmailDomain | null> => {
  return customFetch<WorkspaceEmailDomain | null>(
    getGetWorkspaceEmailDomainUrl(workspaceId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetWorkspaceEmailDomainQueryKey = (workspaceId: string) => {
  return [`/api/workspaces/${workspaceId}/email-domain`] as const;
};

export const getGetWorkspaceEmailDomainQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkspaceEmailDomain>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspaceEmailDomain>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWorkspaceEmailDomainQueryKey(workspaceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWorkspaceEmailDomain>>
  > = ({ signal }) =>
    getWorkspaceEmailDomain(workspaceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspaceEmailDomain>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWorkspaceEmailDomainQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkspaceEmailDomain>>
>;
export type GetWorkspaceEmailDomainQueryError = ErrorType<unknown>;

/**
 * @summary Get the workspace's custom email sending domain configuration (admin only).
 */

export function useGetWorkspaceEmailDomain<
  TData = Awaited<ReturnType<typeof getWorkspaceEmailDomain>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspaceEmailDomain>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWorkspaceEmailDomainQueryOptions(
    workspaceId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Register a custom sending domain for this workspace via Resend (admin only).
 */
export const getCreateWorkspaceEmailDomainUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/email-domain`;
};

export const createWorkspaceEmailDomain = async (
  workspaceId: string,
  createEmailDomainBody: CreateEmailDomainBody,
  options?: RequestInit,
): Promise<WorkspaceEmailDomain> => {
  return customFetch<WorkspaceEmailDomain>(
    getCreateWorkspaceEmailDomainUrl(workspaceId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createEmailDomainBody),
    },
  );
};

export const getCreateWorkspaceEmailDomainMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWorkspaceEmailDomain>>,
    TError,
    { workspaceId: string; data: BodyType<CreateEmailDomainBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createWorkspaceEmailDomain>>,
  TError,
  { workspaceId: string; data: BodyType<CreateEmailDomainBody> },
  TContext
> => {
  const mutationKey = ["createWorkspaceEmailDomain"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWorkspaceEmailDomain>>,
    { workspaceId: string; data: BodyType<CreateEmailDomainBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return createWorkspaceEmailDomain(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateWorkspaceEmailDomainMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWorkspaceEmailDomain>>
>;
export type CreateWorkspaceEmailDomainMutationBody =
  BodyType<CreateEmailDomainBody>;
export type CreateWorkspaceEmailDomainMutationError = ErrorType<unknown>;

/**
 * @summary Register a custom sending domain for this workspace via Resend (admin only).
 */
export const useCreateWorkspaceEmailDomain = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWorkspaceEmailDomain>>,
    TError,
    { workspaceId: string; data: BodyType<CreateEmailDomainBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createWorkspaceEmailDomain>>,
  TError,
  { workspaceId: string; data: BodyType<CreateEmailDomainBody> },
  TContext
> => {
  return useMutation(getCreateWorkspaceEmailDomainMutationOptions(options));
};

/**
 * @summary Remove the custom email sending domain (admin only). Reverts to FortifyID sender.
 */
export const getDeleteWorkspaceEmailDomainUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/email-domain`;
};

export const deleteWorkspaceEmailDomain = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteWorkspaceEmailDomainUrl(workspaceId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteWorkspaceEmailDomainMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWorkspaceEmailDomain>>,
    TError,
    { workspaceId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteWorkspaceEmailDomain>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  const mutationKey = ["deleteWorkspaceEmailDomain"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteWorkspaceEmailDomain>>,
    { workspaceId: string }
  > = (props) => {
    const { workspaceId } = props ?? {};

    return deleteWorkspaceEmailDomain(workspaceId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteWorkspaceEmailDomainMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteWorkspaceEmailDomain>>
>;

export type DeleteWorkspaceEmailDomainMutationError = ErrorType<unknown>;

/**
 * @summary Remove the custom email sending domain (admin only). Reverts to FortifyID sender.
 */
export const useDeleteWorkspaceEmailDomain = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWorkspaceEmailDomain>>,
    TError,
    { workspaceId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteWorkspaceEmailDomain>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  return useMutation(getDeleteWorkspaceEmailDomainMutationOptions(options));
};

/**
 * @summary Re-check verification status of the workspace's custom email domain (admin only).
 */
export const getVerifyWorkspaceEmailDomainUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/email-domain/verify`;
};

export const verifyWorkspaceEmailDomain = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<WorkspaceEmailDomain> => {
  return customFetch<WorkspaceEmailDomain>(
    getVerifyWorkspaceEmailDomainUrl(workspaceId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getVerifyWorkspaceEmailDomainMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyWorkspaceEmailDomain>>,
    TError,
    { workspaceId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyWorkspaceEmailDomain>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  const mutationKey = ["verifyWorkspaceEmailDomain"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyWorkspaceEmailDomain>>,
    { workspaceId: string }
  > = (props) => {
    const { workspaceId } = props ?? {};

    return verifyWorkspaceEmailDomain(workspaceId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyWorkspaceEmailDomainMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyWorkspaceEmailDomain>>
>;

export type VerifyWorkspaceEmailDomainMutationError = ErrorType<unknown>;

/**
 * @summary Re-check verification status of the workspace's custom email domain (admin only).
 */
export const useVerifyWorkspaceEmailDomain = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyWorkspaceEmailDomain>>,
    TError,
    { workspaceId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verifyWorkspaceEmailDomain>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  return useMutation(getVerifyWorkspaceEmailDomainMutationOptions(options));
};

/**
 * @summary Operator read-only view of a workspace's custom email domain.
 */
export const getOpsGetWorkspaceEmailDomainUrl = (workspaceId: string) => {
  return `/api/ops/workspaces/${workspaceId}/email-domain`;
};

export const opsGetWorkspaceEmailDomain = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<WorkspaceEmailDomain | null> => {
  return customFetch<WorkspaceEmailDomain | null>(
    getOpsGetWorkspaceEmailDomainUrl(workspaceId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getOpsGetWorkspaceEmailDomainQueryKey = (workspaceId: string) => {
  return [`/api/ops/workspaces/${workspaceId}/email-domain`] as const;
};

export const getOpsGetWorkspaceEmailDomainQueryOptions = <
  TData = Awaited<ReturnType<typeof opsGetWorkspaceEmailDomain>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof opsGetWorkspaceEmailDomain>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getOpsGetWorkspaceEmailDomainQueryKey(workspaceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof opsGetWorkspaceEmailDomain>>
  > = ({ signal }) =>
    opsGetWorkspaceEmailDomain(workspaceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof opsGetWorkspaceEmailDomain>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OpsGetWorkspaceEmailDomainQueryResult = NonNullable<
  Awaited<ReturnType<typeof opsGetWorkspaceEmailDomain>>
>;
export type OpsGetWorkspaceEmailDomainQueryError = ErrorType<unknown>;

/**
 * @summary Operator read-only view of a workspace's custom email domain.
 */

export function useOpsGetWorkspaceEmailDomain<
  TData = Awaited<ReturnType<typeof opsGetWorkspaceEmailDomain>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof opsGetWorkspaceEmailDomain>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOpsGetWorkspaceEmailDomainQueryOptions(
    workspaceId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Operator-only. ConnectID credentials are managed by FortifyID Operations, not workspace admins.
 */
export const getGetConnectIdConfigUrl = (
  workspaceId: string,
  params?: GetConnectIdConfigParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/workspaces/${workspaceId}/connectid?${stringifiedParams}`
    : `/api/workspaces/${workspaceId}/connectid`;
};

export const getConnectIdConfig = async (
  workspaceId: string,
  params?: GetConnectIdConfigParams,
  options?: RequestInit,
): Promise<ConnectIdConfigStatus> => {
  return customFetch<ConnectIdConfigStatus>(
    getGetConnectIdConfigUrl(workspaceId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetConnectIdConfigQueryKey = (
  workspaceId: string,
  params?: GetConnectIdConfigParams,
) => {
  return [
    `/api/workspaces/${workspaceId}/connectid`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetConnectIdConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getConnectIdConfig>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  params?: GetConnectIdConfigParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getConnectIdConfig>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetConnectIdConfigQueryKey(workspaceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConnectIdConfig>>
  > = ({ signal }) =>
    getConnectIdConfig(workspaceId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getConnectIdConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetConnectIdConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConnectIdConfig>>
>;
export type GetConnectIdConfigQueryError = ErrorType<unknown>;

/**
 * @summary Operator-only. ConnectID credentials are managed by FortifyID Operations, not workspace admins.
 */

export function useGetConnectIdConfig<
  TData = Awaited<ReturnType<typeof getConnectIdConfig>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  params?: GetConnectIdConfigParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getConnectIdConfig>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetConnectIdConfigQueryOptions(
    workspaceId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Operator-only. Upload/rotate a workspace's SSA, signing key and mTLS material.
 */
export const getUpdateConnectIdConfigUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/connectid`;
};

export const updateConnectIdConfig = async (
  workspaceId: string,
  updateConnectIdConfigBody: UpdateConnectIdConfigBody,
  options?: RequestInit,
): Promise<ConnectIdConfigStatus> => {
  return customFetch<ConnectIdConfigStatus>(
    getUpdateConnectIdConfigUrl(workspaceId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateConnectIdConfigBody),
    },
  );
};

export const getUpdateConnectIdConfigMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateConnectIdConfig>>,
    TError,
    { workspaceId: string; data: BodyType<UpdateConnectIdConfigBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateConnectIdConfig>>,
  TError,
  { workspaceId: string; data: BodyType<UpdateConnectIdConfigBody> },
  TContext
> => {
  const mutationKey = ["updateConnectIdConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateConnectIdConfig>>,
    { workspaceId: string; data: BodyType<UpdateConnectIdConfigBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return updateConnectIdConfig(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateConnectIdConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateConnectIdConfig>>
>;
export type UpdateConnectIdConfigMutationBody =
  BodyType<UpdateConnectIdConfigBody>;
export type UpdateConnectIdConfigMutationError = ErrorType<unknown>;

/**
 * @summary Operator-only. Upload/rotate a workspace's SSA, signing key and mTLS material.
 */
export const useUpdateConnectIdConfig = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateConnectIdConfig>>,
    TError,
    { workspaceId: string; data: BodyType<UpdateConnectIdConfigBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateConnectIdConfig>>,
  TError,
  { workspaceId: string; data: BodyType<UpdateConnectIdConfigBody> },
  TContext
> => {
  return useMutation(getUpdateConnectIdConfigMutationOptions(options));
};

/**
 * @summary Operator-only. Generate a fresh signing key pair server-side; the private key is stored encrypted and returned once for optional download.
 */
export const getGenerateConnectIdSigningKeyUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/connectid/generate-signing-key`;
};

export const generateConnectIdSigningKey = async (
  workspaceId: string,
  generateConnectIdSigningKeyBody?: GenerateConnectIdSigningKeyBody,
  options?: RequestInit,
): Promise<GeneratedSigningKey> => {
  return customFetch<GeneratedSigningKey>(
    getGenerateConnectIdSigningKeyUrl(workspaceId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(generateConnectIdSigningKeyBody),
    },
  );
};

export const getGenerateConnectIdSigningKeyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateConnectIdSigningKey>>,
    TError,
    { workspaceId: string; data: BodyType<GenerateConnectIdSigningKeyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateConnectIdSigningKey>>,
  TError,
  { workspaceId: string; data: BodyType<GenerateConnectIdSigningKeyBody> },
  TContext
> => {
  const mutationKey = ["generateConnectIdSigningKey"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateConnectIdSigningKey>>,
    { workspaceId: string; data: BodyType<GenerateConnectIdSigningKeyBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return generateConnectIdSigningKey(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateConnectIdSigningKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateConnectIdSigningKey>>
>;
export type GenerateConnectIdSigningKeyMutationBody =
  BodyType<GenerateConnectIdSigningKeyBody>;
export type GenerateConnectIdSigningKeyMutationError = ErrorType<unknown>;

/**
 * @summary Operator-only. Generate a fresh signing key pair server-side; the private key is stored encrypted and returned once for optional download.
 */
export const useGenerateConnectIdSigningKey = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateConnectIdSigningKey>>,
    TError,
    { workspaceId: string; data: BodyType<GenerateConnectIdSigningKeyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateConnectIdSigningKey>>,
  TError,
  { workspaceId: string; data: BodyType<GenerateConnectIdSigningKeyBody> },
  TContext
> => {
  return useMutation(getGenerateConnectIdSigningKeyMutationOptions(options));
};

/**
 * @summary Operator-only. Generate an mTLS key pair + CSR server-side; the private key is stored encrypted and returned once for optional download.
 */
export const getGenerateConnectIdMtlsCsrUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/connectid/generate-mtls-csr`;
};

export const generateConnectIdMtlsCsr = async (
  workspaceId: string,
  mtlsCsrInput: MtlsCsrInput,
  options?: RequestInit,
): Promise<GeneratedMtlsCsr> => {
  return customFetch<GeneratedMtlsCsr>(
    getGenerateConnectIdMtlsCsrUrl(workspaceId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(mtlsCsrInput),
    },
  );
};

export const getGenerateConnectIdMtlsCsrMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateConnectIdMtlsCsr>>,
    TError,
    { workspaceId: string; data: BodyType<MtlsCsrInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateConnectIdMtlsCsr>>,
  TError,
  { workspaceId: string; data: BodyType<MtlsCsrInput> },
  TContext
> => {
  const mutationKey = ["generateConnectIdMtlsCsr"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateConnectIdMtlsCsr>>,
    { workspaceId: string; data: BodyType<MtlsCsrInput> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return generateConnectIdMtlsCsr(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateConnectIdMtlsCsrMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateConnectIdMtlsCsr>>
>;
export type GenerateConnectIdMtlsCsrMutationBody = BodyType<MtlsCsrInput>;
export type GenerateConnectIdMtlsCsrMutationError = ErrorType<unknown>;

/**
 * @summary Operator-only. Generate an mTLS key pair + CSR server-side; the private key is stored encrypted and returned once for optional download.
 */
export const useGenerateConnectIdMtlsCsr = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateConnectIdMtlsCsr>>,
    TError,
    { workspaceId: string; data: BodyType<MtlsCsrInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateConnectIdMtlsCsr>>,
  TError,
  { workspaceId: string; data: BodyType<MtlsCsrInput> },
  TContext
> => {
  return useMutation(getGenerateConnectIdMtlsCsrMutationOptions(options));
};

/**
 * @summary Operator-only. Guided ConnectID flow — generate BOTH the signing and transport key pairs + CSRs with ConnectID's exact subject (C=AU, O=connectid, OU=orgId, CN=clientId). Private keys are stored encrypted and returned once.
 */
export const getGenerateConnectIdCsrsUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/connectid/generate-csrs`;
};

export const generateConnectIdCsrs = async (
  workspaceId: string,
  connectIdCsrPairInput: ConnectIdCsrPairInput,
  options?: RequestInit,
): Promise<GeneratedConnectIdCsrPair> => {
  return customFetch<GeneratedConnectIdCsrPair>(
    getGenerateConnectIdCsrsUrl(workspaceId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(connectIdCsrPairInput),
    },
  );
};

export const getGenerateConnectIdCsrsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateConnectIdCsrs>>,
    TError,
    { workspaceId: string; data: BodyType<ConnectIdCsrPairInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateConnectIdCsrs>>,
  TError,
  { workspaceId: string; data: BodyType<ConnectIdCsrPairInput> },
  TContext
> => {
  const mutationKey = ["generateConnectIdCsrs"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateConnectIdCsrs>>,
    { workspaceId: string; data: BodyType<ConnectIdCsrPairInput> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return generateConnectIdCsrs(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateConnectIdCsrsMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateConnectIdCsrs>>
>;
export type GenerateConnectIdCsrsMutationBody = BodyType<ConnectIdCsrPairInput>;
export type GenerateConnectIdCsrsMutationError = ErrorType<unknown>;

/**
 * @summary Operator-only. Guided ConnectID flow — generate BOTH the signing and transport key pairs + CSRs with ConnectID's exact subject (C=AU, O=connectid, OU=orgId, CN=clientId). Private keys are stored encrypted and returned once.
 */
export const useGenerateConnectIdCsrs = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateConnectIdCsrs>>,
    TError,
    { workspaceId: string; data: BodyType<ConnectIdCsrPairInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateConnectIdCsrs>>,
  TError,
  { workspaceId: string; data: BodyType<ConnectIdCsrPairInput> },
  TContext
> => {
  return useMutation(getGenerateConnectIdCsrsMutationOptions(options));
};

/**
 * @summary Operator-only. Live PAR handshake against the ConnectID OP.
 */
export const getTestConnectIdConfigUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/connectid/test`;
};

export const testConnectIdConfig = async (
  workspaceId: string,
  testConnectIdConfigBody?: TestConnectIdConfigBody,
  options?: RequestInit,
): Promise<ConnectIdTestResult> => {
  return customFetch<ConnectIdTestResult>(
    getTestConnectIdConfigUrl(workspaceId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(testConnectIdConfigBody),
    },
  );
};

export const getTestConnectIdConfigMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testConnectIdConfig>>,
    TError,
    { workspaceId: string; data: BodyType<TestConnectIdConfigBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testConnectIdConfig>>,
  TError,
  { workspaceId: string; data: BodyType<TestConnectIdConfigBody> },
  TContext
> => {
  const mutationKey = ["testConnectIdConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testConnectIdConfig>>,
    { workspaceId: string; data: BodyType<TestConnectIdConfigBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return testConnectIdConfig(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestConnectIdConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof testConnectIdConfig>>
>;
export type TestConnectIdConfigMutationBody = BodyType<TestConnectIdConfigBody>;
export type TestConnectIdConfigMutationError = ErrorType<unknown>;

/**
 * @summary Operator-only. Live PAR handshake against the ConnectID OP.
 */
export const useTestConnectIdConfig = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testConnectIdConfig>>,
    TError,
    { workspaceId: string; data: BodyType<TestConnectIdConfigBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testConnectIdConfig>>,
  TError,
  { workspaceId: string; data: BodyType<TestConnectIdConfigBody> },
  TContext
> => {
  return useMutation(getTestConnectIdConfigMutationOptions(options));
};

/**
 * @summary Operator-only. Switch which ConnectID environment (sandbox/production) is LIVE for the workspace. The target environment's credentials must have passed a connection test. Instant and reversible; neither credential set is modified.
 */
export const getActivateConnectIdEnvironmentUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/connectid/activate`;
};

export const activateConnectIdEnvironment = async (
  workspaceId: string,
  activateConnectIdEnvironmentBody: ActivateConnectIdEnvironmentBody,
  options?: RequestInit,
): Promise<ActivateConnectIdEnvironment200> => {
  return customFetch<ActivateConnectIdEnvironment200>(
    getActivateConnectIdEnvironmentUrl(workspaceId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(activateConnectIdEnvironmentBody),
    },
  );
};

export const getActivateConnectIdEnvironmentMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateConnectIdEnvironment>>,
    TError,
    { workspaceId: string; data: BodyType<ActivateConnectIdEnvironmentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateConnectIdEnvironment>>,
  TError,
  { workspaceId: string; data: BodyType<ActivateConnectIdEnvironmentBody> },
  TContext
> => {
  const mutationKey = ["activateConnectIdEnvironment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateConnectIdEnvironment>>,
    { workspaceId: string; data: BodyType<ActivateConnectIdEnvironmentBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return activateConnectIdEnvironment(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateConnectIdEnvironmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof activateConnectIdEnvironment>>
>;
export type ActivateConnectIdEnvironmentMutationBody =
  BodyType<ActivateConnectIdEnvironmentBody>;
export type ActivateConnectIdEnvironmentMutationError = ErrorType<void>;

/**
 * @summary Operator-only. Switch which ConnectID environment (sandbox/production) is LIVE for the workspace. The target environment's credentials must have passed a connection test. Instant and reversible; neither credential set is modified.
 */
export const useActivateConnectIdEnvironment = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateConnectIdEnvironment>>,
    TError,
    { workspaceId: string; data: BodyType<ActivateConnectIdEnvironmentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof activateConnectIdEnvironment>>,
  TError,
  { workspaceId: string; data: BodyType<ActivateConnectIdEnvironmentBody> },
  TContext
> => {
  return useMutation(getActivateConnectIdEnvironmentMutationOptions(options));
};

/**
 * @summary Operator-only. Load (or auto-create from workspace data) the Beneficiary Nomination form for a workspace.
 */
export const getGetConnectIdNominationUrl = (workspaceId: string) => {
  return `/api/ops/workspaces/${workspaceId}/connectid-nomination`;
};

export const getConnectIdNomination = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<ConnectIdNomination> => {
  return customFetch<ConnectIdNomination>(
    getGetConnectIdNominationUrl(workspaceId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetConnectIdNominationQueryKey = (workspaceId: string) => {
  return [`/api/ops/workspaces/${workspaceId}/connectid-nomination`] as const;
};

export const getGetConnectIdNominationQueryOptions = <
  TData = Awaited<ReturnType<typeof getConnectIdNomination>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getConnectIdNomination>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetConnectIdNominationQueryKey(workspaceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConnectIdNomination>>
  > = ({ signal }) =>
    getConnectIdNomination(workspaceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getConnectIdNomination>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetConnectIdNominationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConnectIdNomination>>
>;
export type GetConnectIdNominationQueryError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Operator-only. Load (or auto-create from workspace data) the Beneficiary Nomination form for a workspace.
 */

export function useGetConnectIdNomination<
  TData = Awaited<ReturnType<typeof getConnectIdNomination>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getConnectIdNomination>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetConnectIdNominationQueryOptions(
    workspaceId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Operator-only. Save / update the Beneficiary Nomination form for a workspace.
 */
export const getUpdateConnectIdNominationUrl = (workspaceId: string) => {
  return `/api/ops/workspaces/${workspaceId}/connectid-nomination`;
};

export const updateConnectIdNomination = async (
  workspaceId: string,
  updateConnectIdNominationBody: UpdateConnectIdNominationBody,
  options?: RequestInit,
): Promise<ConnectIdNomination> => {
  return customFetch<ConnectIdNomination>(
    getUpdateConnectIdNominationUrl(workspaceId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateConnectIdNominationBody),
    },
  );
};

export const getUpdateConnectIdNominationMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateConnectIdNomination>>,
    TError,
    { workspaceId: string; data: BodyType<UpdateConnectIdNominationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateConnectIdNomination>>,
  TError,
  { workspaceId: string; data: BodyType<UpdateConnectIdNominationBody> },
  TContext
> => {
  const mutationKey = ["updateConnectIdNomination"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateConnectIdNomination>>,
    { workspaceId: string; data: BodyType<UpdateConnectIdNominationBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return updateConnectIdNomination(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateConnectIdNominationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateConnectIdNomination>>
>;
export type UpdateConnectIdNominationMutationBody =
  BodyType<UpdateConnectIdNominationBody>;
export type UpdateConnectIdNominationMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Operator-only. Save / update the Beneficiary Nomination form for a workspace.
 */
export const useUpdateConnectIdNomination = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateConnectIdNomination>>,
    TError,
    { workspaceId: string; data: BodyType<UpdateConnectIdNominationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateConnectIdNomination>>,
  TError,
  { workspaceId: string; data: BodyType<UpdateConnectIdNominationBody> },
  TContext
> => {
  return useMutation(getUpdateConnectIdNominationMutationOptions(options));
};

/**
 * @summary Operator-only. Request a presigned upload URL for a UX-evidence screenshot. The client uploads directly to the returned URL, then stores the objectPath in the nomination form.
 */
export const getRequestConnectIdNominationEvidenceUploadUrl = (
  workspaceId: string,
) => {
  return `/api/ops/workspaces/${workspaceId}/connectid-nomination/evidence`;
};

export const requestConnectIdNominationEvidenceUpload = async (
  workspaceId: string,
  connectIdNominationEvidenceUploadRequest: ConnectIdNominationEvidenceUploadRequest,
  options?: RequestInit,
): Promise<ConnectIdNominationEvidenceUploadResponse> => {
  return customFetch<ConnectIdNominationEvidenceUploadResponse>(
    getRequestConnectIdNominationEvidenceUploadUrl(workspaceId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(connectIdNominationEvidenceUploadRequest),
    },
  );
};

export const getRequestConnectIdNominationEvidenceUploadMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestConnectIdNominationEvidenceUpload>>,
    TError,
    {
      workspaceId: string;
      data: BodyType<ConnectIdNominationEvidenceUploadRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestConnectIdNominationEvidenceUpload>>,
  TError,
  {
    workspaceId: string;
    data: BodyType<ConnectIdNominationEvidenceUploadRequest>;
  },
  TContext
> => {
  const mutationKey = ["requestConnectIdNominationEvidenceUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestConnectIdNominationEvidenceUpload>>,
    {
      workspaceId: string;
      data: BodyType<ConnectIdNominationEvidenceUploadRequest>;
    }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return requestConnectIdNominationEvidenceUpload(
      workspaceId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestConnectIdNominationEvidenceUploadMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof requestConnectIdNominationEvidenceUpload>>
  >;
export type RequestConnectIdNominationEvidenceUploadMutationBody =
  BodyType<ConnectIdNominationEvidenceUploadRequest>;
export type RequestConnectIdNominationEvidenceUploadMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Operator-only. Request a presigned upload URL for a UX-evidence screenshot. The client uploads directly to the returned URL, then stores the objectPath in the nomination form.
 */
export const useRequestConnectIdNominationEvidenceUpload = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestConnectIdNominationEvidenceUpload>>,
    TError,
    {
      workspaceId: string;
      data: BodyType<ConnectIdNominationEvidenceUploadRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestConnectIdNominationEvidenceUpload>>,
  TError,
  {
    workspaceId: string;
    data: BodyType<ConnectIdNominationEvidenceUploadRequest>;
  },
  TContext
> => {
  return useMutation(
    getRequestConnectIdNominationEvidenceUploadMutationOptions(options),
  );
};

/**
 * @summary List custom form templates for a workspace (any member).
 */
export const getListCustomFormTemplatesUrl = (
  workspaceId: string,
  params?: ListCustomFormTemplatesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/workspaces/${workspaceId}/custom-form-templates?${stringifiedParams}`
    : `/api/workspaces/${workspaceId}/custom-form-templates`;
};

export const listCustomFormTemplates = async (
  workspaceId: string,
  params?: ListCustomFormTemplatesParams,
  options?: RequestInit,
): Promise<CustomFormTemplate[]> => {
  return customFetch<CustomFormTemplate[]>(
    getListCustomFormTemplatesUrl(workspaceId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListCustomFormTemplatesQueryKey = (
  workspaceId: string,
  params?: ListCustomFormTemplatesParams,
) => {
  return [
    `/api/workspaces/${workspaceId}/custom-form-templates`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListCustomFormTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCustomFormTemplates>>,
  TError = ErrorType<UnauthorizedResponse | ErrorResponse>,
>(
  workspaceId: string,
  params?: ListCustomFormTemplatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCustomFormTemplates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListCustomFormTemplatesQueryKey(workspaceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCustomFormTemplates>>
  > = ({ signal }) =>
    listCustomFormTemplates(workspaceId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCustomFormTemplates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCustomFormTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCustomFormTemplates>>
>;
export type ListCustomFormTemplatesQueryError = ErrorType<
  UnauthorizedResponse | ErrorResponse
>;

/**
 * @summary List custom form templates for a workspace (any member).
 */

export function useListCustomFormTemplates<
  TData = Awaited<ReturnType<typeof listCustomFormTemplates>>,
  TError = ErrorType<UnauthorizedResponse | ErrorResponse>,
>(
  workspaceId: string,
  params?: ListCustomFormTemplatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCustomFormTemplates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCustomFormTemplatesQueryOptions(
    workspaceId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a custom form template (admin only, Growth/Scale plans).
 */
export const getCreateCustomFormTemplateUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/custom-form-templates`;
};

export const createCustomFormTemplate = async (
  workspaceId: string,
  customFormTemplateInput: CustomFormTemplateInput,
  options?: RequestInit,
): Promise<CustomFormTemplate> => {
  return customFetch<CustomFormTemplate>(
    getCreateCustomFormTemplateUrl(workspaceId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(customFormTemplateInput),
    },
  );
};

export const getCreateCustomFormTemplateMutationOptions = <
  TError = ErrorType<ErrorResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomFormTemplate>>,
    TError,
    { workspaceId: string; data: BodyType<CustomFormTemplateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCustomFormTemplate>>,
  TError,
  { workspaceId: string; data: BodyType<CustomFormTemplateInput> },
  TContext
> => {
  const mutationKey = ["createCustomFormTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCustomFormTemplate>>,
    { workspaceId: string; data: BodyType<CustomFormTemplateInput> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return createCustomFormTemplate(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCustomFormTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCustomFormTemplate>>
>;
export type CreateCustomFormTemplateMutationBody =
  BodyType<CustomFormTemplateInput>;
export type CreateCustomFormTemplateMutationError = ErrorType<
  ErrorResponse | UnauthorizedResponse
>;

/**
 * @summary Create a custom form template (admin only, Growth/Scale plans).
 */
export const useCreateCustomFormTemplate = <
  TError = ErrorType<ErrorResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomFormTemplate>>,
    TError,
    { workspaceId: string; data: BodyType<CustomFormTemplateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCustomFormTemplate>>,
  TError,
  { workspaceId: string; data: BodyType<CustomFormTemplateInput> },
  TContext
> => {
  return useMutation(getCreateCustomFormTemplateMutationOptions(options));
};

/**
 * @summary Get a single custom form template (any member).
 */
export const getGetCustomFormTemplateUrl = (
  workspaceId: string,
  templateId: string,
) => {
  return `/api/workspaces/${workspaceId}/custom-form-templates/${templateId}`;
};

export const getCustomFormTemplate = async (
  workspaceId: string,
  templateId: string,
  options?: RequestInit,
): Promise<CustomFormTemplate> => {
  return customFetch<CustomFormTemplate>(
    getGetCustomFormTemplateUrl(workspaceId, templateId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetCustomFormTemplateQueryKey = (
  workspaceId: string,
  templateId: string,
) => {
  return [
    `/api/workspaces/${workspaceId}/custom-form-templates/${templateId}`,
  ] as const;
};

export const getGetCustomFormTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomFormTemplate>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  workspaceId: string,
  templateId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomFormTemplate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCustomFormTemplateQueryKey(workspaceId, templateId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomFormTemplate>>
  > = ({ signal }) =>
    getCustomFormTemplate(workspaceId, templateId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(workspaceId && templateId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomFormTemplate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCustomFormTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomFormTemplate>>
>;
export type GetCustomFormTemplateQueryError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Get a single custom form template (any member).
 */

export function useGetCustomFormTemplate<
  TData = Awaited<ReturnType<typeof getCustomFormTemplate>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  workspaceId: string,
  templateId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomFormTemplate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCustomFormTemplateQueryOptions(
    workspaceId,
    templateId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a custom form template (admin only, Growth/Scale plans).
 */
export const getUpdateCustomFormTemplateUrl = (
  workspaceId: string,
  templateId: string,
) => {
  return `/api/workspaces/${workspaceId}/custom-form-templates/${templateId}`;
};

export const updateCustomFormTemplate = async (
  workspaceId: string,
  templateId: string,
  customFormTemplateInput: CustomFormTemplateInput,
  options?: RequestInit,
): Promise<CustomFormTemplate> => {
  return customFetch<CustomFormTemplate>(
    getUpdateCustomFormTemplateUrl(workspaceId, templateId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(customFormTemplateInput),
    },
  );
};

export const getUpdateCustomFormTemplateMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCustomFormTemplate>>,
    TError,
    {
      workspaceId: string;
      templateId: string;
      data: BodyType<CustomFormTemplateInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCustomFormTemplate>>,
  TError,
  {
    workspaceId: string;
    templateId: string;
    data: BodyType<CustomFormTemplateInput>;
  },
  TContext
> => {
  const mutationKey = ["updateCustomFormTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCustomFormTemplate>>,
    {
      workspaceId: string;
      templateId: string;
      data: BodyType<CustomFormTemplateInput>;
    }
  > = (props) => {
    const { workspaceId, templateId, data } = props ?? {};

    return updateCustomFormTemplate(
      workspaceId,
      templateId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCustomFormTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCustomFormTemplate>>
>;
export type UpdateCustomFormTemplateMutationBody =
  BodyType<CustomFormTemplateInput>;
export type UpdateCustomFormTemplateMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Update a custom form template (admin only, Growth/Scale plans).
 */
export const useUpdateCustomFormTemplate = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCustomFormTemplate>>,
    TError,
    {
      workspaceId: string;
      templateId: string;
      data: BodyType<CustomFormTemplateInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCustomFormTemplate>>,
  TError,
  {
    workspaceId: string;
    templateId: string;
    data: BodyType<CustomFormTemplateInput>;
  },
  TContext
> => {
  return useMutation(getUpdateCustomFormTemplateMutationOptions(options));
};

/**
 * @summary Delete a custom form template (admin only). Cannot delete templates that have associated requests; archive instead.
 */
export const getDeleteCustomFormTemplateUrl = (
  workspaceId: string,
  templateId: string,
) => {
  return `/api/workspaces/${workspaceId}/custom-form-templates/${templateId}`;
};

export const deleteCustomFormTemplate = async (
  workspaceId: string,
  templateId: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(
    getDeleteCustomFormTemplateUrl(workspaceId, templateId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteCustomFormTemplateMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomFormTemplate>>,
    TError,
    { workspaceId: string; templateId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCustomFormTemplate>>,
  TError,
  { workspaceId: string; templateId: string },
  TContext
> => {
  const mutationKey = ["deleteCustomFormTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCustomFormTemplate>>,
    { workspaceId: string; templateId: string }
  > = (props) => {
    const { workspaceId, templateId } = props ?? {};

    return deleteCustomFormTemplate(workspaceId, templateId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCustomFormTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCustomFormTemplate>>
>;

export type DeleteCustomFormTemplateMutationError = ErrorType<
  UnauthorizedResponse | void | ErrorResponse
>;

/**
 * @summary Delete a custom form template (admin only). Cannot delete templates that have associated requests; archive instead.
 */
export const useDeleteCustomFormTemplate = <
  TError = ErrorType<UnauthorizedResponse | void | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomFormTemplate>>,
    TError,
    { workspaceId: string; templateId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCustomFormTemplate>>,
  TError,
  { workspaceId: string; templateId: string },
  TContext
> => {
  return useMutation(getDeleteCustomFormTemplateMutationOptions(options));
};

export const getListRequestsUrl = (
  workspaceId: string,
  params?: ListRequestsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/workspaces/${workspaceId}/requests?${stringifiedParams}`
    : `/api/workspaces/${workspaceId}/requests`;
};

export const listRequests = async (
  workspaceId: string,
  params?: ListRequestsParams,
  options?: RequestInit,
): Promise<RequestSummary[]> => {
  return customFetch<RequestSummary[]>(
    getListRequestsUrl(workspaceId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListRequestsQueryKey = (
  workspaceId: string,
  params?: ListRequestsParams,
) => {
  return [
    `/api/workspaces/${workspaceId}/requests`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof listRequests>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  params?: ListRequestsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listRequests>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListRequestsQueryKey(workspaceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listRequests>>> = ({
    signal,
  }) => listRequests(workspaceId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listRequests>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRequests>>
>;
export type ListRequestsQueryError = ErrorType<unknown>;

export function useListRequests<
  TData = Awaited<ReturnType<typeof listRequests>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  params?: ListRequestsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listRequests>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListRequestsQueryOptions(
    workspaceId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateRequestUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/requests`;
};

export const createRequest = async (
  workspaceId: string,
  createRequestBody: CreateRequestBody,
  options?: RequestInit,
): Promise<RequestDetail> => {
  return customFetch<RequestDetail>(getCreateRequestUrl(workspaceId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createRequestBody),
  });
};

export const getCreateRequestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRequest>>,
    TError,
    { workspaceId: string; data: BodyType<CreateRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRequest>>,
  TError,
  { workspaceId: string; data: BodyType<CreateRequestBody> },
  TContext
> => {
  const mutationKey = ["createRequest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRequest>>,
    { workspaceId: string; data: BodyType<CreateRequestBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return createRequest(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRequest>>
>;
export type CreateRequestMutationBody = BodyType<CreateRequestBody>;
export type CreateRequestMutationError = ErrorType<unknown>;

export const useCreateRequest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRequest>>,
    TError,
    { workspaceId: string; data: BodyType<CreateRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createRequest>>,
  TError,
  { workspaceId: string; data: BodyType<CreateRequestBody> },
  TContext
> => {
  return useMutation(getCreateRequestMutationOptions(options));
};

export const getGetRequestUrl = (workspaceId: string, requestId: string) => {
  return `/api/workspaces/${workspaceId}/requests/${requestId}`;
};

export const getRequest = async (
  workspaceId: string,
  requestId: string,
  options?: RequestInit,
): Promise<RequestDetail> => {
  return customFetch<RequestDetail>(getGetRequestUrl(workspaceId, requestId), {
    ...options,
    method: "GET",
  });
};

export const getGetRequestQueryKey = (
  workspaceId: string,
  requestId: string,
) => {
  return [`/api/workspaces/${workspaceId}/requests/${requestId}`] as const;
};

export const getGetRequestQueryOptions = <
  TData = Awaited<ReturnType<typeof getRequest>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  requestId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRequest>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRequestQueryKey(workspaceId, requestId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequest>>> = ({
    signal,
  }) => getRequest(workspaceId, requestId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(workspaceId && requestId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRequest>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRequestQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRequest>>
>;
export type GetRequestQueryError = ErrorType<unknown>;

export function useGetRequest<
  TData = Awaited<ReturnType<typeof getRequest>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  requestId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRequest>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRequestQueryOptions(
    workspaceId,
    requestId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Reviewer acknowledges a submitted request (status → reviewed).
 */
export const getMarkRequestReviewedUrl = (
  workspaceId: string,
  requestId: string,
) => {
  return `/api/workspaces/${workspaceId}/requests/${requestId}/mark-reviewed`;
};

export const markRequestReviewed = async (
  workspaceId: string,
  requestId: string,
  options?: RequestInit,
): Promise<RequestDetail> => {
  return customFetch<RequestDetail>(
    getMarkRequestReviewedUrl(workspaceId, requestId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getMarkRequestReviewedMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markRequestReviewed>>,
    TError,
    { workspaceId: string; requestId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markRequestReviewed>>,
  TError,
  { workspaceId: string; requestId: string },
  TContext
> => {
  const mutationKey = ["markRequestReviewed"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markRequestReviewed>>,
    { workspaceId: string; requestId: string }
  > = (props) => {
    const { workspaceId, requestId } = props ?? {};

    return markRequestReviewed(workspaceId, requestId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkRequestReviewedMutationResult = NonNullable<
  Awaited<ReturnType<typeof markRequestReviewed>>
>;

export type MarkRequestReviewedMutationError = ErrorType<void>;

/**
 * @summary Reviewer acknowledges a submitted request (status → reviewed).
 */
export const useMarkRequestReviewed = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markRequestReviewed>>,
    TError,
    { workspaceId: string; requestId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markRequestReviewed>>,
  TError,
  { workspaceId: string; requestId: string },
  TContext
> => {
  return useMutation(getMarkRequestReviewedMutationOptions(options));
};

/**
 * @summary Completer marks a reviewed request as done (status → completed).
 */
export const getMarkRequestCompletedUrl = (
  workspaceId: string,
  requestId: string,
) => {
  return `/api/workspaces/${workspaceId}/requests/${requestId}/mark-completed`;
};

export const markRequestCompleted = async (
  workspaceId: string,
  requestId: string,
  options?: RequestInit,
): Promise<RequestDetail> => {
  return customFetch<RequestDetail>(
    getMarkRequestCompletedUrl(workspaceId, requestId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getMarkRequestCompletedMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markRequestCompleted>>,
    TError,
    { workspaceId: string; requestId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markRequestCompleted>>,
  TError,
  { workspaceId: string; requestId: string },
  TContext
> => {
  const mutationKey = ["markRequestCompleted"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markRequestCompleted>>,
    { workspaceId: string; requestId: string }
  > = (props) => {
    const { workspaceId, requestId } = props ?? {};

    return markRequestCompleted(workspaceId, requestId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkRequestCompletedMutationResult = NonNullable<
  Awaited<ReturnType<typeof markRequestCompleted>>
>;

export type MarkRequestCompletedMutationError = ErrorType<void>;

/**
 * @summary Completer marks a reviewed request as done (status → completed).
 */
export const useMarkRequestCompleted = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markRequestCompleted>>,
    TError,
    { workspaceId: string; requestId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markRequestCompleted>>,
  TError,
  { workspaceId: string; requestId: string },
  TContext
> => {
  return useMutation(getMarkRequestCompletedMutationOptions(options));
};

export const getCancelRequestUrl = (workspaceId: string, requestId: string) => {
  return `/api/workspaces/${workspaceId}/requests/${requestId}/cancel`;
};

export const cancelRequest = async (
  workspaceId: string,
  requestId: string,
  options?: RequestInit,
): Promise<RequestDetail> => {
  return customFetch<RequestDetail>(
    getCancelRequestUrl(workspaceId, requestId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getCancelRequestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelRequest>>,
    TError,
    { workspaceId: string; requestId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelRequest>>,
  TError,
  { workspaceId: string; requestId: string },
  TContext
> => {
  const mutationKey = ["cancelRequest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelRequest>>,
    { workspaceId: string; requestId: string }
  > = (props) => {
    const { workspaceId, requestId } = props ?? {};

    return cancelRequest(workspaceId, requestId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelRequest>>
>;

export type CancelRequestMutationError = ErrorType<unknown>;

export const useCancelRequest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelRequest>>,
    TError,
    { workspaceId: string; requestId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelRequest>>,
  TError,
  { workspaceId: string; requestId: string },
  TContext
> => {
  return useMutation(getCancelRequestMutationOptions(options));
};

/**
 * @summary Re-send the verification email for an existing request (same token, no new request created).
 */
export const getResendRequestEmailUrl = (
  workspaceId: string,
  requestId: string,
) => {
  return `/api/workspaces/${workspaceId}/requests/${requestId}/resend-email`;
};

export const resendRequestEmail = async (
  workspaceId: string,
  requestId: string,
  options?: RequestInit,
): Promise<RequestDetail> => {
  return customFetch<RequestDetail>(
    getResendRequestEmailUrl(workspaceId, requestId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getResendRequestEmailMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendRequestEmail>>,
    TError,
    { workspaceId: string; requestId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendRequestEmail>>,
  TError,
  { workspaceId: string; requestId: string },
  TContext
> => {
  const mutationKey = ["resendRequestEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendRequestEmail>>,
    { workspaceId: string; requestId: string }
  > = (props) => {
    const { workspaceId, requestId } = props ?? {};

    return resendRequestEmail(workspaceId, requestId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendRequestEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendRequestEmail>>
>;

export type ResendRequestEmailMutationError = ErrorType<void>;

/**
 * @summary Re-send the verification email for an existing request (same token, no new request created).
 */
export const useResendRequestEmail = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendRequestEmail>>,
    TError,
    { workspaceId: string; requestId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resendRequestEmail>>,
  TError,
  { workspaceId: string; requestId: string },
  TContext
> => {
  return useMutation(getResendRequestEmailMutationOptions(options));
};

/**
 * @summary Create a fresh request copying the original, optionally overriding types or expiry.
 */
export const getResendRequestUrl = (workspaceId: string, requestId: string) => {
  return `/api/workspaces/${workspaceId}/requests/${requestId}/resend`;
};

export const resendRequest = async (
  workspaceId: string,
  requestId: string,
  resendRequestBody?: ResendRequestBody,
  options?: RequestInit,
): Promise<RequestDetail> => {
  return customFetch<RequestDetail>(
    getResendRequestUrl(workspaceId, requestId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(resendRequestBody),
    },
  );
};

export const getResendRequestMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendRequest>>,
    TError,
    {
      workspaceId: string;
      requestId: string;
      data: BodyType<ResendRequestBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendRequest>>,
  TError,
  { workspaceId: string; requestId: string; data: BodyType<ResendRequestBody> },
  TContext
> => {
  const mutationKey = ["resendRequest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendRequest>>,
    {
      workspaceId: string;
      requestId: string;
      data: BodyType<ResendRequestBody>;
    }
  > = (props) => {
    const { workspaceId, requestId, data } = props ?? {};

    return resendRequest(workspaceId, requestId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendRequest>>
>;
export type ResendRequestMutationBody = BodyType<ResendRequestBody>;
export type ResendRequestMutationError = ErrorType<void>;

/**
 * @summary Create a fresh request copying the original, optionally overriding types or expiry.
 */
export const useResendRequest = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendRequest>>,
    TError,
    {
      workspaceId: string;
      requestId: string;
      data: BodyType<ResendRequestBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resendRequest>>,
  TError,
  { workspaceId: string; requestId: string; data: BodyType<ResendRequestBody> },
  TContext
> => {
  return useMutation(getResendRequestMutationOptions(options));
};

/**
 * @summary Limited contact-detail removal for cancelled/expired requests with no submission. Nulls out subject email and phone ciphertexts only. Returns 409 for completed/in-hold records (7-year mandatory hold applies — use the Privacy Act request log instead).

 */
export const getEraseSubjectPiiUrl = (
  workspaceId: string,
  requestId: string,
) => {
  return `/api/workspaces/${workspaceId}/requests/${requestId}/subject-pii`;
};

export const eraseSubjectPii = async (
  workspaceId: string,
  requestId: string,
  eraseSubjectPiiBody?: EraseSubjectPiiBody,
  options?: RequestInit,
): Promise<EraseSubjectPii200> => {
  return customFetch<EraseSubjectPii200>(
    getEraseSubjectPiiUrl(workspaceId, requestId),
    {
      ...options,
      method: "DELETE",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(eraseSubjectPiiBody),
    },
  );
};

export const getEraseSubjectPiiMutationOptions = <
  TError = ErrorType<
    ErrorResponse | UnauthorizedResponse | void | ErasePiiConflictResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof eraseSubjectPii>>,
    TError,
    {
      workspaceId: string;
      requestId: string;
      data: BodyType<EraseSubjectPiiBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof eraseSubjectPii>>,
  TError,
  {
    workspaceId: string;
    requestId: string;
    data: BodyType<EraseSubjectPiiBody>;
  },
  TContext
> => {
  const mutationKey = ["eraseSubjectPii"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof eraseSubjectPii>>,
    {
      workspaceId: string;
      requestId: string;
      data: BodyType<EraseSubjectPiiBody>;
    }
  > = (props) => {
    const { workspaceId, requestId, data } = props ?? {};

    return eraseSubjectPii(workspaceId, requestId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EraseSubjectPiiMutationResult = NonNullable<
  Awaited<ReturnType<typeof eraseSubjectPii>>
>;
export type EraseSubjectPiiMutationBody = BodyType<EraseSubjectPiiBody>;
export type EraseSubjectPiiMutationError = ErrorType<
  ErrorResponse | UnauthorizedResponse | void | ErasePiiConflictResponse
>;

/**
 * @summary Limited contact-detail removal for cancelled/expired requests with no submission. Nulls out subject email and phone ciphertexts only. Returns 409 for completed/in-hold records (7-year mandatory hold applies — use the Privacy Act request log instead).

 */
export const useEraseSubjectPii = <
  TError = ErrorType<
    ErrorResponse | UnauthorizedResponse | void | ErasePiiConflictResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof eraseSubjectPii>>,
    TError,
    {
      workspaceId: string;
      requestId: string;
      data: BodyType<EraseSubjectPiiBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof eraseSubjectPii>>,
  TError,
  {
    workspaceId: string;
    requestId: string;
    data: BodyType<EraseSubjectPiiBody>;
  },
  TContext
> => {
  return useMutation(getEraseSubjectPiiMutationOptions(options));
};

/**
 * @summary Log that a subject has submitted a Privacy Act right-to-erasure request. Records the date and the legal-basis response given to the client. No data is removed — the automated 7-year scrub fulfils the request when the hold expires.

 */
export const getLogPrivacyActRequestUrl = (
  workspaceId: string,
  requestId: string,
) => {
  return `/api/workspaces/${workspaceId}/requests/${requestId}/privacy-act-request`;
};

export const logPrivacyActRequest = async (
  workspaceId: string,
  requestId: string,
  logPrivacyActRequestBody: LogPrivacyActRequestBody,
  options?: RequestInit,
): Promise<RequestDetail> => {
  return customFetch<RequestDetail>(
    getLogPrivacyActRequestUrl(workspaceId, requestId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(logPrivacyActRequestBody),
    },
  );
};

export const getLogPrivacyActRequestMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logPrivacyActRequest>>,
    TError,
    {
      workspaceId: string;
      requestId: string;
      data: BodyType<LogPrivacyActRequestBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logPrivacyActRequest>>,
  TError,
  {
    workspaceId: string;
    requestId: string;
    data: BodyType<LogPrivacyActRequestBody>;
  },
  TContext
> => {
  const mutationKey = ["logPrivacyActRequest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logPrivacyActRequest>>,
    {
      workspaceId: string;
      requestId: string;
      data: BodyType<LogPrivacyActRequestBody>;
    }
  > = (props) => {
    const { workspaceId, requestId, data } = props ?? {};

    return logPrivacyActRequest(workspaceId, requestId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogPrivacyActRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof logPrivacyActRequest>>
>;
export type LogPrivacyActRequestMutationBody =
  BodyType<LogPrivacyActRequestBody>;
export type LogPrivacyActRequestMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Log that a subject has submitted a Privacy Act right-to-erasure request. Records the date and the legal-basis response given to the client. No data is removed — the automated 7-year scrub fulfils the request when the hold expires.

 */
export const useLogPrivacyActRequest = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logPrivacyActRequest>>,
    TError,
    {
      workspaceId: string;
      requestId: string;
      data: BodyType<LogPrivacyActRequestBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof logPrivacyActRequest>>,
  TError,
  {
    workspaceId: string;
    requestId: string;
    data: BodyType<LogPrivacyActRequestBody>;
  },
  TContext
> => {
  return useMutation(getLogPrivacyActRequestMutationOptions(options));
};

/**
 * @summary Log a verbal verification call for a request. Requires canVerbalVerify permission. Returns 409 if already verified.
 */
export const getRecordVerbalVerificationUrl = (
  workspaceId: string,
  requestId: string,
) => {
  return `/api/workspaces/${workspaceId}/requests/${requestId}/verbal-verify`;
};

export const recordVerbalVerification = async (
  workspaceId: string,
  requestId: string,
  postVerbalVerificationBody: PostVerbalVerificationBody,
  options?: RequestInit,
): Promise<RequestDetail> => {
  return customFetch<RequestDetail>(
    getRecordVerbalVerificationUrl(workspaceId, requestId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(postVerbalVerificationBody),
    },
  );
};

export const getRecordVerbalVerificationMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordVerbalVerification>>,
    TError,
    {
      workspaceId: string;
      requestId: string;
      data: BodyType<PostVerbalVerificationBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordVerbalVerification>>,
  TError,
  {
    workspaceId: string;
    requestId: string;
    data: BodyType<PostVerbalVerificationBody>;
  },
  TContext
> => {
  const mutationKey = ["recordVerbalVerification"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordVerbalVerification>>,
    {
      workspaceId: string;
      requestId: string;
      data: BodyType<PostVerbalVerificationBody>;
    }
  > = (props) => {
    const { workspaceId, requestId, data } = props ?? {};

    return recordVerbalVerification(
      workspaceId,
      requestId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordVerbalVerificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordVerbalVerification>>
>;
export type RecordVerbalVerificationMutationBody =
  BodyType<PostVerbalVerificationBody>;
export type RecordVerbalVerificationMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Log a verbal verification call for a request. Requires canVerbalVerify permission. Returns 409 if already verified.
 */
export const useRecordVerbalVerification = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordVerbalVerification>>,
    TError,
    {
      workspaceId: string;
      requestId: string;
      data: BodyType<PostVerbalVerificationBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof recordVerbalVerification>>,
  TError,
  {
    workspaceId: string;
    requestId: string;
    data: BodyType<PostVerbalVerificationBody>;
  },
  TContext
> => {
  return useMutation(getRecordVerbalVerificationMutationOptions(options));
};

export const getCreateCommentUrl = (workspaceId: string, requestId: string) => {
  return `/api/workspaces/${workspaceId}/requests/${requestId}/comments`;
};

export const createComment = async (
  workspaceId: string,
  requestId: string,
  createCommentBody: CreateCommentBody,
  options?: RequestInit,
): Promise<Comment> => {
  return customFetch<Comment>(getCreateCommentUrl(workspaceId, requestId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCommentBody),
  });
};

export const getCreateCommentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createComment>>,
    TError,
    {
      workspaceId: string;
      requestId: string;
      data: BodyType<CreateCommentBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createComment>>,
  TError,
  { workspaceId: string; requestId: string; data: BodyType<CreateCommentBody> },
  TContext
> => {
  const mutationKey = ["createComment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createComment>>,
    {
      workspaceId: string;
      requestId: string;
      data: BodyType<CreateCommentBody>;
    }
  > = (props) => {
    const { workspaceId, requestId, data } = props ?? {};

    return createComment(workspaceId, requestId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createComment>>
>;
export type CreateCommentMutationBody = BodyType<CreateCommentBody>;
export type CreateCommentMutationError = ErrorType<unknown>;

export const useCreateComment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createComment>>,
    TError,
    {
      workspaceId: string;
      requestId: string;
      data: BodyType<CreateCommentBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createComment>>,
  TError,
  { workspaceId: string; requestId: string; data: BodyType<CreateCommentBody> },
  TContext
> => {
  return useMutation(getCreateCommentMutationOptions(options));
};

export const getListMembershipsUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/memberships`;
};

export const listMemberships = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<Membership[]> => {
  return customFetch<Membership[]>(getListMembershipsUrl(workspaceId), {
    ...options,
    method: "GET",
  });
};

export const getListMembershipsQueryKey = (workspaceId: string) => {
  return [`/api/workspaces/${workspaceId}/memberships`] as const;
};

export const getListMembershipsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMemberships>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMemberships>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListMembershipsQueryKey(workspaceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMemberships>>> = ({
    signal,
  }) => listMemberships(workspaceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listMemberships>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMembershipsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMemberships>>
>;
export type ListMembershipsQueryError = ErrorType<unknown>;

export function useListMemberships<
  TData = Awaited<ReturnType<typeof listMemberships>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMemberships>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMembershipsQueryOptions(workspaceId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getInviteMembershipUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/memberships`;
};

export const inviteMembership = async (
  workspaceId: string,
  inviteMembershipBody: InviteMembershipBody,
  options?: RequestInit,
): Promise<Membership> => {
  return customFetch<Membership>(getInviteMembershipUrl(workspaceId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(inviteMembershipBody),
  });
};

export const getInviteMembershipMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteMembership>>,
    TError,
    { workspaceId: string; data: BodyType<InviteMembershipBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof inviteMembership>>,
  TError,
  { workspaceId: string; data: BodyType<InviteMembershipBody> },
  TContext
> => {
  const mutationKey = ["inviteMembership"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof inviteMembership>>,
    { workspaceId: string; data: BodyType<InviteMembershipBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return inviteMembership(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InviteMembershipMutationResult = NonNullable<
  Awaited<ReturnType<typeof inviteMembership>>
>;
export type InviteMembershipMutationBody = BodyType<InviteMembershipBody>;
export type InviteMembershipMutationError = ErrorType<unknown>;

export const useInviteMembership = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteMembership>>,
    TError,
    { workspaceId: string; data: BodyType<InviteMembershipBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof inviteMembership>>,
  TError,
  { workspaceId: string; data: BodyType<InviteMembershipBody> },
  TContext
> => {
  return useMutation(getInviteMembershipMutationOptions(options));
};

/**
 * @summary Remove (revoke) a pending membership invite. Admin only.
 */
export const getRemoveMembershipInviteUrl = (
  workspaceId: string,
  membershipId: string,
) => {
  return `/api/workspaces/${workspaceId}/memberships/${membershipId}`;
};

export const removeMembershipInvite = async (
  workspaceId: string,
  membershipId: string,
  options?: RequestInit,
): Promise<RemoveMembershipInvite200> => {
  return customFetch<RemoveMembershipInvite200>(
    getRemoveMembershipInviteUrl(workspaceId, membershipId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getRemoveMembershipInviteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeMembershipInvite>>,
    TError,
    { workspaceId: string; membershipId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeMembershipInvite>>,
  TError,
  { workspaceId: string; membershipId: string },
  TContext
> => {
  const mutationKey = ["removeMembershipInvite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeMembershipInvite>>,
    { workspaceId: string; membershipId: string }
  > = (props) => {
    const { workspaceId, membershipId } = props ?? {};

    return removeMembershipInvite(workspaceId, membershipId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveMembershipInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeMembershipInvite>>
>;

export type RemoveMembershipInviteMutationError = ErrorType<void>;

/**
 * @summary Remove (revoke) a pending membership invite. Admin only.
 */
export const useRemoveMembershipInvite = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeMembershipInvite>>,
    TError,
    { workspaceId: string; membershipId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeMembershipInvite>>,
  TError,
  { workspaceId: string; membershipId: string },
  TContext
> => {
  return useMutation(getRemoveMembershipInviteMutationOptions(options));
};

/**
 * @summary Resend a pending membership invite email. Admin only. Rate-limited to once per 5 minutes per invite.
 */
export const getResendMembershipInviteUrl = (
  workspaceId: string,
  membershipId: string,
) => {
  return `/api/workspaces/${workspaceId}/memberships/${membershipId}/resend-invite`;
};

export const resendMembershipInvite = async (
  workspaceId: string,
  membershipId: string,
  options?: RequestInit,
): Promise<ResendMembershipInvite200> => {
  return customFetch<ResendMembershipInvite200>(
    getResendMembershipInviteUrl(workspaceId, membershipId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getResendMembershipInviteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendMembershipInvite>>,
    TError,
    { workspaceId: string; membershipId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendMembershipInvite>>,
  TError,
  { workspaceId: string; membershipId: string },
  TContext
> => {
  const mutationKey = ["resendMembershipInvite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendMembershipInvite>>,
    { workspaceId: string; membershipId: string }
  > = (props) => {
    const { workspaceId, membershipId } = props ?? {};

    return resendMembershipInvite(workspaceId, membershipId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendMembershipInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendMembershipInvite>>
>;

export type ResendMembershipInviteMutationError = ErrorType<void>;

/**
 * @summary Resend a pending membership invite email. Admin only. Rate-limited to once per 5 minutes per invite.
 */
export const useResendMembershipInvite = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendMembershipInvite>>,
    TError,
    { workspaceId: string; membershipId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resendMembershipInvite>>,
  TError,
  { workspaceId: string; membershipId: string },
  TContext
> => {
  return useMutation(getResendMembershipInviteMutationOptions(options));
};

export const getGetDashboardSummaryUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/dashboard-summary`;
};

export const getDashboardSummary = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<DashboardSummary> => {
  return customFetch<DashboardSummary>(getGetDashboardSummaryUrl(workspaceId), {
    ...options,
    method: "GET",
  });
};

export const getGetDashboardSummaryQueryKey = (workspaceId: string) => {
  return [`/api/workspaces/${workspaceId}/dashboard-summary`] as const;
};

export const getGetDashboardSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDashboardSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey(workspaceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardSummary>>
  > = ({ signal }) =>
    getDashboardSummary(workspaceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDashboardSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardSummary>>
>;
export type GetDashboardSummaryQueryError = ErrorType<unknown>;

export function useGetDashboardSummary<
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDashboardSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDashboardSummaryQueryOptions(workspaceId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Aggregated analytics for a workspace — conversion funnel, time-series, type breakdown, ID verification stats, and top staff.
 */
export const getGetWorkspaceAnalyticsUrl = (
  workspaceId: string,
  params?: GetWorkspaceAnalyticsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/workspaces/${workspaceId}/analytics?${stringifiedParams}`
    : `/api/workspaces/${workspaceId}/analytics`;
};

export const getWorkspaceAnalytics = async (
  workspaceId: string,
  params?: GetWorkspaceAnalyticsParams,
  options?: RequestInit,
): Promise<WorkspaceAnalytics> => {
  return customFetch<WorkspaceAnalytics>(
    getGetWorkspaceAnalyticsUrl(workspaceId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetWorkspaceAnalyticsQueryKey = (
  workspaceId: string,
  params?: GetWorkspaceAnalyticsParams,
) => {
  return [
    `/api/workspaces/${workspaceId}/analytics`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetWorkspaceAnalyticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkspaceAnalytics>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  workspaceId: string,
  params?: GetWorkspaceAnalyticsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspaceAnalytics>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetWorkspaceAnalyticsQueryKey(workspaceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWorkspaceAnalytics>>
  > = ({ signal }) =>
    getWorkspaceAnalytics(workspaceId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspaceAnalytics>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWorkspaceAnalyticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkspaceAnalytics>>
>;
export type GetWorkspaceAnalyticsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Aggregated analytics for a workspace — conversion funnel, time-series, type breakdown, ID verification stats, and top staff.
 */

export function useGetWorkspaceAnalytics<
  TData = Awaited<ReturnType<typeof getWorkspaceAnalytics>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  workspaceId: string,
  params?: GetWorkspaceAnalyticsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspaceAnalytics>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWorkspaceAnalyticsQueryOptions(
    workspaceId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetRecentActivityUrl = (
  workspaceId: string,
  params?: GetRecentActivityParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/workspaces/${workspaceId}/recent-activity?${stringifiedParams}`
    : `/api/workspaces/${workspaceId}/recent-activity`;
};

export const getRecentActivity = async (
  workspaceId: string,
  params?: GetRecentActivityParams,
  options?: RequestInit,
): Promise<ActivityItem[]> => {
  return customFetch<ActivityItem[]>(
    getGetRecentActivityUrl(workspaceId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetRecentActivityQueryKey = (
  workspaceId: string,
  params?: GetRecentActivityParams,
) => {
  return [
    `/api/workspaces/${workspaceId}/recent-activity`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRecentActivityQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentActivity>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  params?: GetRecentActivityParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRecentActivity>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentActivityQueryKey(workspaceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentActivity>>
  > = ({ signal }) =>
    getRecentActivity(workspaceId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentActivity>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRecentActivityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentActivity>>
>;
export type GetRecentActivityQueryError = ErrorType<unknown>;

export function useGetRecentActivity<
  TData = Awaited<ReturnType<typeof getRecentActivity>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  params?: GetRecentActivityParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRecentActivity>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRecentActivityQueryOptions(
    workspaceId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get operator support access status and history for a workspace (admin only).
 */
export const getGetWorkspaceOperatorAccessUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/operator-access`;
};

export const getWorkspaceOperatorAccess = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<WorkspaceAccessGrantStatus> => {
  return customFetch<WorkspaceAccessGrantStatus>(
    getGetWorkspaceOperatorAccessUrl(workspaceId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetWorkspaceOperatorAccessQueryKey = (workspaceId: string) => {
  return [`/api/workspaces/${workspaceId}/operator-access`] as const;
};

export const getGetWorkspaceOperatorAccessQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkspaceOperatorAccess>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspaceOperatorAccess>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetWorkspaceOperatorAccessQueryKey(workspaceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWorkspaceOperatorAccess>>
  > = ({ signal }) =>
    getWorkspaceOperatorAccess(workspaceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspaceOperatorAccess>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWorkspaceOperatorAccessQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkspaceOperatorAccess>>
>;
export type GetWorkspaceOperatorAccessQueryError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Get operator support access status and history for a workspace (admin only).
 */

export function useGetWorkspaceOperatorAccess<
  TData = Awaited<ReturnType<typeof getWorkspaceOperatorAccess>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspaceOperatorAccess>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWorkspaceOperatorAccessQueryOptions(
    workspaceId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a time-limited operator support access grant (admin only).
 */
export const getCreateWorkspaceOperatorAccessGrantUrl = (
  workspaceId: string,
) => {
  return `/api/workspaces/${workspaceId}/operator-access`;
};

export const createWorkspaceOperatorAccessGrant = async (
  workspaceId: string,
  createOperatorAccessGrantBody: CreateOperatorAccessGrantBody,
  options?: RequestInit,
): Promise<WorkspaceAccessGrant> => {
  return customFetch<WorkspaceAccessGrant>(
    getCreateWorkspaceOperatorAccessGrantUrl(workspaceId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createOperatorAccessGrantBody),
    },
  );
};

export const getCreateWorkspaceOperatorAccessGrantMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWorkspaceOperatorAccessGrant>>,
    TError,
    { workspaceId: string; data: BodyType<CreateOperatorAccessGrantBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createWorkspaceOperatorAccessGrant>>,
  TError,
  { workspaceId: string; data: BodyType<CreateOperatorAccessGrantBody> },
  TContext
> => {
  const mutationKey = ["createWorkspaceOperatorAccessGrant"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWorkspaceOperatorAccessGrant>>,
    { workspaceId: string; data: BodyType<CreateOperatorAccessGrantBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return createWorkspaceOperatorAccessGrant(
      workspaceId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateWorkspaceOperatorAccessGrantMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWorkspaceOperatorAccessGrant>>
>;
export type CreateWorkspaceOperatorAccessGrantMutationBody =
  BodyType<CreateOperatorAccessGrantBody>;
export type CreateWorkspaceOperatorAccessGrantMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Create a time-limited operator support access grant (admin only).
 */
export const useCreateWorkspaceOperatorAccessGrant = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWorkspaceOperatorAccessGrant>>,
    TError,
    { workspaceId: string; data: BodyType<CreateOperatorAccessGrantBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createWorkspaceOperatorAccessGrant>>,
  TError,
  { workspaceId: string; data: BodyType<CreateOperatorAccessGrantBody> },
  TContext
> => {
  return useMutation(
    getCreateWorkspaceOperatorAccessGrantMutationOptions(options),
  );
};

/**
 * @summary Revoke the active operator support access grant (admin only).
 */
export const getRevokeWorkspaceOperatorAccessUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/operator-access`;
};

export const revokeWorkspaceOperatorAccess = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<RevokeWorkspaceOperatorAccess200> => {
  return customFetch<RevokeWorkspaceOperatorAccess200>(
    getRevokeWorkspaceOperatorAccessUrl(workspaceId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getRevokeWorkspaceOperatorAccessMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeWorkspaceOperatorAccess>>,
    TError,
    { workspaceId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeWorkspaceOperatorAccess>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  const mutationKey = ["revokeWorkspaceOperatorAccess"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeWorkspaceOperatorAccess>>,
    { workspaceId: string }
  > = (props) => {
    const { workspaceId } = props ?? {};

    return revokeWorkspaceOperatorAccess(workspaceId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeWorkspaceOperatorAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeWorkspaceOperatorAccess>>
>;

export type RevokeWorkspaceOperatorAccessMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Revoke the active operator support access grant (admin only).
 */
export const useRevokeWorkspaceOperatorAccess = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeWorkspaceOperatorAccess>>,
    TError,
    { workspaceId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revokeWorkspaceOperatorAccess>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  return useMutation(getRevokeWorkspaceOperatorAccessMutationOptions(options));
};

/**
 * @summary Workspace-level audit log (admin only).
 */
export const getGetWorkspaceActivityUrl = (
  workspaceId: string,
  params?: GetWorkspaceActivityParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/workspaces/${workspaceId}/activity?${stringifiedParams}`
    : `/api/workspaces/${workspaceId}/activity`;
};

export const getWorkspaceActivity = async (
  workspaceId: string,
  params?: GetWorkspaceActivityParams,
  options?: RequestInit,
): Promise<WorkspaceActivityItem[]> => {
  return customFetch<WorkspaceActivityItem[]>(
    getGetWorkspaceActivityUrl(workspaceId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetWorkspaceActivityQueryKey = (
  workspaceId: string,
  params?: GetWorkspaceActivityParams,
) => {
  return [
    `/api/workspaces/${workspaceId}/activity`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetWorkspaceActivityQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkspaceActivity>>,
  TError = ErrorType<void>,
>(
  workspaceId: string,
  params?: GetWorkspaceActivityParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspaceActivity>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetWorkspaceActivityQueryKey(workspaceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWorkspaceActivity>>
  > = ({ signal }) =>
    getWorkspaceActivity(workspaceId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspaceActivity>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWorkspaceActivityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkspaceActivity>>
>;
export type GetWorkspaceActivityQueryError = ErrorType<void>;

/**
 * @summary Workspace-level audit log (admin only).
 */

export function useGetWorkspaceActivity<
  TData = Awaited<ReturnType<typeof getWorkspaceActivity>>,
  TError = ErrorType<void>,
>(
  workspaceId: string,
  params?: GetWorkspaceActivityParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspaceActivity>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWorkspaceActivityQueryOptions(
    workspaceId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Start a full workspace data export (admin only).
 */
export const getCreateWorkspaceExportUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/exports`;
};

export const createWorkspaceExport = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<WorkspaceExport> => {
  return customFetch<WorkspaceExport>(
    getCreateWorkspaceExportUrl(workspaceId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getCreateWorkspaceExportMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWorkspaceExport>>,
    TError,
    { workspaceId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createWorkspaceExport>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  const mutationKey = ["createWorkspaceExport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWorkspaceExport>>,
    { workspaceId: string }
  > = (props) => {
    const { workspaceId } = props ?? {};

    return createWorkspaceExport(workspaceId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateWorkspaceExportMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWorkspaceExport>>
>;

export type CreateWorkspaceExportMutationError = ErrorType<void>;

/**
 * @summary Start a full workspace data export (admin only).
 */
export const useCreateWorkspaceExport = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWorkspaceExport>>,
    TError,
    { workspaceId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createWorkspaceExport>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  return useMutation(getCreateWorkspaceExportMutationOptions(options));
};

/**
 * @summary List recent workspace data exports (admin only).
 */
export const getListWorkspaceExportsUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/exports`;
};

export const listWorkspaceExports = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<WorkspaceExportList> => {
  return customFetch<WorkspaceExportList>(
    getListWorkspaceExportsUrl(workspaceId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListWorkspaceExportsQueryKey = (workspaceId: string) => {
  return [`/api/workspaces/${workspaceId}/exports`] as const;
};

export const getListWorkspaceExportsQueryOptions = <
  TData = Awaited<ReturnType<typeof listWorkspaceExports>>,
  TError = ErrorType<void>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWorkspaceExports>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListWorkspaceExportsQueryKey(workspaceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWorkspaceExports>>
  > = ({ signal }) =>
    listWorkspaceExports(workspaceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listWorkspaceExports>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListWorkspaceExportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspaceExports>>
>;
export type ListWorkspaceExportsQueryError = ErrorType<void>;

/**
 * @summary List recent workspace data exports (admin only).
 */

export function useListWorkspaceExports<
  TData = Awaited<ReturnType<typeof listWorkspaceExports>>,
  TError = ErrorType<void>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWorkspaceExports>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListWorkspaceExportsQueryOptions(
    workspaceId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mint a short-lived signed download URL for a completed export (admin only).
 */
export const getGetWorkspaceExportDownloadUrlUrl = (
  workspaceId: string,
  exportId: string,
) => {
  return `/api/workspaces/${workspaceId}/exports/${exportId}/download`;
};

export const getWorkspaceExportDownloadUrl = async (
  workspaceId: string,
  exportId: string,
  options?: RequestInit,
): Promise<WorkspaceExportDownload> => {
  return customFetch<WorkspaceExportDownload>(
    getGetWorkspaceExportDownloadUrlUrl(workspaceId, exportId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetWorkspaceExportDownloadUrlQueryKey = (
  workspaceId: string,
  exportId: string,
) => {
  return [
    `/api/workspaces/${workspaceId}/exports/${exportId}/download`,
  ] as const;
};

export const getGetWorkspaceExportDownloadUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkspaceExportDownloadUrl>>,
  TError = ErrorType<void>,
>(
  workspaceId: string,
  exportId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspaceExportDownloadUrl>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetWorkspaceExportDownloadUrlQueryKey(workspaceId, exportId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWorkspaceExportDownloadUrl>>
  > = ({ signal }) =>
    getWorkspaceExportDownloadUrl(workspaceId, exportId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(workspaceId && exportId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspaceExportDownloadUrl>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWorkspaceExportDownloadUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkspaceExportDownloadUrl>>
>;
export type GetWorkspaceExportDownloadUrlQueryError = ErrorType<void>;

/**
 * @summary Mint a short-lived signed download URL for a completed export (admin only).
 */

export function useGetWorkspaceExportDownloadUrl<
  TData = Awaited<ReturnType<typeof getWorkspaceExportDownloadUrl>>,
  TError = ErrorType<void>,
>(
  workspaceId: string,
  exportId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspaceExportDownloadUrl>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWorkspaceExportDownloadUrlQueryOptions(
    workspaceId,
    exportId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get Rex CRM connection status (admin only).
 */
export const getGetRexUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/rex`;
};

export const getRex = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<RexConnectionStatus> => {
  return customFetch<RexConnectionStatus>(getGetRexUrl(workspaceId), {
    ...options,
    method: "GET",
  });
};

export const getGetRexQueryKey = (workspaceId: string) => {
  return [`/api/workspaces/${workspaceId}/rex`] as const;
};

export const getGetRexQueryOptions = <
  TData = Awaited<ReturnType<typeof getRex>>,
  TError = ErrorType<void>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getRex>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRexQueryKey(workspaceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRex>>> = ({
    signal,
  }) => getRex(workspaceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getRex>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetRexQueryResult = NonNullable<Awaited<ReturnType<typeof getRex>>>;
export type GetRexQueryError = ErrorType<void>;

/**
 * @summary Get Rex CRM connection status (admin only).
 */

export function useGetRex<
  TData = Awaited<ReturnType<typeof getRex>>,
  TError = ErrorType<void>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getRex>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRexQueryOptions(workspaceId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save and validate Rex CRM credentials (admin only).
 */
export const getSaveRexUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/rex`;
};

export const saveRex = async (
  workspaceId: string,
  saveRexBody: SaveRexBody,
  options?: RequestInit,
): Promise<RexConnectionStatus> => {
  return customFetch<RexConnectionStatus>(getSaveRexUrl(workspaceId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(saveRexBody),
  });
};

export const getSaveRexMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveRex>>,
    TError,
    { workspaceId: string; data: BodyType<SaveRexBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveRex>>,
  TError,
  { workspaceId: string; data: BodyType<SaveRexBody> },
  TContext
> => {
  const mutationKey = ["saveRex"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveRex>>,
    { workspaceId: string; data: BodyType<SaveRexBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return saveRex(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveRexMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveRex>>
>;
export type SaveRexMutationBody = BodyType<SaveRexBody>;
export type SaveRexMutationError = ErrorType<void>;

/**
 * @summary Save and validate Rex CRM credentials (admin only).
 */
export const useSaveRex = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveRex>>,
    TError,
    { workspaceId: string; data: BodyType<SaveRexBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveRex>>,
  TError,
  { workspaceId: string; data: BodyType<SaveRexBody> },
  TContext
> => {
  return useMutation(getSaveRexMutationOptions(options));
};

/**
 * @summary Disconnect Rex CRM (admin only).
 */
export const getDeleteRexUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/rex`;
};

export const deleteRex = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteRexUrl(workspaceId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteRexMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRex>>,
    TError,
    { workspaceId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRex>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  const mutationKey = ["deleteRex"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRex>>,
    { workspaceId: string }
  > = (props) => {
    const { workspaceId } = props ?? {};

    return deleteRex(workspaceId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRexMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRex>>
>;

export type DeleteRexMutationError = ErrorType<void>;

/**
 * @summary Disconnect Rex CRM (admin only).
 */
export const useDeleteRex = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRex>>,
    TError,
    { workspaceId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteRex>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  return useMutation(getDeleteRexMutationOptions(options));
};

/**
 * @summary Search Rex CRM contacts by name or email.
 */
export const getSearchRexContactsUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/rex/contacts`;
};

export const searchRexContacts = async (
  workspaceId: string,
  rexSearchQuery: RexSearchQuery,
  options?: RequestInit,
): Promise<RexContactResults> => {
  return customFetch<RexContactResults>(getSearchRexContactsUrl(workspaceId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(rexSearchQuery),
  });
};

export const getSearchRexContactsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchRexContacts>>,
    TError,
    { workspaceId: string; data: BodyType<RexSearchQuery> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchRexContacts>>,
  TError,
  { workspaceId: string; data: BodyType<RexSearchQuery> },
  TContext
> => {
  const mutationKey = ["searchRexContacts"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchRexContacts>>,
    { workspaceId: string; data: BodyType<RexSearchQuery> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return searchRexContacts(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchRexContactsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchRexContacts>>
>;
export type SearchRexContactsMutationBody = BodyType<RexSearchQuery>;
export type SearchRexContactsMutationError = ErrorType<void>;

/**
 * @summary Search Rex CRM contacts by name or email.
 */
export const useSearchRexContacts = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchRexContacts>>,
    TError,
    { workspaceId: string; data: BodyType<RexSearchQuery> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof searchRexContacts>>,
  TError,
  { workspaceId: string; data: BodyType<RexSearchQuery> },
  TContext
> => {
  return useMutation(getSearchRexContactsMutationOptions(options));
};

/**
 * @summary Search Rex CRM listings by address; returns each listing with its vendor contacts.
 */
export const getSearchRexListingsUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/rex/listings`;
};

export const searchRexListings = async (
  workspaceId: string,
  rexSearchQuery: RexSearchQuery,
  options?: RequestInit,
): Promise<RexListingResults> => {
  return customFetch<RexListingResults>(getSearchRexListingsUrl(workspaceId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(rexSearchQuery),
  });
};

export const getSearchRexListingsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchRexListings>>,
    TError,
    { workspaceId: string; data: BodyType<RexSearchQuery> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchRexListings>>,
  TError,
  { workspaceId: string; data: BodyType<RexSearchQuery> },
  TContext
> => {
  const mutationKey = ["searchRexListings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchRexListings>>,
    { workspaceId: string; data: BodyType<RexSearchQuery> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return searchRexListings(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchRexListingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchRexListings>>
>;
export type SearchRexListingsMutationBody = BodyType<RexSearchQuery>;
export type SearchRexListingsMutationError = ErrorType<void>;

/**
 * @summary Search Rex CRM listings by address; returns each listing with its vendor contacts.
 */
export const useSearchRexListings = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchRexListings>>,
    TError,
    { workspaceId: string; data: BodyType<RexSearchQuery> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof searchRexListings>>,
  TError,
  { workspaceId: string; data: BodyType<RexSearchQuery> },
  TContext
> => {
  return useMutation(getSearchRexListingsMutationOptions(options));
};

export const getOpsListWorkspacesUrl = (params?: OpsListWorkspacesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ops/workspaces?${stringifiedParams}`
    : `/api/ops/workspaces`;
};

export const opsListWorkspaces = async (
  params?: OpsListWorkspacesParams,
  options?: RequestInit,
): Promise<OpsWorkspaceRow[]> => {
  return customFetch<OpsWorkspaceRow[]>(getOpsListWorkspacesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getOpsListWorkspacesQueryKey = (
  params?: OpsListWorkspacesParams,
) => {
  return [`/api/ops/workspaces`, ...(params ? [params] : [])] as const;
};

export const getOpsListWorkspacesQueryOptions = <
  TData = Awaited<ReturnType<typeof opsListWorkspaces>>,
  TError = ErrorType<unknown>,
>(
  params?: OpsListWorkspacesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof opsListWorkspaces>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getOpsListWorkspacesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof opsListWorkspaces>>
  > = ({ signal }) => opsListWorkspaces(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof opsListWorkspaces>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OpsListWorkspacesQueryResult = NonNullable<
  Awaited<ReturnType<typeof opsListWorkspaces>>
>;
export type OpsListWorkspacesQueryError = ErrorType<unknown>;

export function useOpsListWorkspaces<
  TData = Awaited<ReturnType<typeof opsListWorkspaces>>,
  TError = ErrorType<unknown>,
>(
  params?: OpsListWorkspacesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof opsListWorkspaces>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOpsListWorkspacesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getOpsCreateWorkspaceUrl = () => {
  return `/api/ops/workspaces`;
};

export const opsCreateWorkspace = async (
  opsCreateWorkspaceBody: OpsCreateWorkspaceBody,
  options?: RequestInit,
): Promise<OpsWorkspaceRow> => {
  return customFetch<OpsWorkspaceRow>(getOpsCreateWorkspaceUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(opsCreateWorkspaceBody),
  });
};

export const getOpsCreateWorkspaceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsCreateWorkspace>>,
    TError,
    { data: BodyType<OpsCreateWorkspaceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof opsCreateWorkspace>>,
  TError,
  { data: BodyType<OpsCreateWorkspaceBody> },
  TContext
> => {
  const mutationKey = ["opsCreateWorkspace"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof opsCreateWorkspace>>,
    { data: BodyType<OpsCreateWorkspaceBody> }
  > = (props) => {
    const { data } = props ?? {};

    return opsCreateWorkspace(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OpsCreateWorkspaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof opsCreateWorkspace>>
>;
export type OpsCreateWorkspaceMutationBody = BodyType<OpsCreateWorkspaceBody>;
export type OpsCreateWorkspaceMutationError = ErrorType<unknown>;

export const useOpsCreateWorkspace = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsCreateWorkspace>>,
    TError,
    { data: BodyType<OpsCreateWorkspaceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof opsCreateWorkspace>>,
  TError,
  { data: BodyType<OpsCreateWorkspaceBody> },
  TContext
> => {
  return useMutation(getOpsCreateWorkspaceMutationOptions(options));
};

/**
 * @summary Permanently delete a workspace and all its data. Requires operator admin. Body must echo the exact workspace name.
 */
export const getOpsDeleteWorkspaceUrl = (workspaceId: string) => {
  return `/api/ops/workspaces/${workspaceId}`;
};

export const opsDeleteWorkspace = async (
  workspaceId: string,
  opsDeleteWorkspaceBody: OpsDeleteWorkspaceBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getOpsDeleteWorkspaceUrl(workspaceId), {
    ...options,
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(opsDeleteWorkspaceBody),
  });
};

export const getOpsDeleteWorkspaceMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsDeleteWorkspace>>,
    TError,
    { workspaceId: string; data: BodyType<OpsDeleteWorkspaceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof opsDeleteWorkspace>>,
  TError,
  { workspaceId: string; data: BodyType<OpsDeleteWorkspaceBody> },
  TContext
> => {
  const mutationKey = ["opsDeleteWorkspace"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof opsDeleteWorkspace>>,
    { workspaceId: string; data: BodyType<OpsDeleteWorkspaceBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return opsDeleteWorkspace(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OpsDeleteWorkspaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof opsDeleteWorkspace>>
>;
export type OpsDeleteWorkspaceMutationBody = BodyType<OpsDeleteWorkspaceBody>;
export type OpsDeleteWorkspaceMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Permanently delete a workspace and all its data. Requires operator admin. Body must echo the exact workspace name.
 */
export const useOpsDeleteWorkspace = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsDeleteWorkspace>>,
    TError,
    { workspaceId: string; data: BodyType<OpsDeleteWorkspaceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof opsDeleteWorkspace>>,
  TError,
  { workspaceId: string; data: BodyType<OpsDeleteWorkspaceBody> },
  TContext
> => {
  return useMutation(getOpsDeleteWorkspaceMutationOptions(options));
};

/**
 * @summary Update mutable ops-only workspace flags (e.g. isTest).
 */
export const getOpsUpdateWorkspaceUrl = (workspaceId: string) => {
  return `/api/ops/workspaces/${workspaceId}`;
};

export const opsUpdateWorkspace = async (
  workspaceId: string,
  opsUpdateWorkspaceBody: OpsUpdateWorkspaceBody,
  options?: RequestInit,
): Promise<OpsWorkspaceRow> => {
  return customFetch<OpsWorkspaceRow>(getOpsUpdateWorkspaceUrl(workspaceId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(opsUpdateWorkspaceBody),
  });
};

export const getOpsUpdateWorkspaceMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsUpdateWorkspace>>,
    TError,
    { workspaceId: string; data: BodyType<OpsUpdateWorkspaceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof opsUpdateWorkspace>>,
  TError,
  { workspaceId: string; data: BodyType<OpsUpdateWorkspaceBody> },
  TContext
> => {
  const mutationKey = ["opsUpdateWorkspace"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof opsUpdateWorkspace>>,
    { workspaceId: string; data: BodyType<OpsUpdateWorkspaceBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return opsUpdateWorkspace(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OpsUpdateWorkspaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof opsUpdateWorkspace>>
>;
export type OpsUpdateWorkspaceMutationBody = BodyType<OpsUpdateWorkspaceBody>;
export type OpsUpdateWorkspaceMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Update mutable ops-only workspace flags (e.g. isTest).
 */
export const useOpsUpdateWorkspace = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsUpdateWorkspace>>,
    TError,
    { workspaceId: string; data: BodyType<OpsUpdateWorkspaceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof opsUpdateWorkspace>>,
  TError,
  { workspaceId: string; data: BodyType<OpsUpdateWorkspaceBody> },
  TContext
> => {
  return useMutation(getOpsUpdateWorkspaceMutationOptions(options));
};

/**
 * @summary Extend the billing grace period for a workspace (operator only). Audit-logged.
 */
export const getOpsExtendGracePeriodUrl = (workspaceId: string) => {
  return `/api/ops/workspaces/${workspaceId}/extend-grace-period`;
};

export const opsExtendGracePeriod = async (
  workspaceId: string,
  opsExtendGracePeriodBody: OpsExtendGracePeriodBody,
  options?: RequestInit,
): Promise<OpsExtendGracePeriodResponse> => {
  return customFetch<OpsExtendGracePeriodResponse>(
    getOpsExtendGracePeriodUrl(workspaceId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(opsExtendGracePeriodBody),
    },
  );
};

export const getOpsExtendGracePeriodMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsExtendGracePeriod>>,
    TError,
    { workspaceId: string; data: BodyType<OpsExtendGracePeriodBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof opsExtendGracePeriod>>,
  TError,
  { workspaceId: string; data: BodyType<OpsExtendGracePeriodBody> },
  TContext
> => {
  const mutationKey = ["opsExtendGracePeriod"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof opsExtendGracePeriod>>,
    { workspaceId: string; data: BodyType<OpsExtendGracePeriodBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return opsExtendGracePeriod(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OpsExtendGracePeriodMutationResult = NonNullable<
  Awaited<ReturnType<typeof opsExtendGracePeriod>>
>;
export type OpsExtendGracePeriodMutationBody =
  BodyType<OpsExtendGracePeriodBody>;
export type OpsExtendGracePeriodMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Extend the billing grace period for a workspace (operator only). Audit-logged.
 */
export const useOpsExtendGracePeriod = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsExtendGracePeriod>>,
    TError,
    { workspaceId: string; data: BodyType<OpsExtendGracePeriodBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof opsExtendGracePeriod>>,
  TError,
  { workspaceId: string; data: BodyType<OpsExtendGracePeriodBody> },
  TContext
> => {
  return useMutation(getOpsExtendGracePeriodMutationOptions(options));
};

/**
 * @summary Get the ConnectID nomination lifecycle status record for a workspace (creates a draft if none exists).
 */
export const getOpsGetConnectIdNominationStatusUrl = (workspaceId: string) => {
  return `/api/ops/workspaces/${workspaceId}/connectid-nomination/status`;
};

export const opsGetConnectIdNominationStatus = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<ConnectIdNominationRecord> => {
  return customFetch<ConnectIdNominationRecord>(
    getOpsGetConnectIdNominationStatusUrl(workspaceId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getOpsGetConnectIdNominationStatusQueryKey = (
  workspaceId: string,
) => {
  return [
    `/api/ops/workspaces/${workspaceId}/connectid-nomination/status`,
  ] as const;
};

export const getOpsGetConnectIdNominationStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof opsGetConnectIdNominationStatus>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof opsGetConnectIdNominationStatus>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getOpsGetConnectIdNominationStatusQueryKey(workspaceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof opsGetConnectIdNominationStatus>>
  > = ({ signal }) =>
    opsGetConnectIdNominationStatus(workspaceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof opsGetConnectIdNominationStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OpsGetConnectIdNominationStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof opsGetConnectIdNominationStatus>>
>;
export type OpsGetConnectIdNominationStatusQueryError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Get the ConnectID nomination lifecycle status record for a workspace (creates a draft if none exists).
 */

export function useOpsGetConnectIdNominationStatus<
  TData = Awaited<ReturnType<typeof opsGetConnectIdNominationStatus>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof opsGetConnectIdNominationStatus>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOpsGetConnectIdNominationStatusQueryOptions(
    workspaceId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update nomination lifecycle status, ticket reference, approval date, and notes.
 */
export const getOpsUpdateConnectIdNominationStatusUrl = (
  workspaceId: string,
) => {
  return `/api/ops/workspaces/${workspaceId}/connectid-nomination/status`;
};

export const opsUpdateConnectIdNominationStatus = async (
  workspaceId: string,
  connectIdNominationUpdate: ConnectIdNominationUpdate,
  options?: RequestInit,
): Promise<ConnectIdNominationRecord> => {
  return customFetch<ConnectIdNominationRecord>(
    getOpsUpdateConnectIdNominationStatusUrl(workspaceId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(connectIdNominationUpdate),
    },
  );
};

export const getOpsUpdateConnectIdNominationStatusMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsUpdateConnectIdNominationStatus>>,
    TError,
    { workspaceId: string; data: BodyType<ConnectIdNominationUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof opsUpdateConnectIdNominationStatus>>,
  TError,
  { workspaceId: string; data: BodyType<ConnectIdNominationUpdate> },
  TContext
> => {
  const mutationKey = ["opsUpdateConnectIdNominationStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof opsUpdateConnectIdNominationStatus>>,
    { workspaceId: string; data: BodyType<ConnectIdNominationUpdate> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return opsUpdateConnectIdNominationStatus(
      workspaceId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type OpsUpdateConnectIdNominationStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof opsUpdateConnectIdNominationStatus>>
>;
export type OpsUpdateConnectIdNominationStatusMutationBody =
  BodyType<ConnectIdNominationUpdate>;
export type OpsUpdateConnectIdNominationStatusMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Update nomination lifecycle status, ticket reference, approval date, and notes.
 */
export const useOpsUpdateConnectIdNominationStatus = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsUpdateConnectIdNominationStatus>>,
    TError,
    { workspaceId: string; data: BodyType<ConnectIdNominationUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof opsUpdateConnectIdNominationStatus>>,
  TError,
  { workspaceId: string; data: BodyType<ConnectIdNominationUpdate> },
  TContext
> => {
  return useMutation(
    getOpsUpdateConnectIdNominationStatusMutationOptions(options),
  );
};

export const getOpsApproveWorkspaceUrl = (workspaceId: string) => {
  return `/api/ops/workspaces/${workspaceId}/approve`;
};

export const opsApproveWorkspace = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<Workspace> => {
  return customFetch<Workspace>(getOpsApproveWorkspaceUrl(workspaceId), {
    ...options,
    method: "POST",
  });
};

export const getOpsApproveWorkspaceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsApproveWorkspace>>,
    TError,
    { workspaceId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof opsApproveWorkspace>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  const mutationKey = ["opsApproveWorkspace"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof opsApproveWorkspace>>,
    { workspaceId: string }
  > = (props) => {
    const { workspaceId } = props ?? {};

    return opsApproveWorkspace(workspaceId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OpsApproveWorkspaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof opsApproveWorkspace>>
>;

export type OpsApproveWorkspaceMutationError = ErrorType<unknown>;

export const useOpsApproveWorkspace = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsApproveWorkspace>>,
    TError,
    { workspaceId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof opsApproveWorkspace>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  return useMutation(getOpsApproveWorkspaceMutationOptions(options));
};

export const getOpsSuspendWorkspaceUrl = (workspaceId: string) => {
  return `/api/ops/workspaces/${workspaceId}/suspend`;
};

export const opsSuspendWorkspace = async (
  workspaceId: string,
  opsSuspendWorkspaceBody?: OpsSuspendWorkspaceBody,
  options?: RequestInit,
): Promise<Workspace> => {
  return customFetch<Workspace>(getOpsSuspendWorkspaceUrl(workspaceId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(opsSuspendWorkspaceBody),
  });
};

export const getOpsSuspendWorkspaceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsSuspendWorkspace>>,
    TError,
    { workspaceId: string; data: BodyType<OpsSuspendWorkspaceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof opsSuspendWorkspace>>,
  TError,
  { workspaceId: string; data: BodyType<OpsSuspendWorkspaceBody> },
  TContext
> => {
  const mutationKey = ["opsSuspendWorkspace"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof opsSuspendWorkspace>>,
    { workspaceId: string; data: BodyType<OpsSuspendWorkspaceBody> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return opsSuspendWorkspace(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OpsSuspendWorkspaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof opsSuspendWorkspace>>
>;
export type OpsSuspendWorkspaceMutationBody = BodyType<OpsSuspendWorkspaceBody>;
export type OpsSuspendWorkspaceMutationError = ErrorType<unknown>;

export const useOpsSuspendWorkspace = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsSuspendWorkspace>>,
    TError,
    { workspaceId: string; data: BodyType<OpsSuspendWorkspaceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof opsSuspendWorkspace>>,
  TError,
  { workspaceId: string; data: BodyType<OpsSuspendWorkspaceBody> },
  TContext
> => {
  return useMutation(getOpsSuspendWorkspaceMutationOptions(options));
};

export const getGetWorkspaceBillingUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/billing`;
};

export const getWorkspaceBilling = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<WorkspaceBilling> => {
  return customFetch<WorkspaceBilling>(getGetWorkspaceBillingUrl(workspaceId), {
    ...options,
    method: "GET",
  });
};

export const getGetWorkspaceBillingQueryKey = (workspaceId: string) => {
  return [`/api/workspaces/${workspaceId}/billing`] as const;
};

export const getGetWorkspaceBillingQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkspaceBilling>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspaceBilling>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWorkspaceBillingQueryKey(workspaceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWorkspaceBilling>>
  > = ({ signal }) =>
    getWorkspaceBilling(workspaceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspaceBilling>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWorkspaceBillingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkspaceBilling>>
>;
export type GetWorkspaceBillingQueryError = ErrorType<unknown>;

export function useGetWorkspaceBilling<
  TData = Awaited<ReturnType<typeof getWorkspaceBilling>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspaceBilling>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWorkspaceBillingQueryOptions(workspaceId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateBillingCheckoutUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/billing/checkout`;
};

export const createBillingCheckout = async (
  workspaceId: string,
  billingCheckoutInput: BillingCheckoutInput,
  options?: RequestInit,
): Promise<BillingRedirect> => {
  return customFetch<BillingRedirect>(
    getCreateBillingCheckoutUrl(workspaceId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(billingCheckoutInput),
    },
  );
};

export const getCreateBillingCheckoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBillingCheckout>>,
    TError,
    { workspaceId: string; data: BodyType<BillingCheckoutInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBillingCheckout>>,
  TError,
  { workspaceId: string; data: BodyType<BillingCheckoutInput> },
  TContext
> => {
  const mutationKey = ["createBillingCheckout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBillingCheckout>>,
    { workspaceId: string; data: BodyType<BillingCheckoutInput> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return createBillingCheckout(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBillingCheckoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBillingCheckout>>
>;
export type CreateBillingCheckoutMutationBody = BodyType<BillingCheckoutInput>;
export type CreateBillingCheckoutMutationError = ErrorType<unknown>;

export const useCreateBillingCheckout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBillingCheckout>>,
    TError,
    { workspaceId: string; data: BodyType<BillingCheckoutInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBillingCheckout>>,
  TError,
  { workspaceId: string; data: BodyType<BillingCheckoutInput> },
  TContext
> => {
  return useMutation(getCreateBillingCheckoutMutationOptions(options));
};

export const getCreateBillingPortalUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/billing/portal`;
};

export const createBillingPortal = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<BillingRedirect> => {
  return customFetch<BillingRedirect>(getCreateBillingPortalUrl(workspaceId), {
    ...options,
    method: "POST",
  });
};

export const getCreateBillingPortalMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBillingPortal>>,
    TError,
    { workspaceId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBillingPortal>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  const mutationKey = ["createBillingPortal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBillingPortal>>,
    { workspaceId: string }
  > = (props) => {
    const { workspaceId } = props ?? {};

    return createBillingPortal(workspaceId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBillingPortalMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBillingPortal>>
>;

export type CreateBillingPortalMutationError = ErrorType<unknown>;

export const useCreateBillingPortal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBillingPortal>>,
    TError,
    { workspaceId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBillingPortal>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  return useMutation(getCreateBillingPortalMutationOptions(options));
};

export const getDismissBillingPlanChangeNoticeUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/billing/plan-change-notice`;
};

export const dismissBillingPlanChangeNotice = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<DismissBillingPlanChangeNotice200> => {
  return customFetch<DismissBillingPlanChangeNotice200>(
    getDismissBillingPlanChangeNoticeUrl(workspaceId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDismissBillingPlanChangeNoticeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissBillingPlanChangeNotice>>,
    TError,
    { workspaceId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissBillingPlanChangeNotice>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  const mutationKey = ["dismissBillingPlanChangeNotice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissBillingPlanChangeNotice>>,
    { workspaceId: string }
  > = (props) => {
    const { workspaceId } = props ?? {};

    return dismissBillingPlanChangeNotice(workspaceId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissBillingPlanChangeNoticeMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissBillingPlanChangeNotice>>
>;

export type DismissBillingPlanChangeNoticeMutationError = ErrorType<unknown>;

export const useDismissBillingPlanChangeNotice = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissBillingPlanChangeNotice>>,
    TError,
    { workspaceId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dismissBillingPlanChangeNotice>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  return useMutation(getDismissBillingPlanChangeNoticeMutationOptions(options));
};

export const getGetInvoiceLinesUrl = (
  workspaceId: string,
  invoiceId: string,
) => {
  return `/api/workspaces/${workspaceId}/billing/invoices/${invoiceId}/lines`;
};

export const getInvoiceLines = async (
  workspaceId: string,
  invoiceId: string,
  options?: RequestInit,
): Promise<InvoiceLines> => {
  return customFetch<InvoiceLines>(
    getGetInvoiceLinesUrl(workspaceId, invoiceId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetInvoiceLinesQueryKey = (
  workspaceId: string,
  invoiceId: string,
) => {
  return [
    `/api/workspaces/${workspaceId}/billing/invoices/${invoiceId}/lines`,
  ] as const;
};

export const getGetInvoiceLinesQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvoiceLines>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  invoiceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInvoiceLines>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetInvoiceLinesQueryKey(workspaceId, invoiceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceLines>>> = ({
    signal,
  }) => getInvoiceLines(workspaceId, invoiceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(workspaceId && invoiceId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvoiceLines>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceLinesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvoiceLines>>
>;
export type GetInvoiceLinesQueryError = ErrorType<unknown>;

export function useGetInvoiceLines<
  TData = Awaited<ReturnType<typeof getInvoiceLines>>,
  TError = ErrorType<unknown>,
>(
  workspaceId: string,
  invoiceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInvoiceLines>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInvoiceLinesQueryOptions(
    workspaceId,
    invoiceId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getOpsStatsUrl = () => {
  return `/api/ops/stats`;
};

export const opsStats = async (options?: RequestInit): Promise<OpsStats> => {
  return customFetch<OpsStats>(getOpsStatsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getOpsStatsQueryKey = () => {
  return [`/api/ops/stats`] as const;
};

export const getOpsStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof opsStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof opsStats>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOpsStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof opsStats>>> = ({
    signal,
  }) => opsStats({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof opsStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OpsStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof opsStats>>
>;
export type OpsStatsQueryError = ErrorType<unknown>;

export function useOpsStats<
  TData = Awaited<ReturnType<typeof opsStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof opsStats>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOpsStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Data-retention statistics — counts of records eligible for scrubbing, in mandatory hold, and already scrubbed (operator only).
 */
export const getOpsDataRetentionStatsUrl = () => {
  return `/api/ops/data-retention/stats`;
};

export const opsDataRetentionStats = async (
  options?: RequestInit,
): Promise<DataRetentionStats> => {
  return customFetch<DataRetentionStats>(getOpsDataRetentionStatsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getOpsDataRetentionStatsQueryKey = () => {
  return [`/api/ops/data-retention/stats`] as const;
};

export const getOpsDataRetentionStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof opsDataRetentionStats>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof opsDataRetentionStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOpsDataRetentionStatsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof opsDataRetentionStats>>
  > = ({ signal }) => opsDataRetentionStats({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof opsDataRetentionStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OpsDataRetentionStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof opsDataRetentionStats>>
>;
export type OpsDataRetentionStatsQueryError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Data-retention statistics — counts of records eligible for scrubbing, in mandatory hold, and already scrubbed (operator only).
 */

export function useOpsDataRetentionStats<
  TData = Awaited<ReturnType<typeof opsDataRetentionStats>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof opsDataRetentionStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOpsDataRetentionStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List requests where a Privacy Act right-to-erasure request has been logged and PII has not yet been scrubbed (operator only).
 */
export const getOpsListPrivacyActRequestsUrl = () => {
  return `/api/ops/data-retention/privacy-act-requests`;
};

export const opsListPrivacyActRequests = async (
  options?: RequestInit,
): Promise<PrivacyActRequestRow[]> => {
  return customFetch<PrivacyActRequestRow[]>(
    getOpsListPrivacyActRequestsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getOpsListPrivacyActRequestsQueryKey = () => {
  return [`/api/ops/data-retention/privacy-act-requests`] as const;
};

export const getOpsListPrivacyActRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof opsListPrivacyActRequests>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof opsListPrivacyActRequests>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getOpsListPrivacyActRequestsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof opsListPrivacyActRequests>>
  > = ({ signal }) => opsListPrivacyActRequests({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof opsListPrivacyActRequests>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OpsListPrivacyActRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof opsListPrivacyActRequests>>
>;
export type OpsListPrivacyActRequestsQueryError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary List requests where a Privacy Act right-to-erasure request has been logged and PII has not yet been scrubbed (operator only).
 */

export function useOpsListPrivacyActRequests<
  TData = Awaited<ReturnType<typeof opsListPrivacyActRequests>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof opsListPrivacyActRequests>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOpsListPrivacyActRequestsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Operator-initiated PII scrub — de-identifies request records older than 7 years (mandatory hold floor). Returns counts of processed and skipped records.
 */
export const getOpsRunDataRetentionScrubUrl = () => {
  return `/api/ops/data-retention/run-scrub`;
};

export const opsRunDataRetentionScrub = async (
  options?: RequestInit,
): Promise<DataRetentionScrubResult> => {
  return customFetch<DataRetentionScrubResult>(
    getOpsRunDataRetentionScrubUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getOpsRunDataRetentionScrubMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsRunDataRetentionScrub>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof opsRunDataRetentionScrub>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["opsRunDataRetentionScrub"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof opsRunDataRetentionScrub>>,
    void
  > = () => {
    return opsRunDataRetentionScrub(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OpsRunDataRetentionScrubMutationResult = NonNullable<
  Awaited<ReturnType<typeof opsRunDataRetentionScrub>>
>;

export type OpsRunDataRetentionScrubMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Operator-initiated PII scrub — de-identifies request records older than 7 years (mandatory hold floor). Returns counts of processed and skipped records.
 */
export const useOpsRunDataRetentionScrub = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsRunDataRetentionScrub>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof opsRunDataRetentionScrub>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getOpsRunDataRetentionScrubMutationOptions(options));
};

/**
 * @summary Public — submit a marketing contact form message.
 */
export const getCreateMarketingContactUrl = () => {
  return `/api/marketing/contact`;
};

export const createMarketingContact = async (
  marketingContactInput: MarketingContactInput,
  options?: RequestInit,
): Promise<MarketingContactAck> => {
  return customFetch<MarketingContactAck>(getCreateMarketingContactUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(marketingContactInput),
  });
};

export const getCreateMarketingContactMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMarketingContact>>,
    TError,
    { data: BodyType<MarketingContactInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMarketingContact>>,
  TError,
  { data: BodyType<MarketingContactInput> },
  TContext
> => {
  const mutationKey = ["createMarketingContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMarketingContact>>,
    { data: BodyType<MarketingContactInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createMarketingContact(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMarketingContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMarketingContact>>
>;
export type CreateMarketingContactMutationBody =
  BodyType<MarketingContactInput>;
export type CreateMarketingContactMutationError = ErrorType<unknown>;

/**
 * @summary Public — submit a marketing contact form message.
 */
export const useCreateMarketingContact = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMarketingContact>>,
    TError,
    { data: BodyType<MarketingContactInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMarketingContact>>,
  TError,
  { data: BodyType<MarketingContactInput> },
  TContext
> => {
  return useMutation(getCreateMarketingContactMutationOptions(options));
};

/**
 * @summary Public — fire-and-forget partial lead capture on TrustIQ unlock form submit (before early-access form).
 */
export const getCreateTrustiqPartialLeadUrl = () => {
  return `/api/marketing/partial-lead`;
};

export const createTrustiqPartialLead = async (
  trustIQPartialLeadInput: TrustIQPartialLeadInput,
  options?: RequestInit,
): Promise<MarketingContactAck> => {
  return customFetch<MarketingContactAck>(getCreateTrustiqPartialLeadUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(trustIQPartialLeadInput),
  });
};

export const getCreateTrustiqPartialLeadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTrustiqPartialLead>>,
    TError,
    { data: BodyType<TrustIQPartialLeadInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTrustiqPartialLead>>,
  TError,
  { data: BodyType<TrustIQPartialLeadInput> },
  TContext
> => {
  const mutationKey = ["createTrustiqPartialLead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTrustiqPartialLead>>,
    { data: BodyType<TrustIQPartialLeadInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createTrustiqPartialLead(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTrustiqPartialLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTrustiqPartialLead>>
>;
export type CreateTrustiqPartialLeadMutationBody =
  BodyType<TrustIQPartialLeadInput>;
export type CreateTrustiqPartialLeadMutationError = ErrorType<unknown>;

/**
 * @summary Public — fire-and-forget partial lead capture on TrustIQ unlock form submit (before early-access form).
 */
export const useCreateTrustiqPartialLead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTrustiqPartialLead>>,
    TError,
    { data: BodyType<TrustIQPartialLeadInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTrustiqPartialLead>>,
  TError,
  { data: BodyType<TrustIQPartialLeadInput> },
  TContext
> => {
  return useMutation(getCreateTrustiqPartialLeadMutationOptions(options));
};

/**
 * @summary List marketing contact form submissions (operator only).
 */
export const getOpsListMarketingContactsUrl = (
  params?: OpsListMarketingContactsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ops/marketing-contacts?${stringifiedParams}`
    : `/api/ops/marketing-contacts`;
};

export const opsListMarketingContacts = async (
  params?: OpsListMarketingContactsParams,
  options?: RequestInit,
): Promise<MarketingContact[]> => {
  return customFetch<MarketingContact[]>(
    getOpsListMarketingContactsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getOpsListMarketingContactsQueryKey = (
  params?: OpsListMarketingContactsParams,
) => {
  return [`/api/ops/marketing-contacts`, ...(params ? [params] : [])] as const;
};

export const getOpsListMarketingContactsQueryOptions = <
  TData = Awaited<ReturnType<typeof opsListMarketingContacts>>,
  TError = ErrorType<unknown>,
>(
  params?: OpsListMarketingContactsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof opsListMarketingContacts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getOpsListMarketingContactsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof opsListMarketingContacts>>
  > = ({ signal }) =>
    opsListMarketingContacts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof opsListMarketingContacts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OpsListMarketingContactsQueryResult = NonNullable<
  Awaited<ReturnType<typeof opsListMarketingContacts>>
>;
export type OpsListMarketingContactsQueryError = ErrorType<unknown>;

/**
 * @summary List marketing contact form submissions (operator only).
 */

export function useOpsListMarketingContacts<
  TData = Awaited<ReturnType<typeof opsListMarketingContacts>>,
  TError = ErrorType<unknown>,
>(
  params?: OpsListMarketingContactsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof opsListMarketingContacts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOpsListMarketingContactsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Returns whether the current cookie unlocks the brand portal.
 */
export const getGetBrandPortalStatusUrl = () => {
  return `/api/brand-portal/me`;
};

export const getBrandPortalStatus = async (
  options?: RequestInit,
): Promise<BrandPortalStatus> => {
  return customFetch<BrandPortalStatus>(getGetBrandPortalStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetBrandPortalStatusQueryKey = () => {
  return [`/api/brand-portal/me`] as const;
};

export const getGetBrandPortalStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getBrandPortalStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBrandPortalStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBrandPortalStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBrandPortalStatus>>
  > = ({ signal }) => getBrandPortalStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBrandPortalStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBrandPortalStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBrandPortalStatus>>
>;
export type GetBrandPortalStatusQueryError = ErrorType<unknown>;

/**
 * @summary Returns whether the current cookie unlocks the brand portal.
 */

export function useGetBrandPortalStatus<
  TData = Awaited<ReturnType<typeof getBrandPortalStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBrandPortalStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBrandPortalStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Verify the shared brand-portal password and set the unlock cookie.
 */
export const getUnlockBrandPortalUrl = () => {
  return `/api/brand-portal/unlock`;
};

export const unlockBrandPortal = async (
  brandPortalUnlockBody: BrandPortalUnlockBody,
  options?: RequestInit,
): Promise<BrandPortalStatus> => {
  return customFetch<BrandPortalStatus>(getUnlockBrandPortalUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(brandPortalUnlockBody),
  });
};

export const getUnlockBrandPortalMutationOptions = <
  TError = ErrorType<BrandPortalStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlockBrandPortal>>,
    TError,
    { data: BodyType<BrandPortalUnlockBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlockBrandPortal>>,
  TError,
  { data: BodyType<BrandPortalUnlockBody> },
  TContext
> => {
  const mutationKey = ["unlockBrandPortal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlockBrandPortal>>,
    { data: BodyType<BrandPortalUnlockBody> }
  > = (props) => {
    const { data } = props ?? {};

    return unlockBrandPortal(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlockBrandPortalMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlockBrandPortal>>
>;
export type UnlockBrandPortalMutationBody = BodyType<BrandPortalUnlockBody>;
export type UnlockBrandPortalMutationError = ErrorType<BrandPortalStatus>;

/**
 * @summary Verify the shared brand-portal password and set the unlock cookie.
 */
export const useUnlockBrandPortal = <
  TError = ErrorType<BrandPortalStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlockBrandPortal>>,
    TError,
    { data: BodyType<BrandPortalUnlockBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlockBrandPortal>>,
  TError,
  { data: BodyType<BrandPortalUnlockBody> },
  TContext
> => {
  return useMutation(getUnlockBrandPortalMutationOptions(options));
};

/**
 * @summary Download a brand-portal asset. Requires the unlock cookie.
 */
export const getDownloadBrandPortalAssetUrl = (
  file:
    | "logo.svg"
    | "wordmark.svg"
    | "wordmark-stacked.svg"
    | "palette.json"
    | "tokens.css"
    | "FortifyID-Brand-Guidelines.pdf"
    | "fortifyid-brand-kit.zip",
) => {
  return `/api/brand-portal/assets/${file}`;
};

export const downloadBrandPortalAsset = async (
  file:
    | "logo.svg"
    | "wordmark.svg"
    | "wordmark-stacked.svg"
    | "palette.json"
    | "tokens.css"
    | "FortifyID-Brand-Guidelines.pdf"
    | "fortifyid-brand-kit.zip",
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getDownloadBrandPortalAssetUrl(file), {
    ...options,
    method: "GET",
  });
};

export const getDownloadBrandPortalAssetQueryKey = (
  file:
    | "logo.svg"
    | "wordmark.svg"
    | "wordmark-stacked.svg"
    | "palette.json"
    | "tokens.css"
    | "FortifyID-Brand-Guidelines.pdf"
    | "fortifyid-brand-kit.zip",
) => {
  return [`/api/brand-portal/assets/${file}`] as const;
};

export const getDownloadBrandPortalAssetQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadBrandPortalAsset>>,
  TError = ErrorType<void>,
>(
  file:
    | "logo.svg"
    | "wordmark.svg"
    | "wordmark-stacked.svg"
    | "palette.json"
    | "tokens.css"
    | "FortifyID-Brand-Guidelines.pdf"
    | "fortifyid-brand-kit.zip",
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadBrandPortalAsset>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadBrandPortalAssetQueryKey(file);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadBrandPortalAsset>>
  > = ({ signal }) =>
    downloadBrandPortalAsset(file, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!file,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadBrandPortalAsset>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadBrandPortalAssetQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadBrandPortalAsset>>
>;
export type DownloadBrandPortalAssetQueryError = ErrorType<void>;

/**
 * @summary Download a brand-portal asset. Requires the unlock cookie.
 */

export function useDownloadBrandPortalAsset<
  TData = Awaited<ReturnType<typeof downloadBrandPortalAsset>>,
  TError = ErrorType<void>,
>(
  file:
    | "logo.svg"
    | "wordmark.svg"
    | "wordmark-stacked.svg"
    | "palette.json"
    | "tokens.css"
    | "FortifyID-Brand-Guidelines.pdf"
    | "fortifyid-brand-kit.zip",
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadBrandPortalAsset>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadBrandPortalAssetQueryOptions(file, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Clear the brand-portal unlock cookie.
 */
export const getLockBrandPortalUrl = () => {
  return `/api/brand-portal/lock`;
};

export const lockBrandPortal = async (
  options?: RequestInit,
): Promise<BrandPortalStatus> => {
  return customFetch<BrandPortalStatus>(getLockBrandPortalUrl(), {
    ...options,
    method: "POST",
  });
};

export const getLockBrandPortalMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lockBrandPortal>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lockBrandPortal>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["lockBrandPortal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lockBrandPortal>>,
    void
  > = () => {
    return lockBrandPortal(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LockBrandPortalMutationResult = NonNullable<
  Awaited<ReturnType<typeof lockBrandPortal>>
>;

export type LockBrandPortalMutationError = ErrorType<unknown>;

/**
 * @summary Clear the brand-portal unlock cookie.
 */
export const useLockBrandPortal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lockBrandPortal>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof lockBrandPortal>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getLockBrandPortalMutationOptions(options));
};

/**
 * @summary Public-to-pending-admins — list available 30-minute slots for the next two weeks.
 */
export const getGetDemoAvailabilityUrl = () => {
  return `/api/onboarding/demos/availability`;
};

export const getDemoAvailability = async (
  options?: RequestInit,
): Promise<DemoAvailability> => {
  return customFetch<DemoAvailability>(getGetDemoAvailabilityUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDemoAvailabilityQueryKey = () => {
  return [`/api/onboarding/demos/availability`] as const;
};

export const getGetDemoAvailabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof getDemoAvailability>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDemoAvailability>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDemoAvailabilityQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDemoAvailability>>
  > = ({ signal }) => getDemoAvailability({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDemoAvailability>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDemoAvailabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDemoAvailability>>
>;
export type GetDemoAvailabilityQueryError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Public-to-pending-admins — list available 30-minute slots for the next two weeks.
 */

export function useGetDemoAvailability<
  TData = Awaited<ReturnType<typeof getDemoAvailability>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDemoAvailability>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDemoAvailabilityQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Return the current scheduled demo for the pending workspace, if any.
 */
export const getGetMyDemoBookingUrl = () => {
  return `/api/onboarding/demos/my-booking`;
};

export const getMyDemoBooking = async (
  options?: RequestInit,
): Promise<DemoBookingOrNone> => {
  return customFetch<DemoBookingOrNone>(getGetMyDemoBookingUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyDemoBookingQueryKey = () => {
  return [`/api/onboarding/demos/my-booking`] as const;
};

export const getGetMyDemoBookingQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyDemoBooking>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyDemoBooking>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyDemoBookingQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyDemoBooking>>
  > = ({ signal }) => getMyDemoBooking({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyDemoBooking>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyDemoBookingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyDemoBooking>>
>;
export type GetMyDemoBookingQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Return the current scheduled demo for the pending workspace, if any.
 */

export function useGetMyDemoBooking<
  TData = Awaited<ReturnType<typeof getMyDemoBooking>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyDemoBooking>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyDemoBookingQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Book a 30-minute onboarding walkthrough on the platform's shared calendar.
 */
export const getCreateDemoBookingUrl = () => {
  return `/api/onboarding/demos/bookings`;
};

export const createDemoBooking = async (
  demoBookingInput: DemoBookingInput,
  options?: RequestInit,
): Promise<DemoBooking> => {
  return customFetch<DemoBooking>(getCreateDemoBookingUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(demoBookingInput),
  });
};

export const getCreateDemoBookingMutationOptions = <
  TError = ErrorType<ErrorResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDemoBooking>>,
    TError,
    { data: BodyType<DemoBookingInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDemoBooking>>,
  TError,
  { data: BodyType<DemoBookingInput> },
  TContext
> => {
  const mutationKey = ["createDemoBooking"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDemoBooking>>,
    { data: BodyType<DemoBookingInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createDemoBooking(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDemoBookingMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDemoBooking>>
>;
export type CreateDemoBookingMutationBody = BodyType<DemoBookingInput>;
export type CreateDemoBookingMutationError = ErrorType<
  ErrorResponse | UnauthorizedResponse
>;

/**
 * @summary Book a 30-minute onboarding walkthrough on the platform's shared calendar.
 */
export const useCreateDemoBooking = <
  TError = ErrorType<ErrorResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDemoBooking>>,
    TError,
    { data: BodyType<DemoBookingInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createDemoBooking>>,
  TError,
  { data: BodyType<DemoBookingInput> },
  TContext
> => {
  return useMutation(getCreateDemoBookingMutationOptions(options));
};

/**
 * @summary Cancel an existing demo booking (workspace admin only).
 */
export const getCancelDemoBookingUrl = (bookingId: string) => {
  return `/api/onboarding/demos/bookings/${bookingId}`;
};

export const cancelDemoBooking = async (
  bookingId: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getCancelDemoBookingUrl(bookingId), {
    ...options,
    method: "DELETE",
  });
};

export const getCancelDemoBookingMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelDemoBooking>>,
    TError,
    { bookingId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelDemoBooking>>,
  TError,
  { bookingId: string },
  TContext
> => {
  const mutationKey = ["cancelDemoBooking"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelDemoBooking>>,
    { bookingId: string }
  > = (props) => {
    const { bookingId } = props ?? {};

    return cancelDemoBooking(bookingId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelDemoBookingMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelDemoBooking>>
>;

export type CancelDemoBookingMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Cancel an existing demo booking (workspace admin only).
 */
export const useCancelDemoBooking = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelDemoBooking>>,
    TError,
    { bookingId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelDemoBooking>>,
  TError,
  { bookingId: string },
  TContext
> => {
  return useMutation(getCancelDemoBookingMutationOptions(options));
};

/**
 * @summary Submit a question to the FortifyID onboarding team.
 */
export const getCreateOnboardingQuestionUrl = () => {
  return `/api/onboarding/questions`;
};

export const createOnboardingQuestion = async (
  onboardingQuestionInput: OnboardingQuestionInput,
  options?: RequestInit,
): Promise<OnboardingQuestion> => {
  return customFetch<OnboardingQuestion>(getCreateOnboardingQuestionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(onboardingQuestionInput),
  });
};

export const getCreateOnboardingQuestionMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOnboardingQuestion>>,
    TError,
    { data: BodyType<OnboardingQuestionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOnboardingQuestion>>,
  TError,
  { data: BodyType<OnboardingQuestionInput> },
  TContext
> => {
  const mutationKey = ["createOnboardingQuestion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOnboardingQuestion>>,
    { data: BodyType<OnboardingQuestionInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createOnboardingQuestion(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOnboardingQuestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOnboardingQuestion>>
>;
export type CreateOnboardingQuestionMutationBody =
  BodyType<OnboardingQuestionInput>;
export type CreateOnboardingQuestionMutationError =
  ErrorType<UnauthorizedResponse>;

/**
 * @summary Submit a question to the FortifyID onboarding team.
 */
export const useCreateOnboardingQuestion = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOnboardingQuestion>>,
    TError,
    { data: BodyType<OnboardingQuestionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createOnboardingQuestion>>,
  TError,
  { data: BodyType<OnboardingQuestionInput> },
  TContext
> => {
  return useMutation(getCreateOnboardingQuestionMutationOptions(options));
};

/**
 * @summary List onboarding questions submitted by anyone in the caller's pending workspace.
 */
export const getListMyOnboardingQuestionsUrl = () => {
  return `/api/onboarding/questions/mine`;
};

export const listMyOnboardingQuestions = async (
  options?: RequestInit,
): Promise<OnboardingQuestion[]> => {
  return customFetch<OnboardingQuestion[]>(getListMyOnboardingQuestionsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListMyOnboardingQuestionsQueryKey = () => {
  return [`/api/onboarding/questions/mine`] as const;
};

export const getListMyOnboardingQuestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMyOnboardingQuestions>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMyOnboardingQuestions>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListMyOnboardingQuestionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMyOnboardingQuestions>>
  > = ({ signal }) => listMyOnboardingQuestions({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMyOnboardingQuestions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMyOnboardingQuestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMyOnboardingQuestions>>
>;
export type ListMyOnboardingQuestionsQueryError =
  ErrorType<UnauthorizedResponse>;

/**
 * @summary List onboarding questions submitted by anyone in the caller's pending workspace.
 */

export function useListMyOnboardingQuestions<
  TData = Awaited<ReturnType<typeof listMyOnboardingQuestions>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMyOnboardingQuestions>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMyOnboardingQuestionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all scheduled onboarding demos (operator only).
 */
export const getOpsListDemosUrl = (params?: OpsListDemosParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ops/demos?${stringifiedParams}`
    : `/api/ops/demos`;
};

export const opsListDemos = async (
  params?: OpsListDemosParams,
  options?: RequestInit,
): Promise<OpsDemoBookingRow[]> => {
  return customFetch<OpsDemoBookingRow[]>(getOpsListDemosUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getOpsListDemosQueryKey = (params?: OpsListDemosParams) => {
  return [`/api/ops/demos`, ...(params ? [params] : [])] as const;
};

export const getOpsListDemosQueryOptions = <
  TData = Awaited<ReturnType<typeof opsListDemos>>,
  TError = ErrorType<unknown>,
>(
  params?: OpsListDemosParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof opsListDemos>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOpsListDemosQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof opsListDemos>>> = ({
    signal,
  }) => opsListDemos(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof opsListDemos>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OpsListDemosQueryResult = NonNullable<
  Awaited<ReturnType<typeof opsListDemos>>
>;
export type OpsListDemosQueryError = ErrorType<unknown>;

/**
 * @summary List all scheduled onboarding demos (operator only).
 */

export function useOpsListDemos<
  TData = Awaited<ReturnType<typeof opsListDemos>>,
  TError = ErrorType<unknown>,
>(
  params?: OpsListDemosParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof opsListDemos>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOpsListDemosQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List onboarding questions across all pending workspaces (operator only).
 */
export const getOpsListOnboardingQuestionsUrl = (
  params?: OpsListOnboardingQuestionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ops/onboarding-questions?${stringifiedParams}`
    : `/api/ops/onboarding-questions`;
};

export const opsListOnboardingQuestions = async (
  params?: OpsListOnboardingQuestionsParams,
  options?: RequestInit,
): Promise<OpsOnboardingQuestionRow[]> => {
  return customFetch<OpsOnboardingQuestionRow[]>(
    getOpsListOnboardingQuestionsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getOpsListOnboardingQuestionsQueryKey = (
  params?: OpsListOnboardingQuestionsParams,
) => {
  return [
    `/api/ops/onboarding-questions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getOpsListOnboardingQuestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof opsListOnboardingQuestions>>,
  TError = ErrorType<unknown>,
>(
  params?: OpsListOnboardingQuestionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof opsListOnboardingQuestions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getOpsListOnboardingQuestionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof opsListOnboardingQuestions>>
  > = ({ signal }) =>
    opsListOnboardingQuestions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof opsListOnboardingQuestions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OpsListOnboardingQuestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof opsListOnboardingQuestions>>
>;
export type OpsListOnboardingQuestionsQueryError = ErrorType<unknown>;

/**
 * @summary List onboarding questions across all pending workspaces (operator only).
 */

export function useOpsListOnboardingQuestions<
  TData = Awaited<ReturnType<typeof opsListOnboardingQuestions>>,
  TError = ErrorType<unknown>,
>(
  params?: OpsListOnboardingQuestionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof opsListOnboardingQuestions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOpsListOnboardingQuestionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mark an onboarding question as resolved (operator only).
 */
export const getOpsResolveOnboardingQuestionUrl = (questionId: string) => {
  return `/api/ops/onboarding-questions/${questionId}/resolve`;
};

export const opsResolveOnboardingQuestion = async (
  questionId: string,
  options?: RequestInit,
): Promise<OpsOnboardingQuestionRow> => {
  return customFetch<OpsOnboardingQuestionRow>(
    getOpsResolveOnboardingQuestionUrl(questionId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getOpsResolveOnboardingQuestionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsResolveOnboardingQuestion>>,
    TError,
    { questionId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof opsResolveOnboardingQuestion>>,
  TError,
  { questionId: string },
  TContext
> => {
  const mutationKey = ["opsResolveOnboardingQuestion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof opsResolveOnboardingQuestion>>,
    { questionId: string }
  > = (props) => {
    const { questionId } = props ?? {};

    return opsResolveOnboardingQuestion(questionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OpsResolveOnboardingQuestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof opsResolveOnboardingQuestion>>
>;

export type OpsResolveOnboardingQuestionMutationError = ErrorType<void>;

/**
 * @summary Mark an onboarding question as resolved (operator only).
 */
export const useOpsResolveOnboardingQuestion = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsResolveOnboardingQuestion>>,
    TError,
    { questionId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof opsResolveOnboardingQuestion>>,
  TError,
  { questionId: string },
  TContext
> => {
  return useMutation(getOpsResolveOnboardingQuestionMutationOptions(options));
};

/**
 * @summary List FortifyID operators for assignment (operator only).
 */
export const getOpsListOperatorsUrl = () => {
  return `/api/ops/operators`;
};

export const opsListOperators = async (
  options?: RequestInit,
): Promise<Operator[]> => {
  return customFetch<Operator[]>(getOpsListOperatorsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getOpsListOperatorsQueryKey = () => {
  return [`/api/ops/operators`] as const;
};

export const getOpsListOperatorsQueryOptions = <
  TData = Awaited<ReturnType<typeof opsListOperators>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof opsListOperators>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOpsListOperatorsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof opsListOperators>>
  > = ({ signal }) => opsListOperators({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof opsListOperators>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OpsListOperatorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof opsListOperators>>
>;
export type OpsListOperatorsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List FortifyID operators for assignment (operator only).
 */

export function useOpsListOperators<
  TData = Awaited<ReturnType<typeof opsListOperators>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof opsListOperators>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOpsListOperatorsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Compliance Center landing metrics (operator only).
 */
export const getOpsGetComplianceOverviewUrl = () => {
  return `/api/ops/compliance/overview`;
};

export const opsGetComplianceOverview = async (
  options?: RequestInit,
): Promise<ComplianceOverview> => {
  return customFetch<ComplianceOverview>(getOpsGetComplianceOverviewUrl(), {
    ...options,
    method: "GET",
  });
};

export const getOpsGetComplianceOverviewQueryKey = () => {
  return [`/api/ops/compliance/overview`] as const;
};

export const getOpsGetComplianceOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof opsGetComplianceOverview>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof opsGetComplianceOverview>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getOpsGetComplianceOverviewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof opsGetComplianceOverview>>
  > = ({ signal }) => opsGetComplianceOverview({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof opsGetComplianceOverview>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OpsGetComplianceOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof opsGetComplianceOverview>>
>;
export type OpsGetComplianceOverviewQueryError =
  ErrorType<UnauthorizedResponse>;

/**
 * @summary Compliance Center landing metrics (operator only).
 */

export function useOpsGetComplianceOverview<
  TData = Awaited<ReturnType<typeof opsGetComplianceOverview>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof opsGetComplianceOverview>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOpsGetComplianceOverviewQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List compliance cases (operator only).
 */
export const getOpsListComplianceCasesUrl = (
  params?: OpsListComplianceCasesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ops/compliance/cases?${stringifiedParams}`
    : `/api/ops/compliance/cases`;
};

export const opsListComplianceCases = async (
  params?: OpsListComplianceCasesParams,
  options?: RequestInit,
): Promise<ComplianceCaseRow[]> => {
  return customFetch<ComplianceCaseRow[]>(
    getOpsListComplianceCasesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getOpsListComplianceCasesQueryKey = (
  params?: OpsListComplianceCasesParams,
) => {
  return [`/api/ops/compliance/cases`, ...(params ? [params] : [])] as const;
};

export const getOpsListComplianceCasesQueryOptions = <
  TData = Awaited<ReturnType<typeof opsListComplianceCases>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: OpsListComplianceCasesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof opsListComplianceCases>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getOpsListComplianceCasesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof opsListComplianceCases>>
  > = ({ signal }) =>
    opsListComplianceCases(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof opsListComplianceCases>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OpsListComplianceCasesQueryResult = NonNullable<
  Awaited<ReturnType<typeof opsListComplianceCases>>
>;
export type OpsListComplianceCasesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List compliance cases (operator only).
 */

export function useOpsListComplianceCases<
  TData = Awaited<ReturnType<typeof opsListComplianceCases>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: OpsListComplianceCasesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof opsListComplianceCases>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOpsListComplianceCasesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a compliance case (operator only).
 */
export const getOpsCreateComplianceCaseUrl = () => {
  return `/api/ops/compliance/cases`;
};

export const opsCreateComplianceCase = async (
  complianceCaseInput: ComplianceCaseInput,
  options?: RequestInit,
): Promise<ComplianceCaseDetail> => {
  return customFetch<ComplianceCaseDetail>(getOpsCreateComplianceCaseUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(complianceCaseInput),
  });
};

export const getOpsCreateComplianceCaseMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsCreateComplianceCase>>,
    TError,
    { data: BodyType<ComplianceCaseInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof opsCreateComplianceCase>>,
  TError,
  { data: BodyType<ComplianceCaseInput> },
  TContext
> => {
  const mutationKey = ["opsCreateComplianceCase"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof opsCreateComplianceCase>>,
    { data: BodyType<ComplianceCaseInput> }
  > = (props) => {
    const { data } = props ?? {};

    return opsCreateComplianceCase(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OpsCreateComplianceCaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof opsCreateComplianceCase>>
>;
export type OpsCreateComplianceCaseMutationBody = BodyType<ComplianceCaseInput>;
export type OpsCreateComplianceCaseMutationError =
  ErrorType<UnauthorizedResponse>;

/**
 * @summary Create a compliance case (operator only).
 */
export const useOpsCreateComplianceCase = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsCreateComplianceCase>>,
    TError,
    { data: BodyType<ComplianceCaseInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof opsCreateComplianceCase>>,
  TError,
  { data: BodyType<ComplianceCaseInput> },
  TContext
> => {
  return useMutation(getOpsCreateComplianceCaseMutationOptions(options));
};

/**
 * @summary Get a compliance case with its timeline (operator only).
 */
export const getOpsGetComplianceCaseUrl = (caseId: string) => {
  return `/api/ops/compliance/cases/${caseId}`;
};

export const opsGetComplianceCase = async (
  caseId: string,
  options?: RequestInit,
): Promise<ComplianceCaseDetail> => {
  return customFetch<ComplianceCaseDetail>(getOpsGetComplianceCaseUrl(caseId), {
    ...options,
    method: "GET",
  });
};

export const getOpsGetComplianceCaseQueryKey = (caseId: string) => {
  return [`/api/ops/compliance/cases/${caseId}`] as const;
};

export const getOpsGetComplianceCaseQueryOptions = <
  TData = Awaited<ReturnType<typeof opsGetComplianceCase>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  caseId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof opsGetComplianceCase>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getOpsGetComplianceCaseQueryKey(caseId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof opsGetComplianceCase>>
  > = ({ signal }) =>
    opsGetComplianceCase(caseId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!caseId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof opsGetComplianceCase>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OpsGetComplianceCaseQueryResult = NonNullable<
  Awaited<ReturnType<typeof opsGetComplianceCase>>
>;
export type OpsGetComplianceCaseQueryError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Get a compliance case with its timeline (operator only).
 */

export function useOpsGetComplianceCase<
  TData = Awaited<ReturnType<typeof opsGetComplianceCase>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  caseId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof opsGetComplianceCase>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOpsGetComplianceCaseQueryOptions(caseId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a compliance case (status, severity, category, assignee, beneficiary fields).
 */
export const getOpsUpdateComplianceCaseUrl = (caseId: string) => {
  return `/api/ops/compliance/cases/${caseId}`;
};

export const opsUpdateComplianceCase = async (
  caseId: string,
  complianceCaseUpdateInput: ComplianceCaseUpdateInput,
  options?: RequestInit,
): Promise<ComplianceCaseDetail> => {
  return customFetch<ComplianceCaseDetail>(
    getOpsUpdateComplianceCaseUrl(caseId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(complianceCaseUpdateInput),
    },
  );
};

export const getOpsUpdateComplianceCaseMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsUpdateComplianceCase>>,
    TError,
    { caseId: string; data: BodyType<ComplianceCaseUpdateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof opsUpdateComplianceCase>>,
  TError,
  { caseId: string; data: BodyType<ComplianceCaseUpdateInput> },
  TContext
> => {
  const mutationKey = ["opsUpdateComplianceCase"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof opsUpdateComplianceCase>>,
    { caseId: string; data: BodyType<ComplianceCaseUpdateInput> }
  > = (props) => {
    const { caseId, data } = props ?? {};

    return opsUpdateComplianceCase(caseId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OpsUpdateComplianceCaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof opsUpdateComplianceCase>>
>;
export type OpsUpdateComplianceCaseMutationBody =
  BodyType<ComplianceCaseUpdateInput>;
export type OpsUpdateComplianceCaseMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Update a compliance case (status, severity, category, assignee, beneficiary fields).
 */
export const useOpsUpdateComplianceCase = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsUpdateComplianceCase>>,
    TError,
    { caseId: string; data: BodyType<ComplianceCaseUpdateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof opsUpdateComplianceCase>>,
  TError,
  { caseId: string; data: BodyType<ComplianceCaseUpdateInput> },
  TContext
> => {
  return useMutation(getOpsUpdateComplianceCaseMutationOptions(options));
};

/**
 * @summary Add an internal note to a compliance case (operator only).
 */
export const getOpsAddComplianceCaseNoteUrl = (caseId: string) => {
  return `/api/ops/compliance/cases/${caseId}/notes`;
};

export const opsAddComplianceCaseNote = async (
  caseId: string,
  complianceCaseNoteInput: ComplianceCaseNoteInput,
  options?: RequestInit,
): Promise<ComplianceCaseDetail> => {
  return customFetch<ComplianceCaseDetail>(
    getOpsAddComplianceCaseNoteUrl(caseId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(complianceCaseNoteInput),
    },
  );
};

export const getOpsAddComplianceCaseNoteMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsAddComplianceCaseNote>>,
    TError,
    { caseId: string; data: BodyType<ComplianceCaseNoteInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof opsAddComplianceCaseNote>>,
  TError,
  { caseId: string; data: BodyType<ComplianceCaseNoteInput> },
  TContext
> => {
  const mutationKey = ["opsAddComplianceCaseNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof opsAddComplianceCaseNote>>,
    { caseId: string; data: BodyType<ComplianceCaseNoteInput> }
  > = (props) => {
    const { caseId, data } = props ?? {};

    return opsAddComplianceCaseNote(caseId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OpsAddComplianceCaseNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof opsAddComplianceCaseNote>>
>;
export type OpsAddComplianceCaseNoteMutationBody =
  BodyType<ComplianceCaseNoteInput>;
export type OpsAddComplianceCaseNoteMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Add an internal note to a compliance case (operator only).
 */
export const useOpsAddComplianceCaseNote = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsAddComplianceCaseNote>>,
    TError,
    { caseId: string; data: BodyType<ComplianceCaseNoteInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof opsAddComplianceCaseNote>>,
  TError,
  { caseId: string; data: BodyType<ComplianceCaseNoteInput> },
  TContext
> => {
  return useMutation(getOpsAddComplianceCaseNoteMutationOptions(options));
};

/**
 * @summary Email a status/update message to the customer and record it on the timeline.
 */
export const getOpsSendComplianceCustomerUpdateUrl = (caseId: string) => {
  return `/api/ops/compliance/cases/${caseId}/customer-update`;
};

export const opsSendComplianceCustomerUpdate = async (
  caseId: string,
  complianceCustomerUpdateInput: ComplianceCustomerUpdateInput,
  options?: RequestInit,
): Promise<ComplianceCaseDetail> => {
  return customFetch<ComplianceCaseDetail>(
    getOpsSendComplianceCustomerUpdateUrl(caseId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(complianceCustomerUpdateInput),
    },
  );
};

export const getOpsSendComplianceCustomerUpdateMutationOptions = <
  TError = ErrorType<ErrorResponse | UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsSendComplianceCustomerUpdate>>,
    TError,
    { caseId: string; data: BodyType<ComplianceCustomerUpdateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof opsSendComplianceCustomerUpdate>>,
  TError,
  { caseId: string; data: BodyType<ComplianceCustomerUpdateInput> },
  TContext
> => {
  const mutationKey = ["opsSendComplianceCustomerUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof opsSendComplianceCustomerUpdate>>,
    { caseId: string; data: BodyType<ComplianceCustomerUpdateInput> }
  > = (props) => {
    const { caseId, data } = props ?? {};

    return opsSendComplianceCustomerUpdate(caseId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OpsSendComplianceCustomerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof opsSendComplianceCustomerUpdate>>
>;
export type OpsSendComplianceCustomerUpdateMutationBody =
  BodyType<ComplianceCustomerUpdateInput>;
export type OpsSendComplianceCustomerUpdateMutationError = ErrorType<
  ErrorResponse | UnauthorizedResponse | void
>;

/**
 * @summary Email a status/update message to the customer and record it on the timeline.
 */
export const useOpsSendComplianceCustomerUpdate = <
  TError = ErrorType<ErrorResponse | UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsSendComplianceCustomerUpdate>>,
    TError,
    { caseId: string; data: BodyType<ComplianceCustomerUpdateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof opsSendComplianceCustomerUpdate>>,
  TError,
  { caseId: string; data: BodyType<ComplianceCustomerUpdateInput> },
  TContext
> => {
  return useMutation(
    getOpsSendComplianceCustomerUpdateMutationOptions(options),
  );
};

/**
 * @summary Get the BCDR runbook (operator only).
 */
export const getOpsGetComplianceRunbookUrl = () => {
  return `/api/ops/compliance/runbook`;
};

export const opsGetComplianceRunbook = async (
  options?: RequestInit,
): Promise<ComplianceRunbook> => {
  return customFetch<ComplianceRunbook>(getOpsGetComplianceRunbookUrl(), {
    ...options,
    method: "GET",
  });
};

export const getOpsGetComplianceRunbookQueryKey = () => {
  return [`/api/ops/compliance/runbook`] as const;
};

export const getOpsGetComplianceRunbookQueryOptions = <
  TData = Awaited<ReturnType<typeof opsGetComplianceRunbook>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof opsGetComplianceRunbook>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getOpsGetComplianceRunbookQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof opsGetComplianceRunbook>>
  > = ({ signal }) => opsGetComplianceRunbook({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof opsGetComplianceRunbook>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OpsGetComplianceRunbookQueryResult = NonNullable<
  Awaited<ReturnType<typeof opsGetComplianceRunbook>>
>;
export type OpsGetComplianceRunbookQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Get the BCDR runbook (operator only).
 */

export function useOpsGetComplianceRunbook<
  TData = Awaited<ReturnType<typeof opsGetComplianceRunbook>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof opsGetComplianceRunbook>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOpsGetComplianceRunbookQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update the BCDR runbook (operator only). Edits are audit-logged.
 */
export const getOpsUpdateComplianceRunbookUrl = () => {
  return `/api/ops/compliance/runbook`;
};

export const opsUpdateComplianceRunbook = async (
  complianceRunbookInput: ComplianceRunbookInput,
  options?: RequestInit,
): Promise<ComplianceRunbook> => {
  return customFetch<ComplianceRunbook>(getOpsUpdateComplianceRunbookUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(complianceRunbookInput),
  });
};

export const getOpsUpdateComplianceRunbookMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsUpdateComplianceRunbook>>,
    TError,
    { data: BodyType<ComplianceRunbookInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof opsUpdateComplianceRunbook>>,
  TError,
  { data: BodyType<ComplianceRunbookInput> },
  TContext
> => {
  const mutationKey = ["opsUpdateComplianceRunbook"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof opsUpdateComplianceRunbook>>,
    { data: BodyType<ComplianceRunbookInput> }
  > = (props) => {
    const { data } = props ?? {};

    return opsUpdateComplianceRunbook(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OpsUpdateComplianceRunbookMutationResult = NonNullable<
  Awaited<ReturnType<typeof opsUpdateComplianceRunbook>>
>;
export type OpsUpdateComplianceRunbookMutationBody =
  BodyType<ComplianceRunbookInput>;
export type OpsUpdateComplianceRunbookMutationError =
  ErrorType<UnauthorizedResponse>;

/**
 * @summary Update the BCDR runbook (operator only). Edits are audit-logged.
 */
export const useOpsUpdateComplianceRunbook = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsUpdateComplianceRunbook>>,
    TError,
    { data: BodyType<ComplianceRunbookInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof opsUpdateComplianceRunbook>>,
  TError,
  { data: BodyType<ComplianceRunbookInput> },
  TContext
> => {
  return useMutation(getOpsUpdateComplianceRunbookMutationOptions(options));
};

/**
 * @summary List the versioned BCDR runbook change history (operator only).
 */
export const getOpsGetComplianceRunbookHistoryUrl = () => {
  return `/api/ops/compliance/runbook/history`;
};

export const opsGetComplianceRunbookHistory = async (
  options?: RequestInit,
): Promise<ComplianceRunbookHistoryEntry[]> => {
  return customFetch<ComplianceRunbookHistoryEntry[]>(
    getOpsGetComplianceRunbookHistoryUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getOpsGetComplianceRunbookHistoryQueryKey = () => {
  return [`/api/ops/compliance/runbook/history`] as const;
};

export const getOpsGetComplianceRunbookHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof opsGetComplianceRunbookHistory>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof opsGetComplianceRunbookHistory>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getOpsGetComplianceRunbookHistoryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof opsGetComplianceRunbookHistory>>
  > = ({ signal }) =>
    opsGetComplianceRunbookHistory({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof opsGetComplianceRunbookHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OpsGetComplianceRunbookHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof opsGetComplianceRunbookHistory>>
>;
export type OpsGetComplianceRunbookHistoryQueryError =
  ErrorType<UnauthorizedResponse>;

/**
 * @summary List the versioned BCDR runbook change history (operator only).
 */

export function useOpsGetComplianceRunbookHistory<
  TData = Awaited<ReturnType<typeof opsGetComplianceRunbookHistory>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof opsGetComplianceRunbookHistory>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOpsGetComplianceRunbookHistoryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Public — load co-branded landing data for a client verification link.
 */
export const getGetVerifyContextUrl = (slug: string, token: string) => {
  return `/api/verify/${slug}/${token}`;
};

export const getVerifyContext = async (
  slug: string,
  token: string,
  options?: RequestInit,
): Promise<VerifyContext> => {
  return customFetch<VerifyContext>(getGetVerifyContextUrl(slug, token), {
    ...options,
    method: "GET",
  });
};

export const getGetVerifyContextQueryKey = (slug: string, token: string) => {
  return [`/api/verify/${slug}/${token}`] as const;
};

export const getGetVerifyContextQueryOptions = <
  TData = Awaited<ReturnType<typeof getVerifyContext>>,
  TError = ErrorType<void>,
>(
  slug: string,
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVerifyContext>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetVerifyContextQueryKey(slug, token);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVerifyContext>>
  > = ({ signal }) =>
    getVerifyContext(slug, token, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(slug && token),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVerifyContext>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVerifyContextQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVerifyContext>>
>;
export type GetVerifyContextQueryError = ErrorType<void>;

/**
 * @summary Public — load co-branded landing data for a client verification link.
 */

export function useGetVerifyContext<
  TData = Awaited<ReturnType<typeof getVerifyContext>>,
  TError = ErrorType<void>,
>(
  slug: string,
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVerifyContext>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVerifyContextQueryOptions(slug, token, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Public — fetch the list of ConnectID participant banks for the IDP picker.
 */
export const getListVerifyConnectIdParticipantsUrl = (
  slug: string,
  token: string,
) => {
  return `/api/verify/${slug}/${token}/connectid/participants`;
};

export const listVerifyConnectIdParticipants = async (
  slug: string,
  token: string,
  options?: RequestInit,
): Promise<ConnectIdParticipant[]> => {
  return customFetch<ConnectIdParticipant[]>(
    getListVerifyConnectIdParticipantsUrl(slug, token),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListVerifyConnectIdParticipantsQueryKey = (
  slug: string,
  token: string,
) => {
  return [`/api/verify/${slug}/${token}/connectid/participants`] as const;
};

export const getListVerifyConnectIdParticipantsQueryOptions = <
  TData = Awaited<ReturnType<typeof listVerifyConnectIdParticipants>>,
  TError = ErrorType<void>,
>(
  slug: string,
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVerifyConnectIdParticipants>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListVerifyConnectIdParticipantsQueryKey(slug, token);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listVerifyConnectIdParticipants>>
  > = ({ signal }) =>
    listVerifyConnectIdParticipants(slug, token, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(slug && token),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listVerifyConnectIdParticipants>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListVerifyConnectIdParticipantsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVerifyConnectIdParticipants>>
>;
export type ListVerifyConnectIdParticipantsQueryError = ErrorType<void>;

/**
 * @summary Public — fetch the list of ConnectID participant banks for the IDP picker.
 */

export function useListVerifyConnectIdParticipants<
  TData = Awaited<ReturnType<typeof listVerifyConnectIdParticipants>>,
  TError = ErrorType<void>,
>(
  slug: string,
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVerifyConnectIdParticipants>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListVerifyConnectIdParticipantsQueryOptions(
    slug,
    token,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Public — pass-through proxy of the raw ConnectID directory response for the official IDP Selector widget.
 */
export const getGetVerifyConnectIdParticipantsRawUrl = (
  slug: string,
  token: string,
) => {
  return `/api/verify/${slug}/${token}/connectid/participants-raw`;
};

export const getVerifyConnectIdParticipantsRaw = async (
  slug: string,
  token: string,
  options?: RequestInit,
): Promise<GetVerifyConnectIdParticipantsRaw200Item[]> => {
  return customFetch<GetVerifyConnectIdParticipantsRaw200Item[]>(
    getGetVerifyConnectIdParticipantsRawUrl(slug, token),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetVerifyConnectIdParticipantsRawQueryKey = (
  slug: string,
  token: string,
) => {
  return [`/api/verify/${slug}/${token}/connectid/participants-raw`] as const;
};

export const getGetVerifyConnectIdParticipantsRawQueryOptions = <
  TData = Awaited<ReturnType<typeof getVerifyConnectIdParticipantsRaw>>,
  TError = ErrorType<void>,
>(
  slug: string,
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVerifyConnectIdParticipantsRaw>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetVerifyConnectIdParticipantsRawQueryKey(slug, token);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVerifyConnectIdParticipantsRaw>>
  > = ({ signal }) =>
    getVerifyConnectIdParticipantsRaw(slug, token, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(slug && token),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVerifyConnectIdParticipantsRaw>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVerifyConnectIdParticipantsRawQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVerifyConnectIdParticipantsRaw>>
>;
export type GetVerifyConnectIdParticipantsRawQueryError = ErrorType<void>;

/**
 * @summary Public — pass-through proxy of the raw ConnectID directory response for the official IDP Selector widget.
 */

export function useGetVerifyConnectIdParticipantsRaw<
  TData = Awaited<ReturnType<typeof getVerifyConnectIdParticipantsRaw>>,
  TError = ErrorType<void>,
>(
  slug: string,
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVerifyConnectIdParticipantsRaw>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVerifyConnectIdParticipantsRawQueryOptions(
    slug,
    token,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getStartSmsOtpUrl = (slug: string, token: string) => {
  return `/api/verify/${slug}/${token}/start-sms-otp`;
};

export const startSmsOtp = async (
  slug: string,
  token: string,
  options?: RequestInit,
): Promise<SmsOtpStartResponse> => {
  return customFetch<SmsOtpStartResponse>(getStartSmsOtpUrl(slug, token), {
    ...options,
    method: "POST",
  });
};

export const getStartSmsOtpMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startSmsOtp>>,
    TError,
    { slug: string; token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startSmsOtp>>,
  TError,
  { slug: string; token: string },
  TContext
> => {
  const mutationKey = ["startSmsOtp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startSmsOtp>>,
    { slug: string; token: string }
  > = (props) => {
    const { slug, token } = props ?? {};

    return startSmsOtp(slug, token, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartSmsOtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof startSmsOtp>>
>;

export type StartSmsOtpMutationError = ErrorType<void>;

export const useStartSmsOtp = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startSmsOtp>>,
    TError,
    { slug: string; token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof startSmsOtp>>,
  TError,
  { slug: string; token: string },
  TContext
> => {
  return useMutation(getStartSmsOtpMutationOptions(options));
};

export const getVerifySmsOtpUrl = (slug: string, token: string) => {
  return `/api/verify/${slug}/${token}/verify-sms-otp`;
};

export const verifySmsOtp = async (
  slug: string,
  token: string,
  smsOtpVerifyBody: SmsOtpVerifyBody,
  options?: RequestInit,
): Promise<VerifyContext> => {
  return customFetch<VerifyContext>(getVerifySmsOtpUrl(slug, token), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(smsOtpVerifyBody),
  });
};

export const getVerifySmsOtpMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifySmsOtp>>,
    TError,
    { slug: string; token: string; data: BodyType<SmsOtpVerifyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifySmsOtp>>,
  TError,
  { slug: string; token: string; data: BodyType<SmsOtpVerifyBody> },
  TContext
> => {
  const mutationKey = ["verifySmsOtp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifySmsOtp>>,
    { slug: string; token: string; data: BodyType<SmsOtpVerifyBody> }
  > = (props) => {
    const { slug, token, data } = props ?? {};

    return verifySmsOtp(slug, token, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifySmsOtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifySmsOtp>>
>;
export type VerifySmsOtpMutationBody = BodyType<SmsOtpVerifyBody>;
export type VerifySmsOtpMutationError = ErrorType<void>;

export const useVerifySmsOtp = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifySmsOtp>>,
    TError,
    { slug: string; token: string; data: BodyType<SmsOtpVerifyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verifySmsOtp>>,
  TError,
  { slug: string; token: string; data: BodyType<SmsOtpVerifyBody> },
  TContext
> => {
  return useMutation(getVerifySmsOtpMutationOptions(options));
};

export const getStartVerifyIdUrl = (slug: string, token: string) => {
  return `/api/verify/${slug}/${token}/start-id`;
};

export const startVerifyId = async (
  slug: string,
  token: string,
  startIdBody: StartIdBody,
  options?: RequestInit,
): Promise<StartVerifyIdResponse> => {
  return customFetch<StartVerifyIdResponse>(getStartVerifyIdUrl(slug, token), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(startIdBody),
  });
};

export const getStartVerifyIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startVerifyId>>,
    TError,
    { slug: string; token: string; data: BodyType<StartIdBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startVerifyId>>,
  TError,
  { slug: string; token: string; data: BodyType<StartIdBody> },
  TContext
> => {
  const mutationKey = ["startVerifyId"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startVerifyId>>,
    { slug: string; token: string; data: BodyType<StartIdBody> }
  > = (props) => {
    const { slug, token, data } = props ?? {};

    return startVerifyId(slug, token, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartVerifyIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof startVerifyId>>
>;
export type StartVerifyIdMutationBody = BodyType<StartIdBody>;
export type StartVerifyIdMutationError = ErrorType<unknown>;

export const useStartVerifyId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startVerifyId>>,
    TError,
    { slug: string; token: string; data: BodyType<StartIdBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof startVerifyId>>,
  TError,
  { slug: string; token: string; data: BodyType<StartIdBody> },
  TContext
> => {
  return useMutation(getStartVerifyIdMutationOptions(options));
};

export const getSubmitVerifyUrl = (slug: string, token: string) => {
  return `/api/verify/${slug}/${token}/submit`;
};

export const submitVerify = async (
  slug: string,
  token: string,
  submitVerifyBody: SubmitVerifyBody,
  options?: RequestInit,
): Promise<VerifyContext> => {
  return customFetch<VerifyContext>(getSubmitVerifyUrl(slug, token), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(submitVerifyBody),
  });
};

export const getSubmitVerifyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitVerify>>,
    TError,
    { slug: string; token: string; data: BodyType<SubmitVerifyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitVerify>>,
  TError,
  { slug: string; token: string; data: BodyType<SubmitVerifyBody> },
  TContext
> => {
  const mutationKey = ["submitVerify"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitVerify>>,
    { slug: string; token: string; data: BodyType<SubmitVerifyBody> }
  > = (props) => {
    const { slug, token, data } = props ?? {};

    return submitVerify(slug, token, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitVerifyMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitVerify>>
>;
export type SubmitVerifyMutationBody = BodyType<SubmitVerifyBody>;
export type SubmitVerifyMutationError = ErrorType<unknown>;

export const useSubmitVerify = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitVerify>>,
    TError,
    { slug: string; token: string; data: BodyType<SubmitVerifyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof submitVerify>>,
  TError,
  { slug: string; token: string; data: BodyType<SubmitVerifyBody> },
  TContext
> => {
  return useMutation(getSubmitVerifyMutationOptions(options));
};

export const getReissueVerifyLinkUrl = (slug: string, token: string) => {
  return `/api/verify/${slug}/${token}/reissue`;
};

export const reissueVerifyLink = async (
  slug: string,
  token: string,
  options?: RequestInit,
): Promise<ReissueVerifyResponse> => {
  return customFetch<ReissueVerifyResponse>(
    getReissueVerifyLinkUrl(slug, token),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getReissueVerifyLinkMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reissueVerifyLink>>,
    TError,
    { slug: string; token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reissueVerifyLink>>,
  TError,
  { slug: string; token: string },
  TContext
> => {
  const mutationKey = ["reissueVerifyLink"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reissueVerifyLink>>,
    { slug: string; token: string }
  > = (props) => {
    const { slug, token } = props ?? {};

    return reissueVerifyLink(slug, token, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReissueVerifyLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof reissueVerifyLink>>
>;

export type ReissueVerifyLinkMutationError = ErrorType<unknown>;

export const useReissueVerifyLink = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reissueVerifyLink>>,
    TError,
    { slug: string; token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reissueVerifyLink>>,
  TError,
  { slug: string; token: string },
  TContext
> => {
  return useMutation(getReissueVerifyLinkMutationOptions(options));
};

/**
 * @summary Active platform notices (incidents / maintenance / breaches) targeting this workspace, for the in-app banner.
 */
export const getListWorkspaceNoticesUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/notices`;
};

export const listWorkspaceNotices = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<WorkspaceNotice[]> => {
  return customFetch<WorkspaceNotice[]>(
    getListWorkspaceNoticesUrl(workspaceId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListWorkspaceNoticesQueryKey = (workspaceId: string) => {
  return [`/api/workspaces/${workspaceId}/notices`] as const;
};

export const getListWorkspaceNoticesQueryOptions = <
  TData = Awaited<ReturnType<typeof listWorkspaceNotices>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWorkspaceNotices>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListWorkspaceNoticesQueryKey(workspaceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWorkspaceNotices>>
  > = ({ signal }) =>
    listWorkspaceNotices(workspaceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listWorkspaceNotices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListWorkspaceNoticesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspaceNotices>>
>;
export type ListWorkspaceNoticesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Active platform notices (incidents / maintenance / breaches) targeting this workspace, for the in-app banner.
 */

export function useListWorkspaceNotices<
  TData = Awaited<ReturnType<typeof listWorkspaceNotices>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWorkspaceNotices>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListWorkspaceNoticesQueryOptions(
    workspaceId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Suspected-fraud reports raised by this workspace.
 */
export const getListWorkspaceFraudReportsUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/fraud-reports`;
};

export const listWorkspaceFraudReports = async (
  workspaceId: string,
  options?: RequestInit,
): Promise<FraudReport[]> => {
  return customFetch<FraudReport[]>(
    getListWorkspaceFraudReportsUrl(workspaceId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListWorkspaceFraudReportsQueryKey = (workspaceId: string) => {
  return [`/api/workspaces/${workspaceId}/fraud-reports`] as const;
};

export const getListWorkspaceFraudReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof listWorkspaceFraudReports>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWorkspaceFraudReports>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListWorkspaceFraudReportsQueryKey(workspaceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWorkspaceFraudReports>>
  > = ({ signal }) =>
    listWorkspaceFraudReports(workspaceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listWorkspaceFraudReports>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListWorkspaceFraudReportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspaceFraudReports>>
>;
export type ListWorkspaceFraudReportsQueryError =
  ErrorType<UnauthorizedResponse>;

/**
 * @summary Suspected-fraud reports raised by this workspace.
 */

export function useListWorkspaceFraudReports<
  TData = Awaited<ReturnType<typeof listWorkspaceFraudReports>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  workspaceId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWorkspaceFraudReports>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListWorkspaceFraudReportsQueryOptions(
    workspaceId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Report suspected fraud to FortifyID (the ConnectID Representative).
 */
export const getCreateFraudReportUrl = (workspaceId: string) => {
  return `/api/workspaces/${workspaceId}/fraud-reports`;
};

export const createFraudReport = async (
  workspaceId: string,
  fraudReportInput: FraudReportInput,
  options?: RequestInit,
): Promise<FraudReport> => {
  return customFetch<FraudReport>(getCreateFraudReportUrl(workspaceId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(fraudReportInput),
  });
};

export const getCreateFraudReportMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFraudReport>>,
    TError,
    { workspaceId: string; data: BodyType<FraudReportInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFraudReport>>,
  TError,
  { workspaceId: string; data: BodyType<FraudReportInput> },
  TContext
> => {
  const mutationKey = ["createFraudReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFraudReport>>,
    { workspaceId: string; data: BodyType<FraudReportInput> }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return createFraudReport(workspaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFraudReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFraudReport>>
>;
export type CreateFraudReportMutationBody = BodyType<FraudReportInput>;
export type CreateFraudReportMutationError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Report suspected fraud to FortifyID (the ConnectID Representative).
 */
export const useCreateFraudReport = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFraudReport>>,
    TError,
    { workspaceId: string; data: BodyType<FraudReportInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createFraudReport>>,
  TError,
  { workspaceId: string; data: BodyType<FraudReportInput> },
  TContext
> => {
  return useMutation(getCreateFraudReportMutationOptions(options));
};

/**
 * @summary List all platform notices with delivery counts (operator only).
 */
export const getOpsListNoticesUrl = () => {
  return `/api/ops/notices`;
};

export const opsListNotices = async (
  options?: RequestInit,
): Promise<OpsNoticeRow[]> => {
  return customFetch<OpsNoticeRow[]>(getOpsListNoticesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getOpsListNoticesQueryKey = () => {
  return [`/api/ops/notices`] as const;
};

export const getOpsListNoticesQueryOptions = <
  TData = Awaited<ReturnType<typeof opsListNotices>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof opsListNotices>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOpsListNoticesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof opsListNotices>>> = ({
    signal,
  }) => opsListNotices({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof opsListNotices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OpsListNoticesQueryResult = NonNullable<
  Awaited<ReturnType<typeof opsListNotices>>
>;
export type OpsListNoticesQueryError = ErrorType<unknown>;

/**
 * @summary List all platform notices with delivery counts (operator only).
 */

export function useOpsListNotices<
  TData = Awaited<ReturnType<typeof opsListNotices>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof opsListNotices>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOpsListNoticesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a platform notice draft (operator only).
 */
export const getOpsCreateNoticeUrl = () => {
  return `/api/ops/notices`;
};

export const opsCreateNotice = async (
  noticeInput: NoticeInput,
  options?: RequestInit,
): Promise<OpsNoticeRow> => {
  return customFetch<OpsNoticeRow>(getOpsCreateNoticeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(noticeInput),
  });
};

export const getOpsCreateNoticeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsCreateNotice>>,
    TError,
    { data: BodyType<NoticeInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof opsCreateNotice>>,
  TError,
  { data: BodyType<NoticeInput> },
  TContext
> => {
  const mutationKey = ["opsCreateNotice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof opsCreateNotice>>,
    { data: BodyType<NoticeInput> }
  > = (props) => {
    const { data } = props ?? {};

    return opsCreateNotice(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OpsCreateNoticeMutationResult = NonNullable<
  Awaited<ReturnType<typeof opsCreateNotice>>
>;
export type OpsCreateNoticeMutationBody = BodyType<NoticeInput>;
export type OpsCreateNoticeMutationError = ErrorType<unknown>;

/**
 * @summary Create a platform notice draft (operator only).
 */
export const useOpsCreateNotice = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsCreateNotice>>,
    TError,
    { data: BodyType<NoticeInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof opsCreateNotice>>,
  TError,
  { data: BodyType<NoticeInput> },
  TContext
> => {
  return useMutation(getOpsCreateNoticeMutationOptions(options));
};

/**
 * @summary Edit a platform notice (operator only).
 */
export const getOpsUpdateNoticeUrl = (noticeId: string) => {
  return `/api/ops/notices/${noticeId}`;
};

export const opsUpdateNotice = async (
  noticeId: string,
  noticeUpdate: NoticeUpdate,
  options?: RequestInit,
): Promise<OpsNoticeRow> => {
  return customFetch<OpsNoticeRow>(getOpsUpdateNoticeUrl(noticeId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(noticeUpdate),
  });
};

export const getOpsUpdateNoticeMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsUpdateNotice>>,
    TError,
    { noticeId: string; data: BodyType<NoticeUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof opsUpdateNotice>>,
  TError,
  { noticeId: string; data: BodyType<NoticeUpdate> },
  TContext
> => {
  const mutationKey = ["opsUpdateNotice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof opsUpdateNotice>>,
    { noticeId: string; data: BodyType<NoticeUpdate> }
  > = (props) => {
    const { noticeId, data } = props ?? {};

    return opsUpdateNotice(noticeId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OpsUpdateNoticeMutationResult = NonNullable<
  Awaited<ReturnType<typeof opsUpdateNotice>>
>;
export type OpsUpdateNoticeMutationBody = BodyType<NoticeUpdate>;
export type OpsUpdateNoticeMutationError = ErrorType<void>;

/**
 * @summary Edit a platform notice (operator only).
 */
export const useOpsUpdateNotice = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsUpdateNotice>>,
    TError,
    { noticeId: string; data: BodyType<NoticeUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof opsUpdateNotice>>,
  TError,
  { noticeId: string; data: BodyType<NoticeUpdate> },
  TContext
> => {
  return useMutation(getOpsUpdateNoticeMutationOptions(options));
};

/**
 * @summary Publish a notice to its targeted Beneficiary workspaces — materialises delivery records and emails workspace admins (operator only).
 */
export const getOpsPublishNoticeUrl = (noticeId: string) => {
  return `/api/ops/notices/${noticeId}/publish`;
};

export const opsPublishNotice = async (
  noticeId: string,
  options?: RequestInit,
): Promise<OpsNoticeRow> => {
  return customFetch<OpsNoticeRow>(getOpsPublishNoticeUrl(noticeId), {
    ...options,
    method: "POST",
  });
};

export const getOpsPublishNoticeMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsPublishNotice>>,
    TError,
    { noticeId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof opsPublishNotice>>,
  TError,
  { noticeId: string },
  TContext
> => {
  const mutationKey = ["opsPublishNotice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof opsPublishNotice>>,
    { noticeId: string }
  > = (props) => {
    const { noticeId } = props ?? {};

    return opsPublishNotice(noticeId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OpsPublishNoticeMutationResult = NonNullable<
  Awaited<ReturnType<typeof opsPublishNotice>>
>;

export type OpsPublishNoticeMutationError = ErrorType<void>;

/**
 * @summary Publish a notice to its targeted Beneficiary workspaces — materialises delivery records and emails workspace admins (operator only).
 */
export const useOpsPublishNotice = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsPublishNotice>>,
    TError,
    { noticeId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof opsPublishNotice>>,
  TError,
  { noticeId: string },
  TContext
> => {
  return useMutation(getOpsPublishNoticeMutationOptions(options));
};

/**
 * @summary Mark a notice resolved / completed (operator only).
 */
export const getOpsResolveNoticeUrl = (noticeId: string) => {
  return `/api/ops/notices/${noticeId}/resolve`;
};

export const opsResolveNotice = async (
  noticeId: string,
  options?: RequestInit,
): Promise<OpsNoticeRow> => {
  return customFetch<OpsNoticeRow>(getOpsResolveNoticeUrl(noticeId), {
    ...options,
    method: "POST",
  });
};

export const getOpsResolveNoticeMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsResolveNotice>>,
    TError,
    { noticeId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof opsResolveNotice>>,
  TError,
  { noticeId: string },
  TContext
> => {
  const mutationKey = ["opsResolveNotice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof opsResolveNotice>>,
    { noticeId: string }
  > = (props) => {
    const { noticeId } = props ?? {};

    return opsResolveNotice(noticeId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OpsResolveNoticeMutationResult = NonNullable<
  Awaited<ReturnType<typeof opsResolveNotice>>
>;

export type OpsResolveNoticeMutationError = ErrorType<void>;

/**
 * @summary Mark a notice resolved / completed (operator only).
 */
export const useOpsResolveNotice = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsResolveNotice>>,
    TError,
    { noticeId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof opsResolveNotice>>,
  TError,
  { noticeId: string },
  TContext
> => {
  return useMutation(getOpsResolveNoticeMutationOptions(options));
};

/**
 * @summary List suspected-fraud reports across all workspaces (operator only).
 */
export const getOpsListFraudReportsUrl = (
  params?: OpsListFraudReportsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ops/fraud-reports?${stringifiedParams}`
    : `/api/ops/fraud-reports`;
};

export const opsListFraudReports = async (
  params?: OpsListFraudReportsParams,
  options?: RequestInit,
): Promise<OpsFraudReportRow[]> => {
  return customFetch<OpsFraudReportRow[]>(getOpsListFraudReportsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getOpsListFraudReportsQueryKey = (
  params?: OpsListFraudReportsParams,
) => {
  return [`/api/ops/fraud-reports`, ...(params ? [params] : [])] as const;
};

export const getOpsListFraudReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof opsListFraudReports>>,
  TError = ErrorType<unknown>,
>(
  params?: OpsListFraudReportsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof opsListFraudReports>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getOpsListFraudReportsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof opsListFraudReports>>
  > = ({ signal }) =>
    opsListFraudReports(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof opsListFraudReports>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OpsListFraudReportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof opsListFraudReports>>
>;
export type OpsListFraudReportsQueryError = ErrorType<unknown>;

/**
 * @summary List suspected-fraud reports across all workspaces (operator only).
 */

export function useOpsListFraudReports<
  TData = Awaited<ReturnType<typeof opsListFraudReports>>,
  TError = ErrorType<unknown>,
>(
  params?: OpsListFraudReportsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof opsListFraudReports>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOpsListFraudReportsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update the investigation status of a fraud report (operator only).
 */
export const getOpsUpdateFraudReportStatusUrl = (reportId: string) => {
  return `/api/ops/fraud-reports/${reportId}/status`;
};

export const opsUpdateFraudReportStatus = async (
  reportId: string,
  fraudReportStatusUpdate: FraudReportStatusUpdate,
  options?: RequestInit,
): Promise<OpsFraudReportRow> => {
  return customFetch<OpsFraudReportRow>(
    getOpsUpdateFraudReportStatusUrl(reportId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(fraudReportStatusUpdate),
    },
  );
};

export const getOpsUpdateFraudReportStatusMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsUpdateFraudReportStatus>>,
    TError,
    { reportId: string; data: BodyType<FraudReportStatusUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof opsUpdateFraudReportStatus>>,
  TError,
  { reportId: string; data: BodyType<FraudReportStatusUpdate> },
  TContext
> => {
  const mutationKey = ["opsUpdateFraudReportStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof opsUpdateFraudReportStatus>>,
    { reportId: string; data: BodyType<FraudReportStatusUpdate> }
  > = (props) => {
    const { reportId, data } = props ?? {};

    return opsUpdateFraudReportStatus(reportId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OpsUpdateFraudReportStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof opsUpdateFraudReportStatus>>
>;
export type OpsUpdateFraudReportStatusMutationBody =
  BodyType<FraudReportStatusUpdate>;
export type OpsUpdateFraudReportStatusMutationError = ErrorType<void>;

/**
 * @summary Update the investigation status of a fraud report (operator only).
 */
export const useOpsUpdateFraudReportStatus = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof opsUpdateFraudReportStatus>>,
    TError,
    { reportId: string; data: BodyType<FraudReportStatusUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof opsUpdateFraudReportStatus>>,
  TError,
  { reportId: string; data: BodyType<FraudReportStatusUpdate> },
  TContext
> => {
  return useMutation(getOpsUpdateFraudReportStatusMutationOptions(options));
};

/**
 * @summary List audit log entries across all workspaces (operator only).
 */
export const getOpsListAuditLogUrl = (params?: OpsListAuditLogParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ops/audit-log?${stringifiedParams}`
    : `/api/ops/audit-log`;
};

export const opsListAuditLog = async (
  params?: OpsListAuditLogParams,
  options?: RequestInit,
): Promise<OpsAuditLogRow[]> => {
  return customFetch<OpsAuditLogRow[]>(getOpsListAuditLogUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getOpsListAuditLogQueryKey = (params?: OpsListAuditLogParams) => {
  return [`/api/ops/audit-log`, ...(params ? [params] : [])] as const;
};

export const getOpsListAuditLogQueryOptions = <
  TData = Awaited<ReturnType<typeof opsListAuditLog>>,
  TError = ErrorType<void | UnauthorizedResponse>,
>(
  params?: OpsListAuditLogParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof opsListAuditLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOpsListAuditLogQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof opsListAuditLog>>> = ({
    signal,
  }) => opsListAuditLog(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof opsListAuditLog>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OpsListAuditLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof opsListAuditLog>>
>;
export type OpsListAuditLogQueryError = ErrorType<void | UnauthorizedResponse>;

/**
 * @summary List audit log entries across all workspaces (operator only).
 */

export function useOpsListAuditLog<
  TData = Awaited<ReturnType<typeof opsListAuditLog>>,
  TError = ErrorType<void | UnauthorizedResponse>,
>(
  params?: OpsListAuditLogParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof opsListAuditLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOpsListAuditLogQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Beneficiary oversight — per-workspace compliance signals (operator only).
 */
export const getOpsGetOversightUrl = () => {
  return `/api/ops/oversight`;
};

export const opsGetOversight = async (
  options?: RequestInit,
): Promise<OversightRow[]> => {
  return customFetch<OversightRow[]>(getOpsGetOversightUrl(), {
    ...options,
    method: "GET",
  });
};

export const getOpsGetOversightQueryKey = () => {
  return [`/api/ops/oversight`] as const;
};

export const getOpsGetOversightQueryOptions = <
  TData = Awaited<ReturnType<typeof opsGetOversight>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof opsGetOversight>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOpsGetOversightQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof opsGetOversight>>> = ({
    signal,
  }) => opsGetOversight({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof opsGetOversight>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OpsGetOversightQueryResult = NonNullable<
  Awaited<ReturnType<typeof opsGetOversight>>
>;
export type OpsGetOversightQueryError = ErrorType<unknown>;

/**
 * @summary Beneficiary oversight — per-workspace compliance signals (operator only).
 */

export function useOpsGetOversight<
  TData = Awaited<ReturnType<typeof opsGetOversight>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof opsGetOversight>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOpsGetOversightQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Submit a bug report or feature request (any authenticated staff user).
 */
export const getSubmitFeedbackUrl = () => {
  return `/api/feedback`;
};

export const submitFeedback = async (
  submitFeedbackBody: SubmitFeedbackBody,
  options?: RequestInit,
): Promise<FeedbackItem> => {
  return customFetch<FeedbackItem>(getSubmitFeedbackUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(submitFeedbackBody),
  });
};

export const getSubmitFeedbackMutationOptions = <
  TError = ErrorType<ErrorResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitFeedback>>,
    TError,
    { data: BodyType<SubmitFeedbackBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitFeedback>>,
  TError,
  { data: BodyType<SubmitFeedbackBody> },
  TContext
> => {
  const mutationKey = ["submitFeedback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitFeedback>>,
    { data: BodyType<SubmitFeedbackBody> }
  > = (props) => {
    const { data } = props ?? {};

    return submitFeedback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitFeedback>>
>;
export type SubmitFeedbackMutationBody = BodyType<SubmitFeedbackBody>;
export type SubmitFeedbackMutationError = ErrorType<
  ErrorResponse | UnauthorizedResponse
>;

/**
 * @summary Submit a bug report or feature request (any authenticated staff user).
 */
export const useSubmitFeedback = <
  TError = ErrorType<ErrorResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitFeedback>>,
    TError,
    { data: BodyType<SubmitFeedbackBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof submitFeedback>>,
  TError,
  { data: BodyType<SubmitFeedbackBody> },
  TContext
> => {
  return useMutation(getSubmitFeedbackMutationOptions(options));
};

/**
 * @summary List all feedback items (operator only). Filterable by type and status.
 */
export const getGetOpsFeedbackUrl = (params?: GetOpsFeedbackParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ops/feedback?${stringifiedParams}`
    : `/api/ops/feedback`;
};

export const getOpsFeedback = async (
  params?: GetOpsFeedbackParams,
  options?: RequestInit,
): Promise<FeedbackItem[]> => {
  return customFetch<FeedbackItem[]>(getGetOpsFeedbackUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetOpsFeedbackQueryKey = (params?: GetOpsFeedbackParams) => {
  return [`/api/ops/feedback`, ...(params ? [params] : [])] as const;
};

export const getGetOpsFeedbackQueryOptions = <
  TData = Awaited<ReturnType<typeof getOpsFeedback>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  params?: GetOpsFeedbackParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOpsFeedback>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOpsFeedbackQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpsFeedback>>> = ({
    signal,
  }) => getOpsFeedback(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOpsFeedback>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOpsFeedbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOpsFeedback>>
>;
export type GetOpsFeedbackQueryError = ErrorType<UnauthorizedResponse | void>;

/**
 * @summary List all feedback items (operator only). Filterable by type and status.
 */

export function useGetOpsFeedback<
  TData = Awaited<ReturnType<typeof getOpsFeedback>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  params?: GetOpsFeedbackParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOpsFeedback>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOpsFeedbackQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a feedback item's status and optional note (operator only).
 */
export const getPatchOpsFeedbackUrl = (feedbackId: string) => {
  return `/api/ops/feedback/${feedbackId}`;
};

export const patchOpsFeedback = async (
  feedbackId: string,
  patchFeedbackBody: PatchFeedbackBody,
  options?: RequestInit,
): Promise<FeedbackItem> => {
  return customFetch<FeedbackItem>(getPatchOpsFeedbackUrl(feedbackId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(patchFeedbackBody),
  });
};

export const getPatchOpsFeedbackMutationOptions = <
  TError = ErrorType<ErrorResponse | UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchOpsFeedback>>,
    TError,
    { feedbackId: string; data: BodyType<PatchFeedbackBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchOpsFeedback>>,
  TError,
  { feedbackId: string; data: BodyType<PatchFeedbackBody> },
  TContext
> => {
  const mutationKey = ["patchOpsFeedback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchOpsFeedback>>,
    { feedbackId: string; data: BodyType<PatchFeedbackBody> }
  > = (props) => {
    const { feedbackId, data } = props ?? {};

    return patchOpsFeedback(feedbackId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchOpsFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchOpsFeedback>>
>;
export type PatchOpsFeedbackMutationBody = BodyType<PatchFeedbackBody>;
export type PatchOpsFeedbackMutationError = ErrorType<
  ErrorResponse | UnauthorizedResponse | void
>;

/**
 * @summary Update a feedback item's status and optional note (operator only).
 */
export const usePatchOpsFeedback = <
  TError = ErrorType<ErrorResponse | UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchOpsFeedback>>,
    TError,
    { feedbackId: string; data: BodyType<PatchFeedbackBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchOpsFeedback>>,
  TError,
  { feedbackId: string; data: BodyType<PatchFeedbackBody> },
  TContext
> => {
  return useMutation(getPatchOpsFeedbackMutationOptions(options));
};

/**
 * @summary Look up an Australian BSB number. Returns bank, branch, and location. No auth required — the data is public.
 */
export const getLookupBsbUrl = (bsb: string) => {
  return `/api/bsb/${bsb}`;
};

export const lookupBsb = async (
  bsb: string,
  options?: RequestInit,
): Promise<BsbEntry> => {
  return customFetch<BsbEntry>(getLookupBsbUrl(bsb), {
    ...options,
    method: "GET",
  });
};

export const getLookupBsbQueryKey = (bsb: string) => {
  return [`/api/bsb/${bsb}`] as const;
};

export const getLookupBsbQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupBsb>>,
  TError = ErrorType<ErrorResponse>,
>(
  bsb: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof lookupBsb>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLookupBsbQueryKey(bsb);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof lookupBsb>>> = ({
    signal,
  }) => lookupBsb(bsb, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!bsb,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof lookupBsb>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type LookupBsbQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupBsb>>
>;
export type LookupBsbQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Look up an Australian BSB number. Returns bank, branch, and location. No auth required — the data is public.
 */

export function useLookupBsb<
  TData = Awaited<ReturnType<typeof lookupBsb>>,
  TError = ErrorType<ErrorResponse>,
>(
  bsb: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof lookupBsb>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLookupBsbQueryOptions(bsb, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Request a presigned URL for file upload
 */
export const getRequestUploadUrlUrl = () => {
  return `/api/storage/uploads/request-url`;
};

export const requestUploadUrl = async (
  uploadUrlRequest: UploadUrlRequest,
  options?: RequestInit,
): Promise<UploadUrlResponse> => {
  return customFetch<UploadUrlResponse>(getRequestUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(uploadUrlRequest),
  });
};

export const getRequestUploadUrlMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  const mutationKey = ["requestUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    { data: BodyType<UploadUrlRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return requestUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestUploadUrl>>
>;
export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>;
export type RequestUploadUrlMutationError = ErrorType<void>;

/**
 * @summary Request a presigned URL for file upload
 */
export const useRequestUploadUrl = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  return useMutation(getRequestUploadUrlMutationOptions(options));
};

/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */
export const getGetStorageObjectUrl = (objectPath: string) => {
  return `/api/storage/objects/${objectPath}`;
};

export const getStorageObject = async (
  objectPath: string,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetStorageObjectUrl(objectPath), {
    ...options,
    method: "GET",
  });
};

export const getGetStorageObjectQueryKey = (objectPath: string) => {
  return [`/api/storage/objects/${objectPath}`] as const;
};

export const getGetStorageObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<void>,
>(
  objectPath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStorageObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStorageObject>>
  > = ({ signal }) =>
    getStorageObject(objectPath, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!objectPath,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorageObject>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStorageObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStorageObject>>
>;
export type GetStorageObjectQueryError = ErrorType<void>;

/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */

export function useGetStorageObject<
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<void>,
>(
  objectPath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStorageObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStorageObjectQueryOptions(objectPath, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all CRM contacts (operator only).
 */
export const getCrmListContactsUrl = (params?: CrmListContactsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ops/crm/contacts?${stringifiedParams}`
    : `/api/ops/crm/contacts`;
};

export const crmListContacts = async (
  params?: CrmListContactsParams,
  options?: RequestInit,
): Promise<CrmContact[]> => {
  return customFetch<CrmContact[]>(getCrmListContactsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getCrmListContactsQueryKey = (params?: CrmListContactsParams) => {
  return [`/api/ops/crm/contacts`, ...(params ? [params] : [])] as const;
};

export const getCrmListContactsQueryOptions = <
  TData = Awaited<ReturnType<typeof crmListContacts>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: CrmListContactsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmListContacts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCrmListContactsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof crmListContacts>>> = ({
    signal,
  }) => crmListContacts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof crmListContacts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CrmListContactsQueryResult = NonNullable<
  Awaited<ReturnType<typeof crmListContacts>>
>;
export type CrmListContactsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List all CRM contacts (operator only).
 */

export function useCrmListContacts<
  TData = Awaited<ReturnType<typeof crmListContacts>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: CrmListContactsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmListContacts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCrmListContactsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single CRM contact with their unified timeline (operator only).
 */
export const getCrmGetContactUrl = (email: string) => {
  return `/api/ops/crm/contacts/${email}`;
};

export const crmGetContact = async (
  email: string,
  options?: RequestInit,
): Promise<CrmContactDetail> => {
  return customFetch<CrmContactDetail>(getCrmGetContactUrl(email), {
    ...options,
    method: "GET",
  });
};

export const getCrmGetContactQueryKey = (email: string) => {
  return [`/api/ops/crm/contacts/${email}`] as const;
};

export const getCrmGetContactQueryOptions = <
  TData = Awaited<ReturnType<typeof crmGetContact>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  email: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmGetContact>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCrmGetContactQueryKey(email);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof crmGetContact>>> = ({
    signal,
  }) => crmGetContact(email, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!email,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof crmGetContact>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CrmGetContactQueryResult = NonNullable<
  Awaited<ReturnType<typeof crmGetContact>>
>;
export type CrmGetContactQueryError = ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Get a single CRM contact with their unified timeline (operator only).
 */

export function useCrmGetContact<
  TData = Awaited<ReturnType<typeof crmGetContact>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  email: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmGetContact>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCrmGetContactQueryOptions(email, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update CRM contact enrichment fields and/or stage (operator only).
 */
export const getCrmPatchContactUrl = (email: string) => {
  return `/api/ops/crm/contacts/${email}`;
};

export const crmPatchContact = async (
  email: string,
  crmPatchContactBody: CrmPatchContactBody,
  options?: RequestInit,
): Promise<CrmContact> => {
  return customFetch<CrmContact>(getCrmPatchContactUrl(email), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(crmPatchContactBody),
  });
};

export const getCrmPatchContactMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmPatchContact>>,
    TError,
    { email: string; data: BodyType<CrmPatchContactBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmPatchContact>>,
  TError,
  { email: string; data: BodyType<CrmPatchContactBody> },
  TContext
> => {
  const mutationKey = ["crmPatchContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmPatchContact>>,
    { email: string; data: BodyType<CrmPatchContactBody> }
  > = (props) => {
    const { email, data } = props ?? {};

    return crmPatchContact(email, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmPatchContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmPatchContact>>
>;
export type CrmPatchContactMutationBody = BodyType<CrmPatchContactBody>;
export type CrmPatchContactMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Update CRM contact enrichment fields and/or stage (operator only).
 */
export const useCrmPatchContact = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmPatchContact>>,
    TError,
    { email: string; data: BodyType<CrmPatchContactBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmPatchContact>>,
  TError,
  { email: string; data: BodyType<CrmPatchContactBody> },
  TContext
> => {
  return useMutation(getCrmPatchContactMutationOptions(options));
};

/**
 * @summary Create a note on a CRM contact (operator only). Parses @mention tokens and fires notification emails.
 */
export const getCrmCreateNoteUrl = () => {
  return `/api/ops/crm/notes`;
};

export const crmCreateNote = async (
  crmCreateNoteBody: CrmCreateNoteBody,
  options?: RequestInit,
): Promise<CrmNote> => {
  return customFetch<CrmNote>(getCrmCreateNoteUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(crmCreateNoteBody),
  });
};

export const getCrmCreateNoteMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmCreateNote>>,
    TError,
    { data: BodyType<CrmCreateNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmCreateNote>>,
  TError,
  { data: BodyType<CrmCreateNoteBody> },
  TContext
> => {
  const mutationKey = ["crmCreateNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmCreateNote>>,
    { data: BodyType<CrmCreateNoteBody> }
  > = (props) => {
    const { data } = props ?? {};

    return crmCreateNote(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmCreateNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmCreateNote>>
>;
export type CrmCreateNoteMutationBody = BodyType<CrmCreateNoteBody>;
export type CrmCreateNoteMutationError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Create a note on a CRM contact (operator only). Parses @mention tokens and fires notification emails.
 */
export const useCrmCreateNote = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmCreateNote>>,
    TError,
    { data: BodyType<CrmCreateNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmCreateNote>>,
  TError,
  { data: BodyType<CrmCreateNoteBody> },
  TContext
> => {
  return useMutation(getCrmCreateNoteMutationOptions(options));
};

/**
 * @summary Send a trial invite email to a CRM contact (operator only).
 */
export const getCrmSendTrialInviteUrl = () => {
  return `/api/ops/crm/trial-invite`;
};

export const crmSendTrialInvite = async (
  crmTrialInviteBody: CrmTrialInviteBody,
  options?: RequestInit,
): Promise<CrmContact> => {
  return customFetch<CrmContact>(getCrmSendTrialInviteUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(crmTrialInviteBody),
  });
};

export const getCrmSendTrialInviteMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmSendTrialInvite>>,
    TError,
    { data: BodyType<CrmTrialInviteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmSendTrialInvite>>,
  TError,
  { data: BodyType<CrmTrialInviteBody> },
  TContext
> => {
  const mutationKey = ["crmSendTrialInvite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmSendTrialInvite>>,
    { data: BodyType<CrmTrialInviteBody> }
  > = (props) => {
    const { data } = props ?? {};

    return crmSendTrialInvite(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmSendTrialInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmSendTrialInvite>>
>;
export type CrmSendTrialInviteMutationBody = BodyType<CrmTrialInviteBody>;
export type CrmSendTrialInviteMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Send a trial invite email to a CRM contact (operator only).
 */
export const useCrmSendTrialInvite = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmSendTrialInvite>>,
    TError,
    { data: BodyType<CrmTrialInviteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmSendTrialInvite>>,
  TError,
  { data: BodyType<CrmTrialInviteBody> },
  TContext
> => {
  return useMutation(getCrmSendTrialInviteMutationOptions(options));
};

/**
 * @summary Send a one-off ad-hoc email to a single CRM contact (operator only).
 */
export const getCrmSendContactEmailUrl = (email: string) => {
  return `/api/ops/crm/contacts/${email}/send-email`;
};

export const crmSendContactEmail = async (
  email: string,
  crmSendContactEmailBody: CrmSendContactEmailBody,
  options?: RequestInit,
): Promise<CrmSendContactEmail200> => {
  return customFetch<CrmSendContactEmail200>(getCrmSendContactEmailUrl(email), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(crmSendContactEmailBody),
  });
};

export const getCrmSendContactEmailMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmSendContactEmail>>,
    TError,
    { email: string; data: BodyType<CrmSendContactEmailBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmSendContactEmail>>,
  TError,
  { email: string; data: BodyType<CrmSendContactEmailBody> },
  TContext
> => {
  const mutationKey = ["crmSendContactEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmSendContactEmail>>,
    { email: string; data: BodyType<CrmSendContactEmailBody> }
  > = (props) => {
    const { email, data } = props ?? {};

    return crmSendContactEmail(email, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmSendContactEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmSendContactEmail>>
>;
export type CrmSendContactEmailMutationBody = BodyType<CrmSendContactEmailBody>;
export type CrmSendContactEmailMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Send a one-off ad-hoc email to a single CRM contact (operator only).
 */
export const useCrmSendContactEmail = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmSendContactEmail>>,
    TError,
    { email: string; data: BodyType<CrmSendContactEmailBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmSendContactEmail>>,
  TError,
  { email: string; data: BodyType<CrmSendContactEmailBody> },
  TContext
> => {
  return useMutation(getCrmSendContactEmailMutationOptions(options));
};

/**
 * @summary List all CRM email campaigns (operator only).
 */
export const getCrmListCampaignsUrl = () => {
  return `/api/ops/crm/campaigns`;
};

export const crmListCampaigns = async (
  options?: RequestInit,
): Promise<CrmCampaign[]> => {
  return customFetch<CrmCampaign[]>(getCrmListCampaignsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getCrmListCampaignsQueryKey = () => {
  return [`/api/ops/crm/campaigns`] as const;
};

export const getCrmListCampaignsQueryOptions = <
  TData = Awaited<ReturnType<typeof crmListCampaigns>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof crmListCampaigns>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCrmListCampaignsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof crmListCampaigns>>
  > = ({ signal }) => crmListCampaigns({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof crmListCampaigns>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CrmListCampaignsQueryResult = NonNullable<
  Awaited<ReturnType<typeof crmListCampaigns>>
>;
export type CrmListCampaignsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List all CRM email campaigns (operator only).
 */

export function useCrmListCampaigns<
  TData = Awaited<ReturnType<typeof crmListCampaigns>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof crmListCampaigns>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCrmListCampaignsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new email campaign (operator only).
 */
export const getCrmCreateCampaignUrl = () => {
  return `/api/ops/crm/campaigns`;
};

export const crmCreateCampaign = async (
  crmCreateCampaignBody: CrmCreateCampaignBody,
  options?: RequestInit,
): Promise<CrmCampaign> => {
  return customFetch<CrmCampaign>(getCrmCreateCampaignUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(crmCreateCampaignBody),
  });
};

export const getCrmCreateCampaignMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmCreateCampaign>>,
    TError,
    { data: BodyType<CrmCreateCampaignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmCreateCampaign>>,
  TError,
  { data: BodyType<CrmCreateCampaignBody> },
  TContext
> => {
  const mutationKey = ["crmCreateCampaign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmCreateCampaign>>,
    { data: BodyType<CrmCreateCampaignBody> }
  > = (props) => {
    const { data } = props ?? {};

    return crmCreateCampaign(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmCreateCampaignMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmCreateCampaign>>
>;
export type CrmCreateCampaignMutationBody = BodyType<CrmCreateCampaignBody>;
export type CrmCreateCampaignMutationError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Create a new email campaign (operator only).
 */
export const useCrmCreateCampaign = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmCreateCampaign>>,
    TError,
    { data: BodyType<CrmCreateCampaignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmCreateCampaign>>,
  TError,
  { data: BodyType<CrmCreateCampaignBody> },
  TContext
> => {
  return useMutation(getCrmCreateCampaignMutationOptions(options));
};

/**
 * @summary Get a campaign with per-recipient send statuses (operator only).
 */
export const getCrmGetCampaignUrl = (id: string) => {
  return `/api/ops/crm/campaigns/${id}`;
};

export const crmGetCampaign = async (
  id: string,
  options?: RequestInit,
): Promise<CrmCampaignDetail> => {
  return customFetch<CrmCampaignDetail>(getCrmGetCampaignUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getCrmGetCampaignQueryKey = (id: string) => {
  return [`/api/ops/crm/campaigns/${id}`] as const;
};

export const getCrmGetCampaignQueryOptions = <
  TData = Awaited<ReturnType<typeof crmGetCampaign>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmGetCampaign>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCrmGetCampaignQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof crmGetCampaign>>> = ({
    signal,
  }) => crmGetCampaign(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof crmGetCampaign>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CrmGetCampaignQueryResult = NonNullable<
  Awaited<ReturnType<typeof crmGetCampaign>>
>;
export type CrmGetCampaignQueryError = ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Get a campaign with per-recipient send statuses (operator only).
 */

export function useCrmGetCampaign<
  TData = Awaited<ReturnType<typeof crmGetCampaign>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmGetCampaign>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCrmGetCampaignQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a draft campaign (operator only). Rejected if status is not draft.
 */
export const getCrmUpdateCampaignUrl = (id: string) => {
  return `/api/ops/crm/campaigns/${id}`;
};

export const crmUpdateCampaign = async (
  id: string,
  crmUpdateCampaignBody: CrmUpdateCampaignBody,
  options?: RequestInit,
): Promise<CrmCampaign> => {
  return customFetch<CrmCampaign>(getCrmUpdateCampaignUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(crmUpdateCampaignBody),
  });
};

export const getCrmUpdateCampaignMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmUpdateCampaign>>,
    TError,
    { id: string; data: BodyType<CrmUpdateCampaignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmUpdateCampaign>>,
  TError,
  { id: string; data: BodyType<CrmUpdateCampaignBody> },
  TContext
> => {
  const mutationKey = ["crmUpdateCampaign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmUpdateCampaign>>,
    { id: string; data: BodyType<CrmUpdateCampaignBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return crmUpdateCampaign(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmUpdateCampaignMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmUpdateCampaign>>
>;
export type CrmUpdateCampaignMutationBody = BodyType<CrmUpdateCampaignBody>;
export type CrmUpdateCampaignMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Update a draft campaign (operator only). Rejected if status is not draft.
 */
export const useCrmUpdateCampaign = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmUpdateCampaign>>,
    TError,
    { id: string; data: BodyType<CrmUpdateCampaignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmUpdateCampaign>>,
  TError,
  { id: string; data: BodyType<CrmUpdateCampaignBody> },
  TContext
> => {
  return useMutation(getCrmUpdateCampaignMutationOptions(options));
};

/**
 * @summary Send a test copy of a campaign to a given email address (operator only). Not logged as a real send.
 */
export const getCrmSendTestCampaignUrl = (id: string) => {
  return `/api/ops/crm/campaigns/${id}/send-test`;
};

export const crmSendTestCampaign = async (
  id: string,
  crmSendTestCampaignBody: CrmSendTestCampaignBody,
  options?: RequestInit,
): Promise<CrmSendTestCampaign200> => {
  return customFetch<CrmSendTestCampaign200>(getCrmSendTestCampaignUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(crmSendTestCampaignBody),
  });
};

export const getCrmSendTestCampaignMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmSendTestCampaign>>,
    TError,
    { id: string; data: BodyType<CrmSendTestCampaignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmSendTestCampaign>>,
  TError,
  { id: string; data: BodyType<CrmSendTestCampaignBody> },
  TContext
> => {
  const mutationKey = ["crmSendTestCampaign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmSendTestCampaign>>,
    { id: string; data: BodyType<CrmSendTestCampaignBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return crmSendTestCampaign(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmSendTestCampaignMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmSendTestCampaign>>
>;
export type CrmSendTestCampaignMutationBody = BodyType<CrmSendTestCampaignBody>;
export type CrmSendTestCampaignMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Send a test copy of a campaign to a given email address (operator only). Not logged as a real send.
 */
export const useCrmSendTestCampaign = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmSendTestCampaign>>,
    TError,
    { id: string; data: BodyType<CrmSendTestCampaignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmSendTestCampaign>>,
  TError,
  { id: string; data: BodyType<CrmSendTestCampaignBody> },
  TContext
> => {
  return useMutation(getCrmSendTestCampaignMutationOptions(options));
};

/**
 * @summary Send a draft campaign to its resolved segment (operator only).
 */
export const getCrmSendCampaignUrl = (id: string) => {
  return `/api/ops/crm/campaigns/${id}/send`;
};

export const crmSendCampaign = async (
  id: string,
  options?: RequestInit,
): Promise<CrmCampaign> => {
  return customFetch<CrmCampaign>(getCrmSendCampaignUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getCrmSendCampaignMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmSendCampaign>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmSendCampaign>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["crmSendCampaign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmSendCampaign>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return crmSendCampaign(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmSendCampaignMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmSendCampaign>>
>;

export type CrmSendCampaignMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Send a draft campaign to its resolved segment (operator only).
 */
export const useCrmSendCampaign = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmSendCampaign>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmSendCampaign>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getCrmSendCampaignMutationOptions(options));
};

/**
 * @summary Preview recipient count for a given segment definition (operator only).
 */
export const getCrmGetSegmentCountUrl = (params?: CrmGetSegmentCountParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ops/crm/segment-count?${stringifiedParams}`
    : `/api/ops/crm/segment-count`;
};

export const crmGetSegmentCount = async (
  params?: CrmGetSegmentCountParams,
  options?: RequestInit,
): Promise<CrmGetSegmentCount200> => {
  return customFetch<CrmGetSegmentCount200>(getCrmGetSegmentCountUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getCrmGetSegmentCountQueryKey = (
  params?: CrmGetSegmentCountParams,
) => {
  return [`/api/ops/crm/segment-count`, ...(params ? [params] : [])] as const;
};

export const getCrmGetSegmentCountQueryOptions = <
  TData = Awaited<ReturnType<typeof crmGetSegmentCount>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: CrmGetSegmentCountParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmGetSegmentCount>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCrmGetSegmentCountQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof crmGetSegmentCount>>
  > = ({ signal }) => crmGetSegmentCount(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof crmGetSegmentCount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CrmGetSegmentCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof crmGetSegmentCount>>
>;
export type CrmGetSegmentCountQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Preview recipient count for a given segment definition (operator only).
 */

export function useCrmGetSegmentCount<
  TData = Awaited<ReturnType<typeof crmGetSegmentCount>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: CrmGetSegmentCountParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmGetSegmentCount>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCrmGetSegmentCountQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Paginated list of contacts matching a segment definition (operator only).
 */
export const getCrmGetSegmentPreviewUrl = (
  params?: CrmGetSegmentPreviewParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ops/crm/segment-preview?${stringifiedParams}`
    : `/api/ops/crm/segment-preview`;
};

export const crmGetSegmentPreview = async (
  params?: CrmGetSegmentPreviewParams,
  options?: RequestInit,
): Promise<CrmGetSegmentPreview200> => {
  return customFetch<CrmGetSegmentPreview200>(
    getCrmGetSegmentPreviewUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getCrmGetSegmentPreviewQueryKey = (
  params?: CrmGetSegmentPreviewParams,
) => {
  return [`/api/ops/crm/segment-preview`, ...(params ? [params] : [])] as const;
};

export const getCrmGetSegmentPreviewQueryOptions = <
  TData = Awaited<ReturnType<typeof crmGetSegmentPreview>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: CrmGetSegmentPreviewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmGetSegmentPreview>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCrmGetSegmentPreviewQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof crmGetSegmentPreview>>
  > = ({ signal }) =>
    crmGetSegmentPreview(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof crmGetSegmentPreview>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CrmGetSegmentPreviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof crmGetSegmentPreview>>
>;
export type CrmGetSegmentPreviewQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Paginated list of contacts matching a segment definition (operator only).
 */

export function useCrmGetSegmentPreview<
  TData = Awaited<ReturnType<typeof crmGetSegmentPreview>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: CrmGetSegmentPreviewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmGetSegmentPreview>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCrmGetSegmentPreviewQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all email templates (operator only).
 */
export const getCrmListTemplatesUrl = (params?: CrmListTemplatesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ops/crm/templates?${stringifiedParams}`
    : `/api/ops/crm/templates`;
};

export const crmListTemplates = async (
  params?: CrmListTemplatesParams,
  options?: RequestInit,
): Promise<CrmEmailTemplate[]> => {
  return customFetch<CrmEmailTemplate[]>(getCrmListTemplatesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getCrmListTemplatesQueryKey = (
  params?: CrmListTemplatesParams,
) => {
  return [`/api/ops/crm/templates`, ...(params ? [params] : [])] as const;
};

export const getCrmListTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof crmListTemplates>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: CrmListTemplatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmListTemplates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCrmListTemplatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof crmListTemplates>>
  > = ({ signal }) => crmListTemplates(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof crmListTemplates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CrmListTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof crmListTemplates>>
>;
export type CrmListTemplatesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List all email templates (operator only).
 */

export function useCrmListTemplates<
  TData = Awaited<ReturnType<typeof crmListTemplates>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: CrmListTemplatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmListTemplates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCrmListTemplatesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new email template (operator only).
 */
export const getCrmCreateTemplateUrl = () => {
  return `/api/ops/crm/templates`;
};

export const crmCreateTemplate = async (
  crmCreateTemplateBody: CrmCreateTemplateBody,
  options?: RequestInit,
): Promise<CrmEmailTemplate> => {
  return customFetch<CrmEmailTemplate>(getCrmCreateTemplateUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(crmCreateTemplateBody),
  });
};

export const getCrmCreateTemplateMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmCreateTemplate>>,
    TError,
    { data: BodyType<CrmCreateTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmCreateTemplate>>,
  TError,
  { data: BodyType<CrmCreateTemplateBody> },
  TContext
> => {
  const mutationKey = ["crmCreateTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmCreateTemplate>>,
    { data: BodyType<CrmCreateTemplateBody> }
  > = (props) => {
    const { data } = props ?? {};

    return crmCreateTemplate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmCreateTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmCreateTemplate>>
>;
export type CrmCreateTemplateMutationBody = BodyType<CrmCreateTemplateBody>;
export type CrmCreateTemplateMutationError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Create a new email template (operator only).
 */
export const useCrmCreateTemplate = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmCreateTemplate>>,
    TError,
    { data: BodyType<CrmCreateTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmCreateTemplate>>,
  TError,
  { data: BodyType<CrmCreateTemplateBody> },
  TContext
> => {
  return useMutation(getCrmCreateTemplateMutationOptions(options));
};

/**
 * @summary Get a single email template (operator only).
 */
export const getCrmGetTemplateUrl = (id: string) => {
  return `/api/ops/crm/templates/${id}`;
};

export const crmGetTemplate = async (
  id: string,
  options?: RequestInit,
): Promise<CrmEmailTemplate> => {
  return customFetch<CrmEmailTemplate>(getCrmGetTemplateUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getCrmGetTemplateQueryKey = (id: string) => {
  return [`/api/ops/crm/templates/${id}`] as const;
};

export const getCrmGetTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof crmGetTemplate>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmGetTemplate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCrmGetTemplateQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof crmGetTemplate>>> = ({
    signal,
  }) => crmGetTemplate(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof crmGetTemplate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CrmGetTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof crmGetTemplate>>
>;
export type CrmGetTemplateQueryError = ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Get a single email template (operator only).
 */

export function useCrmGetTemplate<
  TData = Awaited<ReturnType<typeof crmGetTemplate>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmGetTemplate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCrmGetTemplateQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a non-built-in email template (operator only).
 */
export const getCrmUpdateTemplateUrl = (id: string) => {
  return `/api/ops/crm/templates/${id}`;
};

export const crmUpdateTemplate = async (
  id: string,
  crmUpdateTemplateBody: CrmUpdateTemplateBody,
  options?: RequestInit,
): Promise<CrmEmailTemplate> => {
  return customFetch<CrmEmailTemplate>(getCrmUpdateTemplateUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(crmUpdateTemplateBody),
  });
};

export const getCrmUpdateTemplateMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmUpdateTemplate>>,
    TError,
    { id: string; data: BodyType<CrmUpdateTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmUpdateTemplate>>,
  TError,
  { id: string; data: BodyType<CrmUpdateTemplateBody> },
  TContext
> => {
  const mutationKey = ["crmUpdateTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmUpdateTemplate>>,
    { id: string; data: BodyType<CrmUpdateTemplateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return crmUpdateTemplate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmUpdateTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmUpdateTemplate>>
>;
export type CrmUpdateTemplateMutationBody = BodyType<CrmUpdateTemplateBody>;
export type CrmUpdateTemplateMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Update a non-built-in email template (operator only).
 */
export const useCrmUpdateTemplate = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmUpdateTemplate>>,
    TError,
    { id: string; data: BodyType<CrmUpdateTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmUpdateTemplate>>,
  TError,
  { id: string; data: BodyType<CrmUpdateTemplateBody> },
  TContext
> => {
  return useMutation(getCrmUpdateTemplateMutationOptions(options));
};

/**
 * @summary Soft-archive an email template (operator only). Built-in templates cannot be archived.
 */
export const getCrmArchiveTemplateUrl = (id: string) => {
  return `/api/ops/crm/templates/${id}`;
};

export const crmArchiveTemplate = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getCrmArchiveTemplateUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getCrmArchiveTemplateMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmArchiveTemplate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmArchiveTemplate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["crmArchiveTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmArchiveTemplate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return crmArchiveTemplate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmArchiveTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmArchiveTemplate>>
>;

export type CrmArchiveTemplateMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Soft-archive an email template (operator only). Built-in templates cannot be archived.
 */
export const useCrmArchiveTemplate = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmArchiveTemplate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmArchiveTemplate>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getCrmArchiveTemplateMutationOptions(options));
};

/**
 * @summary Stream-generate a brand-aligned HTML email via Claude (operator only). Returns text/event-stream SSE.
 */
export const getCrmAiGenerateEmailUrl = () => {
  return `/api/ops/crm/ai/generate-email`;
};

export const crmAiGenerateEmail = async (
  crmAiGenerateEmailBody: CrmAiGenerateEmailBody,
  options?: RequestInit,
): Promise<string> => {
  return customFetch<string>(getCrmAiGenerateEmailUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(crmAiGenerateEmailBody),
  });
};

export const getCrmAiGenerateEmailMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmAiGenerateEmail>>,
    TError,
    { data: BodyType<CrmAiGenerateEmailBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmAiGenerateEmail>>,
  TError,
  { data: BodyType<CrmAiGenerateEmailBody> },
  TContext
> => {
  const mutationKey = ["crmAiGenerateEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmAiGenerateEmail>>,
    { data: BodyType<CrmAiGenerateEmailBody> }
  > = (props) => {
    const { data } = props ?? {};

    return crmAiGenerateEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmAiGenerateEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmAiGenerateEmail>>
>;
export type CrmAiGenerateEmailMutationBody = BodyType<CrmAiGenerateEmailBody>;
export type CrmAiGenerateEmailMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Stream-generate a brand-aligned HTML email via Claude (operator only). Returns text/event-stream SSE.
 */
export const useCrmAiGenerateEmail = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmAiGenerateEmail>>,
    TError,
    { data: BodyType<CrmAiGenerateEmailBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmAiGenerateEmail>>,
  TError,
  { data: BodyType<CrmAiGenerateEmailBody> },
  TContext
> => {
  return useMutation(getCrmAiGenerateEmailMutationOptions(options));
};

/**
 * @summary Twilio inbound SMS webhook — public, validates X-Twilio-Signature. Returns empty TwiML.
 */
export const getTwilioInboundSmsUrl = () => {
  return `/api/twilio/inbound-sms`;
};

export const twilioInboundSms = async (
  twilioInboundSmsBody: TwilioInboundSmsBody,
  options?: RequestInit,
): Promise<string> => {
  const formUrlEncoded = new URLSearchParams();
  if (twilioInboundSmsBody.From !== undefined) {
    formUrlEncoded.append(`From`, twilioInboundSmsBody.From);
  }
  if (twilioInboundSmsBody.To !== undefined) {
    formUrlEncoded.append(`To`, twilioInboundSmsBody.To);
  }
  if (twilioInboundSmsBody.Body !== undefined) {
    formUrlEncoded.append(`Body`, twilioInboundSmsBody.Body);
  }
  if (twilioInboundSmsBody.MessageSid !== undefined) {
    formUrlEncoded.append(`MessageSid`, twilioInboundSmsBody.MessageSid);
  }
  if (twilioInboundSmsBody.NumMedia !== undefined) {
    formUrlEncoded.append(`NumMedia`, twilioInboundSmsBody.NumMedia);
  }

  return customFetch<string>(getTwilioInboundSmsUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      ...options?.headers,
    },
    body: formUrlEncoded,
  });
};

export const getTwilioInboundSmsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof twilioInboundSms>>,
    TError,
    { data: BodyType<TwilioInboundSmsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof twilioInboundSms>>,
  TError,
  { data: BodyType<TwilioInboundSmsBody> },
  TContext
> => {
  const mutationKey = ["twilioInboundSms"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof twilioInboundSms>>,
    { data: BodyType<TwilioInboundSmsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return twilioInboundSms(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TwilioInboundSmsMutationResult = NonNullable<
  Awaited<ReturnType<typeof twilioInboundSms>>
>;
export type TwilioInboundSmsMutationBody = BodyType<TwilioInboundSmsBody>;
export type TwilioInboundSmsMutationError = ErrorType<void>;

/**
 * @summary Twilio inbound SMS webhook — public, validates X-Twilio-Signature. Returns empty TwiML.
 */
export const useTwilioInboundSms = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof twilioInboundSms>>,
    TError,
    { data: BodyType<TwilioInboundSmsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof twilioInboundSms>>,
  TError,
  { data: BodyType<TwilioInboundSmsBody> },
  TContext
> => {
  return useMutation(getTwilioInboundSmsMutationOptions(options));
};

/**
 * @summary List SMS threads — contacts who have sent/received SMS, sorted by most recent message.
 */
export const getCrmGetSmsInboxUrl = () => {
  return `/api/ops/crm/sms-inbox`;
};

export const crmGetSmsInbox = async (
  options?: RequestInit,
): Promise<SmsThread[]> => {
  return customFetch<SmsThread[]>(getCrmGetSmsInboxUrl(), {
    ...options,
    method: "GET",
  });
};

export const getCrmGetSmsInboxQueryKey = () => {
  return [`/api/ops/crm/sms-inbox`] as const;
};

export const getCrmGetSmsInboxQueryOptions = <
  TData = Awaited<ReturnType<typeof crmGetSmsInbox>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof crmGetSmsInbox>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCrmGetSmsInboxQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof crmGetSmsInbox>>> = ({
    signal,
  }) => crmGetSmsInbox({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof crmGetSmsInbox>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CrmGetSmsInboxQueryResult = NonNullable<
  Awaited<ReturnType<typeof crmGetSmsInbox>>
>;
export type CrmGetSmsInboxQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List SMS threads — contacts who have sent/received SMS, sorted by most recent message.
 */

export function useCrmGetSmsInbox<
  TData = Awaited<ReturnType<typeof crmGetSmsInbox>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof crmGetSmsInbox>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCrmGetSmsInboxQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Number of contacts with at least one unread inbound SMS.
 */
export const getCrmGetSmsUnreadCountUrl = () => {
  return `/api/ops/crm/sms-inbox/unread-count`;
};

export const crmGetSmsUnreadCount = async (
  options?: RequestInit,
): Promise<CrmGetSmsUnreadCount200> => {
  return customFetch<CrmGetSmsUnreadCount200>(getCrmGetSmsUnreadCountUrl(), {
    ...options,
    method: "GET",
  });
};

export const getCrmGetSmsUnreadCountQueryKey = () => {
  return [`/api/ops/crm/sms-inbox/unread-count`] as const;
};

export const getCrmGetSmsUnreadCountQueryOptions = <
  TData = Awaited<ReturnType<typeof crmGetSmsUnreadCount>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof crmGetSmsUnreadCount>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCrmGetSmsUnreadCountQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof crmGetSmsUnreadCount>>
  > = ({ signal }) => crmGetSmsUnreadCount({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof crmGetSmsUnreadCount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CrmGetSmsUnreadCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof crmGetSmsUnreadCount>>
>;
export type CrmGetSmsUnreadCountQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Number of contacts with at least one unread inbound SMS.
 */

export function useCrmGetSmsUnreadCount<
  TData = Awaited<ReturnType<typeof crmGetSmsUnreadCount>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof crmGetSmsUnreadCount>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCrmGetSmsUnreadCountQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Full SMS thread for a contact (all inbound + outbound messages).
 */
export const getCrmGetSmsThreadUrl = (email: string) => {
  return `/api/ops/crm/sms-inbox/${email}/messages`;
};

export const crmGetSmsThread = async (
  email: string,
  options?: RequestInit,
): Promise<SmsMessage[]> => {
  return customFetch<SmsMessage[]>(getCrmGetSmsThreadUrl(email), {
    ...options,
    method: "GET",
  });
};

export const getCrmGetSmsThreadQueryKey = (email: string) => {
  return [`/api/ops/crm/sms-inbox/${email}/messages`] as const;
};

export const getCrmGetSmsThreadQueryOptions = <
  TData = Awaited<ReturnType<typeof crmGetSmsThread>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  email: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmGetSmsThread>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCrmGetSmsThreadQueryKey(email);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof crmGetSmsThread>>> = ({
    signal,
  }) => crmGetSmsThread(email, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!email,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof crmGetSmsThread>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CrmGetSmsThreadQueryResult = NonNullable<
  Awaited<ReturnType<typeof crmGetSmsThread>>
>;
export type CrmGetSmsThreadQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Full SMS thread for a contact (all inbound + outbound messages).
 */

export function useCrmGetSmsThread<
  TData = Awaited<ReturnType<typeof crmGetSmsThread>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  email: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmGetSmsThread>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCrmGetSmsThreadQueryOptions(email, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mark all unread inbound SMS from this contact as read.
 */
export const getCrmMarkSmsThreadReadUrl = (email: string) => {
  return `/api/ops/crm/sms-inbox/${email}/read`;
};

export const crmMarkSmsThreadRead = async (
  email: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getCrmMarkSmsThreadReadUrl(email), {
    ...options,
    method: "POST",
  });
};

export const getCrmMarkSmsThreadReadMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmMarkSmsThreadRead>>,
    TError,
    { email: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmMarkSmsThreadRead>>,
  TError,
  { email: string },
  TContext
> => {
  const mutationKey = ["crmMarkSmsThreadRead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmMarkSmsThreadRead>>,
    { email: string }
  > = (props) => {
    const { email } = props ?? {};

    return crmMarkSmsThreadRead(email, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmMarkSmsThreadReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmMarkSmsThreadRead>>
>;

export type CrmMarkSmsThreadReadMutationError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Mark all unread inbound SMS from this contact as read.
 */
export const useCrmMarkSmsThreadRead = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmMarkSmsThreadRead>>,
    TError,
    { email: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmMarkSmsThreadRead>>,
  TError,
  { email: string },
  TContext
> => {
  return useMutation(getCrmMarkSmsThreadReadMutationOptions(options));
};

/**
 * @summary List all drip sequences (operator only).
 */
export const getCrmListSequencesUrl = () => {
  return `/api/ops/crm/sequences`;
};

export const crmListSequences = async (
  options?: RequestInit,
): Promise<CrmSequence[]> => {
  return customFetch<CrmSequence[]>(getCrmListSequencesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getCrmListSequencesQueryKey = () => {
  return [`/api/ops/crm/sequences`] as const;
};

export const getCrmListSequencesQueryOptions = <
  TData = Awaited<ReturnType<typeof crmListSequences>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof crmListSequences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCrmListSequencesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof crmListSequences>>
  > = ({ signal }) => crmListSequences({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof crmListSequences>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CrmListSequencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof crmListSequences>>
>;
export type CrmListSequencesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List all drip sequences (operator only).
 */

export function useCrmListSequences<
  TData = Awaited<ReturnType<typeof crmListSequences>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof crmListSequences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCrmListSequencesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new drip sequence (operator only).
 */
export const getCrmCreateSequenceUrl = () => {
  return `/api/ops/crm/sequences`;
};

export const crmCreateSequence = async (
  crmCreateSequenceBody: CrmCreateSequenceBody,
  options?: RequestInit,
): Promise<CrmSequence> => {
  return customFetch<CrmSequence>(getCrmCreateSequenceUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(crmCreateSequenceBody),
  });
};

export const getCrmCreateSequenceMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmCreateSequence>>,
    TError,
    { data: BodyType<CrmCreateSequenceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmCreateSequence>>,
  TError,
  { data: BodyType<CrmCreateSequenceBody> },
  TContext
> => {
  const mutationKey = ["crmCreateSequence"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmCreateSequence>>,
    { data: BodyType<CrmCreateSequenceBody> }
  > = (props) => {
    const { data } = props ?? {};

    return crmCreateSequence(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmCreateSequenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmCreateSequence>>
>;
export type CrmCreateSequenceMutationBody = BodyType<CrmCreateSequenceBody>;
export type CrmCreateSequenceMutationError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Create a new drip sequence (operator only).
 */
export const useCrmCreateSequence = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmCreateSequence>>,
    TError,
    { data: BodyType<CrmCreateSequenceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmCreateSequence>>,
  TError,
  { data: BodyType<CrmCreateSequenceBody> },
  TContext
> => {
  return useMutation(getCrmCreateSequenceMutationOptions(options));
};

/**
 * @summary Manually flush the sequence scheduler (send any due steps).
 */
export const getCrmFlushSequenceSchedulerUrl = () => {
  return `/api/ops/crm/sequences/scheduler/flush`;
};

export const crmFlushSequenceScheduler = async (
  options?: RequestInit,
): Promise<CrmFlushSequenceScheduler200> => {
  return customFetch<CrmFlushSequenceScheduler200>(
    getCrmFlushSequenceSchedulerUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getCrmFlushSequenceSchedulerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmFlushSequenceScheduler>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmFlushSequenceScheduler>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["crmFlushSequenceScheduler"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmFlushSequenceScheduler>>,
    void
  > = () => {
    return crmFlushSequenceScheduler(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmFlushSequenceSchedulerMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmFlushSequenceScheduler>>
>;

export type CrmFlushSequenceSchedulerMutationError = ErrorType<unknown>;

/**
 * @summary Manually flush the sequence scheduler (send any due steps).
 */
export const useCrmFlushSequenceScheduler = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmFlushSequenceScheduler>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmFlushSequenceScheduler>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCrmFlushSequenceSchedulerMutationOptions(options));
};

/**
 * @summary Get a single drip sequence with its steps (operator only).
 */
export const getCrmGetSequenceUrl = (id: string) => {
  return `/api/ops/crm/sequences/${id}`;
};

export const crmGetSequence = async (
  id: string,
  options?: RequestInit,
): Promise<CrmSequenceDetail> => {
  return customFetch<CrmSequenceDetail>(getCrmGetSequenceUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getCrmGetSequenceQueryKey = (id: string) => {
  return [`/api/ops/crm/sequences/${id}`] as const;
};

export const getCrmGetSequenceQueryOptions = <
  TData = Awaited<ReturnType<typeof crmGetSequence>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmGetSequence>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCrmGetSequenceQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof crmGetSequence>>> = ({
    signal,
  }) => crmGetSequence(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof crmGetSequence>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CrmGetSequenceQueryResult = NonNullable<
  Awaited<ReturnType<typeof crmGetSequence>>
>;
export type CrmGetSequenceQueryError = ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Get a single drip sequence with its steps (operator only).
 */

export function useCrmGetSequence<
  TData = Awaited<ReturnType<typeof crmGetSequence>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmGetSequence>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCrmGetSequenceQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a drip sequence including its steps (operator only). Steps are replaced atomically.
 */
export const getCrmUpdateSequenceUrl = (id: string) => {
  return `/api/ops/crm/sequences/${id}`;
};

export const crmUpdateSequence = async (
  id: string,
  crmUpdateSequenceBody: CrmUpdateSequenceBody,
  options?: RequestInit,
): Promise<CrmSequenceDetail> => {
  return customFetch<CrmSequenceDetail>(getCrmUpdateSequenceUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(crmUpdateSequenceBody),
  });
};

export const getCrmUpdateSequenceMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmUpdateSequence>>,
    TError,
    { id: string; data: BodyType<CrmUpdateSequenceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmUpdateSequence>>,
  TError,
  { id: string; data: BodyType<CrmUpdateSequenceBody> },
  TContext
> => {
  const mutationKey = ["crmUpdateSequence"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmUpdateSequence>>,
    { id: string; data: BodyType<CrmUpdateSequenceBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return crmUpdateSequence(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmUpdateSequenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmUpdateSequence>>
>;
export type CrmUpdateSequenceMutationBody = BodyType<CrmUpdateSequenceBody>;
export type CrmUpdateSequenceMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Update a drip sequence including its steps (operator only). Steps are replaced atomically.
 */
export const useCrmUpdateSequence = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmUpdateSequence>>,
    TError,
    { id: string; data: BodyType<CrmUpdateSequenceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmUpdateSequence>>,
  TError,
  { id: string; data: BodyType<CrmUpdateSequenceBody> },
  TContext
> => {
  return useMutation(getCrmUpdateSequenceMutationOptions(options));
};

/**
 * @summary Delete a drip sequence (operator only).
 */
export const getCrmDeleteSequenceUrl = (id: string) => {
  return `/api/ops/crm/sequences/${id}`;
};

export const crmDeleteSequence = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getCrmDeleteSequenceUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getCrmDeleteSequenceMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmDeleteSequence>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmDeleteSequence>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["crmDeleteSequence"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmDeleteSequence>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return crmDeleteSequence(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmDeleteSequenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmDeleteSequence>>
>;

export type CrmDeleteSequenceMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Delete a drip sequence (operator only).
 */
export const useCrmDeleteSequence = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmDeleteSequence>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmDeleteSequence>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getCrmDeleteSequenceMutationOptions(options));
};

/**
 * @summary Add a step to a sequence (operator only).
 */
export const getCrmAddSequenceStepUrl = (id: string) => {
  return `/api/ops/crm/sequences/${id}/steps`;
};

export const crmAddSequenceStep = async (
  id: string,
  crmCreateSequenceStepBody: CrmCreateSequenceStepBody,
  options?: RequestInit,
): Promise<CrmSequenceStep> => {
  return customFetch<CrmSequenceStep>(getCrmAddSequenceStepUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(crmCreateSequenceStepBody),
  });
};

export const getCrmAddSequenceStepMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmAddSequenceStep>>,
    TError,
    { id: string; data: BodyType<CrmCreateSequenceStepBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmAddSequenceStep>>,
  TError,
  { id: string; data: BodyType<CrmCreateSequenceStepBody> },
  TContext
> => {
  const mutationKey = ["crmAddSequenceStep"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmAddSequenceStep>>,
    { id: string; data: BodyType<CrmCreateSequenceStepBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return crmAddSequenceStep(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmAddSequenceStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmAddSequenceStep>>
>;
export type CrmAddSequenceStepMutationBody =
  BodyType<CrmCreateSequenceStepBody>;
export type CrmAddSequenceStepMutationError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Add a step to a sequence (operator only).
 */
export const useCrmAddSequenceStep = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmAddSequenceStep>>,
    TError,
    { id: string; data: BodyType<CrmCreateSequenceStepBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmAddSequenceStep>>,
  TError,
  { id: string; data: BodyType<CrmCreateSequenceStepBody> },
  TContext
> => {
  return useMutation(getCrmAddSequenceStepMutationOptions(options));
};

/**
 * @summary Update a sequence step (operator only).
 */
export const getCrmUpdateSequenceStepUrl = (id: string, stepId: string) => {
  return `/api/ops/crm/sequences/${id}/steps/${stepId}`;
};

export const crmUpdateSequenceStep = async (
  id: string,
  stepId: string,
  crmCreateSequenceStepBody: CrmCreateSequenceStepBody,
  options?: RequestInit,
): Promise<CrmSequenceStep> => {
  return customFetch<CrmSequenceStep>(getCrmUpdateSequenceStepUrl(id, stepId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(crmCreateSequenceStepBody),
  });
};

export const getCrmUpdateSequenceStepMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmUpdateSequenceStep>>,
    TError,
    { id: string; stepId: string; data: BodyType<CrmCreateSequenceStepBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmUpdateSequenceStep>>,
  TError,
  { id: string; stepId: string; data: BodyType<CrmCreateSequenceStepBody> },
  TContext
> => {
  const mutationKey = ["crmUpdateSequenceStep"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmUpdateSequenceStep>>,
    { id: string; stepId: string; data: BodyType<CrmCreateSequenceStepBody> }
  > = (props) => {
    const { id, stepId, data } = props ?? {};

    return crmUpdateSequenceStep(id, stepId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmUpdateSequenceStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmUpdateSequenceStep>>
>;
export type CrmUpdateSequenceStepMutationBody =
  BodyType<CrmCreateSequenceStepBody>;
export type CrmUpdateSequenceStepMutationError =
  ErrorType<UnauthorizedResponse>;

/**
 * @summary Update a sequence step (operator only).
 */
export const useCrmUpdateSequenceStep = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmUpdateSequenceStep>>,
    TError,
    { id: string; stepId: string; data: BodyType<CrmCreateSequenceStepBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmUpdateSequenceStep>>,
  TError,
  { id: string; stepId: string; data: BodyType<CrmCreateSequenceStepBody> },
  TContext
> => {
  return useMutation(getCrmUpdateSequenceStepMutationOptions(options));
};

/**
 * @summary Remove a step from a sequence (operator only).
 */
export const getCrmDeleteSequenceStepUrl = (id: string, stepId: string) => {
  return `/api/ops/crm/sequences/${id}/steps/${stepId}`;
};

export const crmDeleteSequenceStep = async (
  id: string,
  stepId: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getCrmDeleteSequenceStepUrl(id, stepId), {
    ...options,
    method: "DELETE",
  });
};

export const getCrmDeleteSequenceStepMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmDeleteSequenceStep>>,
    TError,
    { id: string; stepId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmDeleteSequenceStep>>,
  TError,
  { id: string; stepId: string },
  TContext
> => {
  const mutationKey = ["crmDeleteSequenceStep"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmDeleteSequenceStep>>,
    { id: string; stepId: string }
  > = (props) => {
    const { id, stepId } = props ?? {};

    return crmDeleteSequenceStep(id, stepId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmDeleteSequenceStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmDeleteSequenceStep>>
>;

export type CrmDeleteSequenceStepMutationError =
  ErrorType<UnauthorizedResponse>;

/**
 * @summary Remove a step from a sequence (operator only).
 */
export const useCrmDeleteSequenceStep = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmDeleteSequenceStep>>,
    TError,
    { id: string; stepId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmDeleteSequenceStep>>,
  TError,
  { id: string; stepId: string },
  TContext
> => {
  return useMutation(getCrmDeleteSequenceStepMutationOptions(options));
};

/**
 * @summary List all enrollments for a sequence (operator only).
 */
export const getCrmListSequenceEnrollmentsUrl = (id: string) => {
  return `/api/ops/crm/sequences/${id}/enrollments`;
};

export const crmListSequenceEnrollments = async (
  id: string,
  options?: RequestInit,
): Promise<CrmSequenceEnrollment[]> => {
  return customFetch<CrmSequenceEnrollment[]>(
    getCrmListSequenceEnrollmentsUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getCrmListSequenceEnrollmentsQueryKey = (id: string) => {
  return [`/api/ops/crm/sequences/${id}/enrollments`] as const;
};

export const getCrmListSequenceEnrollmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof crmListSequenceEnrollments>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmListSequenceEnrollments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCrmListSequenceEnrollmentsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof crmListSequenceEnrollments>>
  > = ({ signal }) =>
    crmListSequenceEnrollments(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof crmListSequenceEnrollments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CrmListSequenceEnrollmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof crmListSequenceEnrollments>>
>;
export type CrmListSequenceEnrollmentsQueryError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary List all enrollments for a sequence (operator only).
 */

export function useCrmListSequenceEnrollments<
  TData = Awaited<ReturnType<typeof crmListSequenceEnrollments>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmListSequenceEnrollments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCrmListSequenceEnrollmentsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Manually enroll a contact in a sequence (operator only). Idempotent.
 */
export const getCrmEnrollContactUrl = (id: string) => {
  return `/api/ops/crm/sequences/${id}/enroll`;
};

export const crmEnrollContact = async (
  id: string,
  crmEnrollContactBody: CrmEnrollContactBody,
  options?: RequestInit,
): Promise<CrmSequenceEnrollment> => {
  return customFetch<CrmSequenceEnrollment>(getCrmEnrollContactUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(crmEnrollContactBody),
  });
};

export const getCrmEnrollContactMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmEnrollContact>>,
    TError,
    { id: string; data: BodyType<CrmEnrollContactBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmEnrollContact>>,
  TError,
  { id: string; data: BodyType<CrmEnrollContactBody> },
  TContext
> => {
  const mutationKey = ["crmEnrollContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmEnrollContact>>,
    { id: string; data: BodyType<CrmEnrollContactBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return crmEnrollContact(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmEnrollContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmEnrollContact>>
>;
export type CrmEnrollContactMutationBody = BodyType<CrmEnrollContactBody>;
export type CrmEnrollContactMutationError =
  ErrorType<void | UnauthorizedResponse>;

/**
 * @summary Manually enroll a contact in a sequence (operator only). Idempotent.
 */
export const useCrmEnrollContact = <
  TError = ErrorType<void | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmEnrollContact>>,
    TError,
    { id: string; data: BodyType<CrmEnrollContactBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmEnrollContact>>,
  TError,
  { id: string; data: BodyType<CrmEnrollContactBody> },
  TContext
> => {
  return useMutation(getCrmEnrollContactMutationOptions(options));
};

/**
 * @summary Unenroll a contact from a sequence and cancel pending sends (operator only).
 */
export const getCrmUnenrollContactUrl = (id: string, contactEmail: string) => {
  return `/api/ops/crm/sequences/${id}/enrollments/${contactEmail}`;
};

export const crmUnenrollContact = async (
  id: string,
  contactEmail: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getCrmUnenrollContactUrl(id, contactEmail), {
    ...options,
    method: "DELETE",
  });
};

export const getCrmUnenrollContactMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmUnenrollContact>>,
    TError,
    { id: string; contactEmail: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmUnenrollContact>>,
  TError,
  { id: string; contactEmail: string },
  TContext
> => {
  const mutationKey = ["crmUnenrollContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmUnenrollContact>>,
    { id: string; contactEmail: string }
  > = (props) => {
    const { id, contactEmail } = props ?? {};

    return crmUnenrollContact(id, contactEmail, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmUnenrollContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmUnenrollContact>>
>;

export type CrmUnenrollContactMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Unenroll a contact from a sequence and cancel pending sends (operator only).
 */
export const useCrmUnenrollContact = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmUnenrollContact>>,
    TError,
    { id: string; contactEmail: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmUnenrollContact>>,
  TError,
  { id: string; contactEmail: string },
  TContext
> => {
  return useMutation(getCrmUnenrollContactMutationOptions(options));
};

/**
 * @summary Cancel an enrollment (operator only).
 */
export const getCrmCancelEnrollmentUrl = (id: string, enrollmentId: string) => {
  return `/api/ops/crm/sequences/${id}/enrollments/${enrollmentId}/cancel`;
};

export const crmCancelEnrollment = async (
  id: string,
  enrollmentId: string,
  options?: RequestInit,
): Promise<CrmSequenceEnrollment> => {
  return customFetch<CrmSequenceEnrollment>(
    getCrmCancelEnrollmentUrl(id, enrollmentId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getCrmCancelEnrollmentMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmCancelEnrollment>>,
    TError,
    { id: string; enrollmentId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof crmCancelEnrollment>>,
  TError,
  { id: string; enrollmentId: string },
  TContext
> => {
  const mutationKey = ["crmCancelEnrollment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crmCancelEnrollment>>,
    { id: string; enrollmentId: string }
  > = (props) => {
    const { id, enrollmentId } = props ?? {};

    return crmCancelEnrollment(id, enrollmentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CrmCancelEnrollmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof crmCancelEnrollment>>
>;

export type CrmCancelEnrollmentMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Cancel an enrollment (operator only).
 */
export const useCrmCancelEnrollment = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crmCancelEnrollment>>,
    TError,
    { id: string; enrollmentId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof crmCancelEnrollment>>,
  TError,
  { id: string; enrollmentId: string },
  TContext
> => {
  return useMutation(getCrmCancelEnrollmentMutationOptions(options));
};

/**
 * @summary Get all sequence enrollments for a contact (operator only).
 */
export const getCrmGetContactEnrollmentsUrl = (email: string) => {
  return `/api/ops/crm/contacts/${email}/enrollments`;
};

export const crmGetContactEnrollments = async (
  email: string,
  options?: RequestInit,
): Promise<CrmContactEnrollmentRow[]> => {
  return customFetch<CrmContactEnrollmentRow[]>(
    getCrmGetContactEnrollmentsUrl(email),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getCrmGetContactEnrollmentsQueryKey = (email: string) => {
  return [`/api/ops/crm/contacts/${email}/enrollments`] as const;
};

export const getCrmGetContactEnrollmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof crmGetContactEnrollments>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  email: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmGetContactEnrollments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCrmGetContactEnrollmentsQueryKey(email);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof crmGetContactEnrollments>>
  > = ({ signal }) =>
    crmGetContactEnrollments(email, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!email,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof crmGetContactEnrollments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CrmGetContactEnrollmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof crmGetContactEnrollments>>
>;
export type CrmGetContactEnrollmentsQueryError =
  ErrorType<UnauthorizedResponse>;

/**
 * @summary Get all sequence enrollments for a contact (operator only).
 */

export function useCrmGetContactEnrollments<
  TData = Awaited<ReturnType<typeof crmGetContactEnrollments>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  email: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmGetContactEnrollments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCrmGetContactEnrollmentsQueryOptions(email, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary One-click unsubscribe — validates token and sets the contact as unsubscribed. Public endpoint.
 */
export const getCrmUnsubscribeUrl = (params: CrmUnsubscribeParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/crm/unsubscribe?${stringifiedParams}`
    : `/api/crm/unsubscribe`;
};

export const crmUnsubscribe = async (
  params: CrmUnsubscribeParams,
  options?: RequestInit,
): Promise<string> => {
  return customFetch<string>(getCrmUnsubscribeUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getCrmUnsubscribeQueryKey = (params?: CrmUnsubscribeParams) => {
  return [`/api/crm/unsubscribe`, ...(params ? [params] : [])] as const;
};

export const getCrmUnsubscribeQueryOptions = <
  TData = Awaited<ReturnType<typeof crmUnsubscribe>>,
  TError = ErrorType<void>,
>(
  params: CrmUnsubscribeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmUnsubscribe>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCrmUnsubscribeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof crmUnsubscribe>>> = ({
    signal,
  }) => crmUnsubscribe(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof crmUnsubscribe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CrmUnsubscribeQueryResult = NonNullable<
  Awaited<ReturnType<typeof crmUnsubscribe>>
>;
export type CrmUnsubscribeQueryError = ErrorType<void>;

/**
 * @summary One-click unsubscribe — validates token and sets the contact as unsubscribed. Public endpoint.
 */

export function useCrmUnsubscribe<
  TData = Awaited<ReturnType<typeof crmUnsubscribe>>,
  TError = ErrorType<void>,
>(
  params: CrmUnsubscribeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof crmUnsubscribe>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCrmUnsubscribeQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all Instagram post schedules (operator only).
 */
export const getListSocialPostSchedulesUrl = () => {
  return `/api/ops/social/schedules`;
};

export const listSocialPostSchedules = async (
  options?: RequestInit,
): Promise<SocialPostSchedule[]> => {
  return customFetch<SocialPostSchedule[]>(getListSocialPostSchedulesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListSocialPostSchedulesQueryKey = () => {
  return [`/api/ops/social/schedules`] as const;
};

export const getListSocialPostSchedulesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSocialPostSchedules>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSocialPostSchedules>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSocialPostSchedulesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSocialPostSchedules>>
  > = ({ signal }) => listSocialPostSchedules({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSocialPostSchedules>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSocialPostSchedulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSocialPostSchedules>>
>;
export type ListSocialPostSchedulesQueryError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary List all Instagram post schedules (operator only).
 */

export function useListSocialPostSchedules<
  TData = Awaited<ReturnType<typeof listSocialPostSchedules>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSocialPostSchedules>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSocialPostSchedulesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Delete a social post schedule entry (operator only).
 */
export const getDeleteSocialPostScheduleUrl = (id: string) => {
  return `/api/ops/social/schedules/${id}`;
};

export const deleteSocialPostSchedule = async (
  id: string,
  options?: RequestInit,
): Promise<DeleteSocialPostSchedule200> => {
  return customFetch<DeleteSocialPostSchedule200>(
    getDeleteSocialPostScheduleUrl(id),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteSocialPostScheduleMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSocialPostSchedule>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSocialPostSchedule>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteSocialPostSchedule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSocialPostSchedule>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSocialPostSchedule(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSocialPostScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSocialPostSchedule>>
>;

export type DeleteSocialPostScheduleMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Delete a social post schedule entry (operator only).
 */
export const useDeleteSocialPostSchedule = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSocialPostSchedule>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSocialPostSchedule>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteSocialPostScheduleMutationOptions(options));
};

/**
 * @summary Schedule an Instagram post via the Meta Graph API (operator only).
 */
export const getScheduleSocialPostUrl = () => {
  return `/api/ops/social/schedule`;
};

export const scheduleSocialPost = async (
  scheduleSocialPostBody: ScheduleSocialPostBody,
  options?: RequestInit,
): Promise<SocialPostSchedule> => {
  return customFetch<SocialPostSchedule>(getScheduleSocialPostUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(scheduleSocialPostBody),
  });
};

export const getScheduleSocialPostMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduleSocialPost>>,
    TError,
    { data: BodyType<ScheduleSocialPostBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scheduleSocialPost>>,
  TError,
  { data: BodyType<ScheduleSocialPostBody> },
  TContext
> => {
  const mutationKey = ["scheduleSocialPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scheduleSocialPost>>,
    { data: BodyType<ScheduleSocialPostBody> }
  > = (props) => {
    const { data } = props ?? {};

    return scheduleSocialPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScheduleSocialPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof scheduleSocialPost>>
>;
export type ScheduleSocialPostMutationBody = BodyType<ScheduleSocialPostBody>;
export type ScheduleSocialPostMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Schedule an Instagram post via the Meta Graph API (operator only).
 */
export const useScheduleSocialPost = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduleSocialPost>>,
    TError,
    { data: BodyType<ScheduleSocialPostBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof scheduleSocialPost>>,
  TError,
  { data: BodyType<ScheduleSocialPostBody> },
  TContext
> => {
  return useMutation(getScheduleSocialPostMutationOptions(options));
};
